var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _g, _path10, _g2, _path11, _path12, _g3, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g4, _path20, _g5, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _g6, _path31, _g7, _path32, _g8, _path33, _path34, _path35, _g9, _path36, _g0, _path37, _path38, _path39, _path40, _g1, _path41, _path42, _g10, _g11, _path43, _path44, _g12, _path45, _g13, _g14, _g15, _g16, _g17, _g18, _path46, _g19, _path47, _path48, _g20, _path49, _path50, _g21, _path51, _g22, _g23, _g24, _g25, _g26, _g27, _path52, _g28, _path53, _path54, _path55, _path56, _path57, _path58, _g29, _path59, _path60, _path61, _g30, _g31, _path62, _path63, _g32, _path64, _g33, _g34, _g35, _g36, _g37, _g38, _path65, _g39, _path66, _path67, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPenguinErrorDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 690,
    height: 287,
    viewBox: "0 0 690 287",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_90771_36502)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M620.302 171.041V4.39062H576.742L447.262 179.031V217.391H570.352V282.931H620.312V217.391H664.672V171.031H620.312L620.302 171.041ZM498.262 171.041L570.342 69.8806V171.041H498.262Z",
    fill: "#555556"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M419.851 67.14C416.391 54.62 411.061 43.29 403.871 33.17C396.681 23.05 387.221 15.05 375.491 9.19C364.031 3.06 349.651 0 332.331 0C315.011 0 300.091 3.06 288.371 9.19C276.911 15.32 267.591 23.44 260.391 33.57C253.201 43.69 247.741 55.02 244.001 67.54C240.541 80.06 238.141 92.85 236.811 105.9C235.741 118.69 235.211 130.81 235.211 142.27C235.211 153.73 235.881 166.51 237.211 179.84C238.541 193.16 240.941 206.08 244.401 218.6C248.131 231.12 253.591 242.58 260.791 252.97C267.981 263.09 277.441 271.22 289.161 277.35C300.881 283.48 315.401 286.54 332.721 286.54C350.041 286.54 364.021 283.61 375.481 277.75C386.941 271.62 396.261 263.5 403.451 253.37C410.641 243.25 416.111 231.92 419.841 219.4C423.571 206.88 426.101 193.96 427.431 180.63C428.761 167.31 429.431 154.52 429.431 142.26C429.431 130 428.761 118.28 427.431 105.49C426.101 92.43 423.571 79.65 419.841 67.12L419.851 67.14ZM375.091 191.43C372.691 205.82 368.161 217.41 361.501 226.2C354.841 234.73 345.251 238.99 332.731 238.99C322.871 238.99 314.881 236.46 308.751 231.4C302.621 226.07 297.961 219.01 294.761 210.22C291.561 201.43 289.301 191.3 287.971 179.85C286.901 168.39 286.371 156.4 286.371 143.88C286.371 131.36 286.901 118.57 287.971 107.11C289.301 95.39 291.431 85.13 294.361 76.34C297.561 67.55 302.221 60.62 308.351 55.56C314.481 50.5 322.471 47.97 332.331 47.97C344.851 47.97 354.441 52.23 361.101 60.76C367.761 69.29 372.291 80.88 374.691 95.53C377.351 109.92 378.691 126.04 378.691 143.89C378.691 161.74 377.491 177.06 375.091 191.45V191.43Z",
    fill: "#555556"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M173.04 4.39062H129.48L0 179.041V217.401H123.09V282.941H173.05V217.401H217.41V171.041H173.05V4.39062H173.04ZM51.01 171.041L123.09 69.8806V171.041H51.01Z",
    fill: "#555556"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M645.302 171.041V4.39062H601.742L472.262 179.031V217.391H595.352V282.931H645.312V217.391H689.672V171.031H645.312L645.302 171.041ZM523.262 171.041L595.342 69.8806V171.041H523.262Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M357.729 286.54C340.409 286.54 325.889 283.48 314.169 277.35C302.449 271.22 292.989 263.1 285.799 252.97C278.609 242.58 273.139 231.12 269.409 218.6C265.949 206.08 263.549 193.16 262.219 179.84C260.889 166.52 260.219 154 260.219 142.27C260.219 130.54 260.749 118.69 261.819 105.9C263.149 92.85 265.549 80.06 269.009 67.54C272.739 55.02 278.199 43.69 285.399 33.57C292.589 23.45 301.919 15.32 313.379 9.19C325.099 3.06 339.759 0 357.339 0C374.919 0 389.039 3.06 400.499 9.19C412.219 15.05 421.679 23.04 428.879 33.17C436.069 43.29 441.399 54.62 444.859 67.14C448.589 79.66 451.119 92.45 452.449 105.51C453.779 118.3 454.449 130.55 454.449 142.28C454.449 154.01 453.779 167.32 452.449 180.65C451.119 193.98 448.589 206.89 444.859 219.41C441.129 231.93 435.669 243.26 428.469 253.38C421.279 263.5 411.949 271.63 400.499 277.76C389.039 283.62 374.789 286.55 357.739 286.55L357.729 286.54ZM357.729 238.98C370.249 238.98 379.839 234.72 386.499 226.19C393.159 217.4 397.689 205.81 400.089 191.42C402.489 177.03 403.689 161.18 403.689 143.86C403.689 126.54 402.359 109.89 399.689 95.5C397.289 80.85 392.759 69.26 386.099 60.73C379.439 52.2 369.849 47.94 357.329 47.94C347.469 47.94 339.479 50.47 333.349 55.53C327.219 60.59 322.559 67.52 319.359 76.31C316.429 85.1 314.299 95.36 312.969 107.08C311.899 118.54 311.369 130.79 311.369 143.85C311.369 156.91 311.899 168.36 312.969 179.82C314.299 191.28 316.569 201.4 319.759 210.19C322.959 218.98 327.619 226.04 333.749 231.37C339.879 236.43 347.869 238.96 357.729 238.96V238.98Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M198.04 171.041V4.39062H154.48L25 179.041V217.401H148.09V282.941H198.05V217.401H242.41V171.041H198.05H198.04ZM76.01 171.041L148.09 69.8806V171.041H76.01Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M402.561 182C401.621 193 399.931 210.05 396.781 232.44C398.341 231.62 400.711 230.17 403.001 227.77C406.101 224.52 408.771 219.81 411.001 204.88C412.051 197.85 412.731 193.33 412.781 186.44C412.931 166.12 407.181 146.88 403.611 136.25C403.791 141.81 403.611 149.34 403.391 158.11C403.181 166.06 403.311 173.13 402.561 182Z",
    fill: "url(#paint0_radial_90771_36502)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M423.499 172.238C423.169 172.878 422.949 173.318 422.739 173.688C421.709 175.588 419.149 180.378 415.379 185.138C411.509 190.008 407.269 193.738 403.719 196.398C404.909 199.678 406.339 204.698 406.589 210.948C406.809 216.438 406.999 220.938 404.609 225.898C402.119 231.078 397.669 235.018 394.289 238.008C393.279 238.898 392.299 239.708 391.759 240.128C385.429 244.998 376.859 244.198 363.919 244.668C355.609 244.968 339.769 245.998 332.509 242.788C330.549 241.918 329.039 240.668 328.979 240.608C325.739 237.898 324.599 234.388 323.989 232.528C322.239 227.218 321.009 216.018 321.539 201.458C316.069 192.848 306.209 176.548 304.849 168.918C304.549 167.228 301.139 146.788 308.399 143.238C310.139 142.378 312.619 142.448 314.479 143.338C318.119 145.078 319.139 149.838 319.609 151.748C320.899 156.918 324.009 164.258 332.019 173.718C325.529 158.268 328.369 140.878 339.169 129.698C347.909 120.648 362.689 114.828 376.439 119.488C388.719 123.658 394.369 134.148 395.839 136.978C405.089 154.818 396.069 173.048 394.999 175.118C403.489 168.788 408.909 162.478 412.319 157.798C418.239 149.678 421.199 142.258 425.799 142.558C428.419 142.728 430.579 145.348 431.479 147.368C433.659 152.268 430.269 158.928 423.479 172.238H423.499Z",
    fill: "#584EA0"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M424.479 172.24C424.099 172.98 423.769 173.6 423.719 173.69C422.689 175.59 420.129 180.38 416.359 185.14C412.489 190.01 408.249 193.74 404.699 196.4C405.889 199.68 407.319 204.7 407.569 210.95C407.789 216.44 407.979 220.94 405.589 225.9C403.099 231.08 398.649 235.02 395.269 238.01C394.259 238.9 393.279 239.71 392.739 240.13C386.409 245 377.839 244.2 364.899 244.67C356.589 244.97 340.749 246 333.489 242.79C331.529 241.92 330.019 240.67 329.959 240.61C326.719 237.9 325.579 234.39 324.969 232.53C323.219 227.22 321.989 216.02 322.519 201.46C317.049 192.85 307.189 176.55 305.829 168.92C304.259 160.12 303.969 145.49 309.379 143.24C310.529 142.76 312.629 142.55 314.479 143.34C315.939 143.96 317.099 145.13 319.069 148.69C320.749 151.72 321.579 153.24 322.459 156.01C323.609 159.66 326.289 165.25 333.009 173.72C326.939 158.19 329.639 141.02 340.159 129.7C348.369 120.87 363.199 113.62 377.409 118.43C389.849 122.65 395.329 133.92 396.829 136.99C405.499 154.82 397.249 172.54 395.989 175.13C404.449 168.88 409.859 162.6 413.309 157.81C418.829 150.16 422.129 142.47 426.679 142.9C429.249 143.14 430.889 145.85 431.159 146.29C434.699 152.12 429.819 161.72 424.469 172.25L424.479 172.24Z",
    fill: "#19124C"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M427.931 172.238C427.691 172.718 427.451 173.188 427.171 173.688C426.141 175.588 423.581 180.378 419.811 185.138C415.941 190.008 411.701 193.738 408.151 196.398C409.341 199.678 410.771 204.698 411.021 210.948C411.241 216.438 411.431 220.938 409.041 225.898C406.551 231.078 402.101 235.018 398.721 238.008C397.711 238.898 396.731 239.708 396.191 240.128C389.861 244.998 381.291 244.198 368.351 244.668C360.041 244.968 344.201 245.998 336.941 242.788C334.981 241.918 333.471 240.668 333.411 240.608C330.171 237.898 329.031 234.388 328.421 232.528C326.671 227.218 325.441 216.018 325.971 201.458C320.501 192.848 310.641 176.548 309.281 168.918C308.141 162.538 306.491 144.598 312.831 143.238C317.641 142.208 319.461 151.258 324.461 159.198C328.091 164.968 333.161 170.428 336.451 173.718C329.961 158.268 332.801 140.878 343.601 129.698C352.341 120.648 367.121 114.828 380.871 119.488C393.151 123.658 398.801 134.148 400.271 136.978C409.521 154.818 400.501 173.048 399.431 175.118C407.901 168.678 413.341 162.378 416.751 157.798C422.101 150.608 425.551 143.498 428.951 144.198C430.781 144.578 431.681 147.018 432.381 148.978C435.301 157.228 431.101 165.898 427.921 172.248L427.931 172.238Z",
    fill: "#4F3F99"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_90771_36502",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 379,
    y: 144,
    width: 55,
    height: 101
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M398.722 238.009C402.092 235.029 406.552 231.089 409.042 225.899C411.422 220.939 411.242 216.439 411.022 210.949C410.772 204.699 409.342 199.679 408.152 196.399C411.702 193.729 415.942 190.009 419.812 185.139C423.582 180.389 426.142 175.599 427.172 173.689C427.442 173.189 427.692 172.709 427.932 172.239C431.112 165.889 435.312 157.219 432.392 148.969C431.702 147.019 430.792 144.569 428.962 144.189C428.202 144.029 427.432 144.269 426.642 144.819C427.232 146.779 427.042 149.169 427.152 151.099C427.482 157.449 425.312 163.459 421.642 169.139C416.802 176.489 411.952 182.499 404.772 187.679C401.932 189.849 398.922 192.689 395.252 192.689C395.582 193.689 396.592 194.029 396.752 194.689C398.252 201.869 396.752 208.549 394.752 215.229C391.062 226.879 388.672 236.059 379.832 244.459C386.342 243.519 390.942 243.569 396.192 240.109C396.622 239.829 397.572 239.009 398.722 237.989V238.009Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_90771_36502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.601 144.039L376.191 216.749V144.039H395.601Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.911 144.039L376.191 217.899V216.749L395.601 144.039H395.911Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.221 144.039L376.191 219.049V217.899L395.911 144.039H396.221Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.531 144.039L376.191 220.209V219.049L396.221 144.039H396.531Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.841 144.039L376.191 221.359V220.209L396.531 144.039H396.841Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.151 144.039L376.191 222.519V221.359L396.841 144.039H397.151Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.451 144.039L376.191 223.669V222.519L397.151 144.039H397.451Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.761 144.039L376.191 224.829V223.669L397.451 144.039H397.761Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.071 144.039L376.191 225.979V224.829L397.761 144.039H398.071Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.381 144.039L376.191 227.139V225.979L398.071 144.039H398.381Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.691 144.039L376.191 228.289V227.139L398.381 144.039H398.691Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.991 144.039L376.191 229.439V228.289L398.691 144.039H398.991Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.301 144.039L376.191 230.599V229.439L398.991 144.039H399.301Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.611 144.039L376.191 231.749V230.599L399.301 144.039H399.611Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.921 144.039L376.191 232.909V231.749L399.611 144.039H399.921Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.231 144.039L376.191 234.059V232.909L399.921 144.039H400.231Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.541 144.039L376.191 235.219V234.059L400.231 144.039H400.541Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.841 144.039L376.191 236.369V235.219L400.541 144.039H400.841Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.151 144.039L376.191 237.529V236.369L400.841 144.039H401.151Z",
    fill: "#504099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.461 144.039L376.191 238.679V237.529L401.151 144.039H401.461Z",
    fill: "#504099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.771 144.039L376.191 239.829V238.679L401.461 144.039H401.771Z",
    fill: "#504099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.081 144.039L376.191 240.989V239.829L401.771 144.039H402.081Z",
    fill: "#504099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.391 144.039L376.191 242.139V240.989L402.081 144.039H402.391Z",
    fill: "#504099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.691 144.039L376.191 243.299V242.139L402.391 144.039H402.691Z",
    fill: "#50409A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.001 144.039L376.191 244.449V243.299L402.691 144.039H403.001Z",
    fill: "#50409A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.311 144.039L376.191 245.609V244.449L403.001 144.039H403.311Z",
    fill: "#50409A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.621 144.039L376.321 246.289H376.191V245.609L403.311 144.039H403.621Z",
    fill: "#50409A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.93 144.039L376.63 246.289H376.32L403.62 144.039H403.93Z",
    fill: "#50419A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.233 144.039L376.943 246.289H376.633L403.933 144.039H404.233Z",
    fill: "#51419A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.541 144.039L377.241 246.289H376.941L404.231 144.039H404.541Z",
    fill: "#51419A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.852 144.039L377.552 246.289H377.242L404.542 144.039H404.852Z",
    fill: "#51419A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.161 144.039L377.861 246.289H377.551L404.851 144.039H405.161Z",
    fill: "#51419A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.473 144.039L378.173 246.289H377.863L405.163 144.039H405.473Z",
    fill: "#51419A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.782 144.039L378.482 246.289H378.172L405.472 144.039H405.782Z",
    fill: "#51429A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.08 144.039L378.78 246.289H378.48L405.78 144.039H406.08Z",
    fill: "#52429A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.391 144.039L379.091 246.289H378.781L406.081 144.039H406.391Z",
    fill: "#52429B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.7 144.039L379.4 246.289H379.09L406.39 144.039H406.7Z",
    fill: "#52429B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.012 144.039L379.712 246.289H379.402L406.702 144.039H407.012Z",
    fill: "#52429B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.321 144.039L380.021 246.289H379.711L407.011 144.039H407.321Z",
    fill: "#52439B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.63 144.039L380.33 246.289H380.02L407.32 144.039H407.63Z",
    fill: "#53439B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.932 144.039L380.632 246.289H380.332L407.632 144.039H407.932Z",
    fill: "#53439B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.243 144.039L380.943 246.289H380.633L407.933 144.039H408.243Z",
    fill: "#53439B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.551 144.039L381.251 246.289H380.941L408.241 144.039H408.551Z",
    fill: "#53449B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.86 144.039L381.56 246.289H381.25L408.55 144.039H408.86Z",
    fill: "#53449C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.173 144.039L381.872 246.289H381.562L408.862 144.039H409.173Z",
    fill: "#54449C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.471 144.039L382.181 246.289H381.871L409.171 144.039H409.471Z",
    fill: "#54449C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.78 144.039L382.48 246.289H382.18L409.47 144.039H409.78Z",
    fill: "#54459C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.09 144.039L382.79 246.289H382.48L409.78 144.039H410.09Z",
    fill: "#55459C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.403 144.039L383.103 246.289H382.793L410.093 144.039H410.403Z",
    fill: "#55459C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.712 144.039L383.412 246.289H383.102L410.402 144.039H410.712Z",
    fill: "#55469D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.02 144.039L383.72 246.289H383.41L410.71 144.039H411.02Z",
    fill: "#56469D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.323 144.039L384.023 246.289H383.723L411.023 144.039H411.323Z",
    fill: "#56469D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.63 144.039L384.33 246.289H384.02L411.32 144.039H411.63Z",
    fill: "#56479D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.942 144.039L384.642 246.289H384.332L411.632 144.039H411.942Z",
    fill: "#57479D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.251 144.039L384.951 246.289H384.641L411.941 144.039H412.251Z",
    fill: "#57489E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.563 144.039L385.263 246.289H384.953L412.253 144.039H412.563Z",
    fill: "#57489E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.872 144.039L385.572 246.289H385.262L412.562 144.039H412.872Z",
    fill: "#58489E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.17 144.039L385.87 246.289H385.57L412.87 144.039H413.17Z",
    fill: "#58499E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.481 144.039L386.181 246.289H385.871L413.171 144.039H413.481Z",
    fill: "#58499E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.79 144.039L386.49 246.289H386.18L413.48 144.039H413.79Z",
    fill: "#594A9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.102 144.039L386.802 246.289H386.492L413.792 144.039H414.102Z",
    fill: "#594A9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.411 144.039L387.111 246.289H386.801L414.101 144.039H414.411Z",
    fill: "#5A4B9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.713 144.039L387.423 246.289H387.113L414.413 144.039H414.713Z",
    fill: "#5A4B9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.022 144.039L387.722 246.289H387.422L414.712 144.039H415.022Z",
    fill: "#5B4CA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.333 144.039L388.033 246.289H387.723L415.023 144.039H415.333Z",
    fill: "#5B4CA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.641 144.039L388.341 246.289H388.031L415.331 144.039H415.641Z",
    fill: "#5B4DA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.95 144.039L388.65 246.289H388.34L415.64 144.039H415.95Z",
    fill: "#5C4DA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.262 144.039L388.962 246.289H388.652L415.952 144.039H416.262Z",
    fill: "#5C4EA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.561 144.039L389.261 246.289H388.961L416.261 144.039H416.561Z",
    fill: "#5D4EA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.872 144.039L389.572 246.289H389.262L416.562 144.039H416.872Z",
    fill: "#5D4FA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.18 144.039L389.88 246.289H389.57L416.87 144.039H417.18Z",
    fill: "#5E4FA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.493 144.039L390.193 246.289H389.883L417.183 144.039H417.493Z",
    fill: "#5E50A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.801 144.039L390.501 246.289H390.191L417.491 144.039H417.801Z",
    fill: "#5F50A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.11 144.039L390.81 246.289H390.5L417.8 144.039H418.11Z",
    fill: "#6051A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.413 144.039L391.112 246.289H390.812L418.112 144.039H418.413Z",
    fill: "#6052A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.723 144.039L391.423 246.289H391.113L418.413 144.039H418.723Z",
    fill: "#6152A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.032 144.039L391.732 246.289H391.422L418.722 144.039H419.032Z",
    fill: "#6153A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.34 144.039L392.04 246.289H391.73L419.03 144.039H419.34Z",
    fill: "#6254A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.653 144.039L392.353 246.289H392.043L419.343 144.039H419.653Z",
    fill: "#6254A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.952 144.039L392.662 246.289H392.352L419.652 144.039H419.952Z",
    fill: "#6355A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.26 144.039L392.96 246.289H392.66L419.95 144.039H420.26Z",
    fill: "#6456A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.571 144.039L393.271 246.289H392.961L420.261 144.039H420.571Z",
    fill: "#6456A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.88 144.039L393.58 246.289H393.27L420.57 144.039H420.88Z",
    fill: "#6557A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.192 144.039L393.892 246.289H393.582L420.882 144.039H421.192Z",
    fill: "#6658A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.501 144.039L394.201 246.289H393.891L421.191 144.039H421.501Z",
    fill: "#6659A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.803 144.039L394.503 246.289H394.203L421.503 144.039H421.803Z",
    fill: "#6759A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.11 144.039L394.81 246.289H394.5L421.8 144.039H422.11Z",
    fill: "#685AA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.423 144.039L395.122 246.289H394.812L422.112 144.039H422.423Z",
    fill: "#685BA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.731 144.039L395.431 246.289H395.121L422.421 144.039H422.731Z",
    fill: "#695CA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.04 144.039L395.74 246.289H395.43L422.73 144.039H423.04Z",
    fill: "#6A5CA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.352 144.039L396.052 246.289H395.742L423.042 144.039H423.352Z",
    fill: "#6B5DA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.651 144.039L396.351 246.289H396.051L423.351 144.039H423.651Z",
    fill: "#6B5EA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.962 144.039L396.662 246.289H396.352L423.652 144.039H423.962Z",
    fill: "#6C5FAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.27 144.039L396.97 246.289H396.66L423.96 144.039H424.27Z",
    fill: "#6D60AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.583 144.039L397.283 246.289H396.973L424.273 144.039H424.583Z",
    fill: "#6E61AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.891 144.039L397.591 246.289H397.281L424.581 144.039H424.891Z",
    fill: "#6F61AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.19 144.039L397.89 246.289H397.59L424.89 144.039H425.19Z",
    fill: "#6F62AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.501 144.039L398.201 246.289H397.891L425.191 144.039H425.501Z",
    fill: "#7063AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.813 144.039L398.513 246.289H398.203L425.503 144.039H425.813Z",
    fill: "#7164AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.122 144.039L398.822 246.289H398.512L425.812 144.039H426.122Z",
    fill: "#7265AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.43 144.039L399.13 246.289H398.82L426.12 144.039H426.43Z",
    fill: "#7366AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.743 144.039L399.443 246.289H399.133L426.433 144.039H426.743Z",
    fill: "#7467AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.041 144.039L399.741 246.289H399.441L426.741 144.039H427.041Z",
    fill: "#7568AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.352 144.039L400.052 246.289H399.742L427.042 144.039H427.352Z",
    fill: "#7669AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.661 144.039L400.361 246.289H400.051L427.351 144.039H427.661Z",
    fill: "#766AB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.973 144.039L400.673 246.289H400.363L427.663 144.039H427.973Z",
    fill: "#776BB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.282 144.039L400.982 246.289H400.672L427.972 144.039H428.282Z",
    fill: "#786CB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.59 144.039L401.29 246.289H400.98L428.28 144.039H428.59Z",
    fill: "#796DB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.893 144.039L401.593 246.289H401.293L428.593 144.039H428.893Z",
    fill: "#7A6EB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.2 144.039L401.9 246.289H401.59L428.89 144.039H429.2Z",
    fill: "#7B6FB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.512 144.039L402.212 246.289H401.902L429.202 144.039H429.512Z",
    fill: "#7C70B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.821 144.039L402.521 246.289H402.211L429.511 144.039H429.821Z",
    fill: "#7D71B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.13 144.039L402.83 246.289H402.52L429.82 144.039H430.13Z",
    fill: "#7E73B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.432 144.039L403.132 246.289H402.832L430.132 144.039H430.432Z",
    fill: "#7F74B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.743 144.039L403.443 246.289H403.133L430.433 144.039H430.743Z",
    fill: "#8075B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.051 144.039L403.751 246.289H403.441L430.741 144.039H431.051Z",
    fill: "#8176B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.36 144.039L404.06 246.289H403.75L431.05 144.039H431.36Z",
    fill: "#8377B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.673 144.039L404.372 246.289H404.062L431.362 144.039H431.673Z",
    fill: "#8478B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.981 144.039L404.681 246.289H404.371L431.671 144.039H431.981Z",
    fill: "#857AB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.28 144.039L404.98 246.289H404.68L431.98 144.039H432.28Z",
    fill: "#867BB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.59 144.039L405.29 246.289H404.98L432.28 144.039H432.59Z",
    fill: "#877CB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.603 144.039L432.883 144.119L405.603 246.289H405.293L432.593 144.039H432.603Z",
    fill: "#887DBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.882 144.117L433.172 144.187L405.912 246.287H405.602L432.882 144.117Z",
    fill: "#897FBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.17 144.188L433.46 144.268L406.22 246.287H405.91L433.17 144.188Z",
    fill: "#8A80BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.463 144.27L433.743 144.35L406.533 246.29H406.223L433.463 144.27Z",
    fill: "#8C81BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.741 144.348L434.031 144.418L406.831 246.288H406.531L433.741 144.348Z",
    fill: "#8D82BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.032 144.418L434.322 144.498L407.142 246.288H406.832L434.032 144.418Z",
    fill: "#8E84BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.321 144.5L434.611 144.58L407.451 246.29H407.141L434.321 144.5Z",
    fill: "#8F85BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.613 144.578L434.893 144.658L407.763 246.288H407.453L434.613 144.578Z",
    fill: "#9186BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.892 144.66L435.182 144.73L408.072 246.29H407.762L434.892 144.66Z",
    fill: "#9288C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.18 144.73L435.31 144.76V145.42L408.37 246.29H408.07L435.18 144.73Z",
    fill: "#9389C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.311 146.578L408.681 246.288H408.371L435.311 145.418V146.578Z",
    fill: "#948BC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.31 147.728L408.99 246.288H408.68L435.31 146.578V147.728Z",
    fill: "#968CC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.312 148.89L409.302 246.29H408.992L435.312 147.73V148.89Z",
    fill: "#978DC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.311 150.041L409.611 246.291H409.301L435.311 148.891V150.041Z",
    fill: "#988FC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.313 151.199L409.923 246.289H409.613L435.313 150.039V151.199Z",
    fill: "#9A90C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.312 152.349L410.222 246.289H409.922L435.312 151.199V152.349Z",
    fill: "#9B92C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.313 153.508L410.533 246.288H410.223L435.313 152.348V153.508Z",
    fill: "#9C93C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.311 154.658L410.841 246.288H410.531L435.311 153.508V154.658Z",
    fill: "#9E95C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.31 155.81L411.15 246.29H410.84L435.31 154.66V155.81Z",
    fill: "#9F96C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.312 156.969L411.462 246.289H411.152L435.312 155.809V156.969Z",
    fill: "#A198C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.311 158.119L411.771 246.289H411.461L435.311 156.969V158.119Z",
    fill: "#A299C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.31 159.277L412.07 246.287H411.77L435.31 158.117V159.277Z",
    fill: "#A39BCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.31 160.427L412.38 246.287H412.07L435.31 159.277V160.427Z",
    fill: "#A59DCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.313 161.59L412.693 246.29H412.383L435.313 160.43V161.59Z",
    fill: "#A69ECC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.311 162.74L413.001 246.29H412.691L435.311 161.59V162.74Z",
    fill: "#A8A0CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.31 163.898L413.31 246.288H413L435.31 162.738V163.898Z",
    fill: "#A9A2CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.312 165.048L413.612 246.288H413.312L435.312 163.898V165.048Z",
    fill: "#ABA3CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.313 166.201L413.923 246.291H413.613L435.313 165.051V166.201Z",
    fill: "#ACA5CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.312 167.359L414.232 246.289H413.922L435.312 166.199V167.359Z",
    fill: "#AEA7D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.31 168.509L414.54 246.289H414.23L435.31 167.359V168.509Z",
    fill: "#AFA8D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.313 169.668L414.853 246.288H414.543L435.313 168.508V169.668Z",
    fill: "#B1AAD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.312 170.818L415.162 246.288H414.852L435.312 169.668V170.818Z",
    fill: "#B3ACD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.31 171.98L415.46 246.29H415.16L435.31 170.82V171.98Z",
    fill: "#B4ADD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.311 173.13L415.771 246.29H415.461L435.311 171.98V173.13Z",
    fill: "#B6AFD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.31 174.289L416.08 246.289H415.77L435.31 173.129V174.289Z",
    fill: "#B7B1D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.312 175.439L416.392 246.289H416.082L435.312 174.289V175.439Z",
    fill: "#B9B3D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.311 176.587L416.701 246.287H416.391L435.311 175.438V176.587Z",
    fill: "#BBB5D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.313 177.75L417.013 246.29H416.703L435.313 176.59V177.75Z",
    fill: "#BCB6D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.312 178.9L417.312 246.29H417.012L435.312 177.75V178.9Z",
    fill: "#BEB8D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.312 180.058L417.622 246.288H417.312L435.312 178.898V180.058Z",
    fill: "#C0BADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.311 181.209L417.931 246.289H417.621L435.311 180.059V181.209Z",
    fill: "#C2BCDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.31 182.371L418.24 246.291H417.93L435.31 181.211V182.371Z",
    fill: "#C3BEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.312 183.517L418.552 246.287H418.242L435.312 182.367V183.517Z",
    fill: "#C5C0DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.311 184.68L418.851 246.29H418.551L435.311 183.52V184.68Z",
    fill: "#C7C2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.312 185.83L419.162 246.29H418.852L435.312 184.68V185.83Z",
    fill: "#C9C4E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.31 186.978L419.47 246.288H419.16L435.31 185.828V186.978Z",
    fill: "#CAC6E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.313 188.14L419.783 246.29H419.473L435.313 186.98V188.14Z",
    fill: "#CCC8E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.311 189.291L420.091 246.291H419.781L435.311 188.141V189.291Z",
    fill: "#CECAE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.31 190.449L420.4 246.289H420.09L435.31 189.289V190.449Z",
    fill: "#D0CCE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.312 191.599L420.702 246.289H420.402L435.312 190.449V191.599Z",
    fill: "#D2CEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.313 192.758L421.013 246.288H420.703L435.313 191.598V192.758Z",
    fill: "#D4D0E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.312 193.908L421.322 246.288H421.012L435.312 192.758V193.908Z",
    fill: "#D6D2E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.31 195.07L421.63 246.29H421.32L435.31 193.91V195.07Z",
    fill: "#D8D4E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.313 196.22L421.943 246.29H421.633L435.313 195.07V196.22Z",
    fill: "#D9D6E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.311 197.369L422.251 246.289H421.941L435.311 196.219V197.369Z",
    fill: "#DBD8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.31 198.527L422.55 246.287H422.25L435.31 197.367V198.527Z",
    fill: "#DDDAEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.311 199.677L422.861 246.287H422.551L435.311 198.527V199.677Z",
    fill: "#DFDCED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.313 200.84L423.173 246.29H422.863L435.313 199.68V200.84Z",
    fill: "#E1DFEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.312 201.99L423.482 246.29H423.172L435.312 200.84V201.99Z",
    fill: "#E3E1EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.31 203.148L423.79 246.288H423.48L435.31 201.988V203.148Z",
    fill: "#E5E3F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.313 204.298L424.093 246.288H423.793L435.313 203.148V204.298Z",
    fill: "#E7E5F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.31 205.461L424.4 246.291H424.09L435.31 204.301V205.461Z",
    fill: "#EAE8F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.312 206.611L424.712 246.291H424.402L435.312 205.461V206.611Z",
    fill: "#ECEAF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.311 207.759L425.021 246.289H424.711L435.311 206.609V207.759Z",
    fill: "#EEECF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.31 208.918L425.33 246.288H425.02L435.31 207.758V208.918Z",
    fill: "#F0EEF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.312 210.068L425.642 246.288H425.332L435.312 208.918V210.068Z",
    fill: "#F2F1F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.311 211.23L425.941 246.29H425.641L435.311 210.07V211.23Z",
    fill: "#F4F3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.311 212.38L426.251 246.29H425.941L435.311 211.23V212.38Z",
    fill: "#F6F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.31 213.539L426.56 246.289H426.25L435.31 212.379V213.539Z",
    fill: "#F8F8FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.312 214.689L426.872 246.289H426.562L435.312 213.539V214.689Z",
    fill: "#FBFAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.311 215.848L427.181 246.287H426.871L435.311 214.688V215.848Z",
    fill: "#FDFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.31 216.998L427.49 246.288H427.18L435.31 215.848V216.998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.492 246.29L435.312 217V246.29H427.492Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_90771_36502",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 308,
    y: 117,
    width: 96,
    height: 128
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M403.552 147.038C401.292 134.168 392.622 123.588 380.882 119.488C360.782 112.468 344.402 128.878 343.612 129.698C332.812 140.878 329.972 158.258 336.462 173.718C333.172 170.428 328.102 164.968 324.472 159.198C319.472 151.258 317.652 142.208 312.842 143.238C306.502 144.598 308.162 162.538 309.292 168.918C310.652 176.548 320.512 192.848 325.982 201.458C325.442 216.018 326.682 227.218 328.432 232.528C329.042 234.388 330.182 237.898 333.422 240.608C333.422 240.608 334.932 241.878 336.952 242.788C344.282 246.078 361.442 244.468 362.942 244.328C362.062 229.658 361.842 191.098 388.182 161.078C393.122 155.448 398.372 150.838 403.552 147.048V147.038Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_90771_36502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.504 165L342.644 246.07H306.504V165Z",
    fill: "#1C1548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.504 161.891L344.034 246.071H342.644L306.504 165.001V161.891Z",
    fill: "#1C1548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.504 158.77L345.424 246.07H344.034L306.504 161.89V158.77Z",
    fill: "#1D164A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.504 155.66L346.814 246.07H345.424L306.504 158.77V155.66Z",
    fill: "#1F174C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.504 152.539L348.204 246.069H346.814L306.504 155.659V152.539Z",
    fill: "#20184E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.504 149.43L349.594 246.07H348.204L306.504 152.54V149.43Z",
    fill: "#211950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.504 146.309L350.984 246.069H349.594L306.504 149.429V146.309Z",
    fill: "#231A52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.504 143.188L352.374 246.068H350.984L306.504 146.307V143.188Z",
    fill: "#241B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.504 140.078L353.764 246.068H352.374L306.504 143.188V140.078Z",
    fill: "#251C56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.504 136.957L355.154 246.067H353.764L306.504 140.077V136.957Z",
    fill: "#261D58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.504 135.599L307.154 135.309L356.544 246.069H355.154L306.504 136.959V135.599Z",
    fill: "#271E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.152 135.309L308.312 134.789L357.932 246.069H356.542L307.152 135.309Z",
    fill: "#291F5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.312 134.79L309.473 134.27L359.312 246.07H357.932L308.312 134.79Z",
    fill: "#2A205E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.473 134.268L310.633 133.758L360.703 246.068H359.313L309.473 134.268Z",
    fill: "#2B2160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.633 133.758L311.783 133.238L361.983 245.818L361.433 246.068H360.703L310.633 133.758Z",
    fill: "#2C2261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.949 132.729L311.789 133.246L361.986 245.833L363.146 245.315L312.949 132.729Z",
    fill: "#2D2363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.105 132.209L312.945 132.727L363.143 245.313L364.303 244.796L314.105 132.209Z",
    fill: "#2E2465"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.265 131.694L314.105 132.211L364.303 244.797L365.463 244.28L315.265 131.694Z",
    fill: "#2F2567"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.426 131.174L315.266 131.691L365.463 244.278L366.623 243.761L316.426 131.174Z",
    fill: "#302668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.586 130.663L316.426 131.18L366.623 243.766L367.783 243.249L317.586 130.663Z",
    fill: "#31276A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.742 130.143L317.582 130.66L367.779 243.247L368.939 242.729L318.742 130.143Z",
    fill: "#32276B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.902 129.635L318.742 130.152L368.94 242.739L370.099 242.222L319.902 129.635Z",
    fill: "#33286D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.062 129.108L319.902 129.625L370.1 242.211L371.26 241.694L321.062 129.108Z",
    fill: "#34296F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.219 128.592L321.059 129.109L371.256 241.696L372.416 241.179L322.219 128.592Z",
    fill: "#352A70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.383 128.084L322.223 128.602L372.42 241.188L373.58 240.671L323.383 128.084Z",
    fill: "#362B72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.539 127.557L323.379 128.074L373.576 240.661L374.736 240.144L324.539 127.557Z",
    fill: "#372B73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.695 127.038L324.535 127.555L374.733 240.141L375.892 239.624L325.695 127.038Z",
    fill: "#382C74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.847 126.534L325.688 127.051L375.885 239.637L377.045 239.12L326.847 126.534Z",
    fill: "#392D76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.008 126.018L326.848 126.535L377.045 239.122L378.205 238.604L328.008 126.018Z",
    fill: "#3A2D77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.164 125.491L328.004 126.008L378.201 238.594L379.361 238.077L329.164 125.491Z",
    fill: "#3B2E79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.328 124.983L329.168 125.5L379.365 238.086L380.525 237.569L330.328 124.983Z",
    fill: "#3B2F7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.496 124.463L330.336 124.98L380.533 237.567L381.693 237.05L331.496 124.463Z",
    fill: "#3C307B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.652 123.936L331.492 124.453L381.69 237.04L382.849 236.522L332.652 123.936Z",
    fill: "#3D307C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.812 123.428L332.652 123.945L382.85 236.532L384.01 236.015L333.812 123.428Z",
    fill: "#3E317E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.972 122.913L333.812 123.43L384.01 236.016L385.17 235.499L334.972 122.913Z",
    fill: "#3F317F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.129 122.393L334.969 122.91L385.166 235.497L386.326 234.979L336.129 122.393Z",
    fill: "#3F3280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.281 121.881L336.121 122.398L386.318 234.985L387.478 234.468L337.281 121.881Z",
    fill: "#403381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.441 121.362L337.281 121.879L387.479 234.465L388.639 233.948L338.441 121.362Z",
    fill: "#413382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.597 120.846L338.438 121.363L388.635 233.95L389.795 233.433L339.597 120.846Z",
    fill: "#413483"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.758 120.327L339.598 120.844L389.795 233.43L390.955 232.913L340.758 120.327Z",
    fill: "#423484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.918 119.811L340.758 120.328L390.955 232.915L392.115 232.397L341.918 119.811Z",
    fill: "#433585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.074 119.291L341.914 119.809L392.111 232.395L393.271 231.878L343.074 119.291Z",
    fill: "#433586"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.246 118.784L343.086 119.301L393.283 231.887L394.443 231.37L344.246 118.784Z",
    fill: "#443687"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.402 118.256L344.242 118.773L394.44 231.36L395.599 230.843L345.402 118.256Z",
    fill: "#453688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.562 117.741L345.402 118.258L395.6 230.844L396.76 230.327L346.562 117.741Z",
    fill: "#453789"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.715 117.237L346.555 117.754L396.752 230.34L397.912 229.823L347.715 117.237Z",
    fill: "#46378A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.871 116.709L347.711 117.227L397.908 229.813L399.068 229.296L348.871 116.709Z",
    fill: "#46388B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.031 116.19L348.871 116.707L399.068 229.294L400.228 228.776L350.031 116.19Z",
    fill: "#47388C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.191 115.682L350.031 116.199L400.229 228.786L401.389 228.269L351.191 115.682Z",
    fill: "#47398D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.347 115.166L351.188 115.684L401.385 228.27L402.545 227.753L352.347 115.166Z",
    fill: "#48398D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.344 115.151L353.504 114.641L403.554 226.881V227.291L402.544 227.741L352.344 115.151Z",
    fill: "#48398E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.504 114.637L354.664 114.117L403.554 223.757V226.877L353.504 114.637Z",
    fill: "#493A8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.664 114.118L355.824 113.598L403.554 220.638V223.758L354.664 114.118Z",
    fill: "#493A90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.824 113.6L356.984 113.09L403.554 217.53V220.64L355.824 113.6Z",
    fill: "#4A3A90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.984 113.09L358.144 112.57L403.554 214.41V217.53L356.984 113.09Z",
    fill: "#4A3B91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.145 112.569L358.365 112.469H359.485L403.555 211.299V214.409L358.145 112.569Z",
    fill: "#4A3B92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.874 112.469L403.554 208.179V211.299L359.484 112.469H360.874Z",
    fill: "#4B3B92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.265 112.469L403.555 205.069V208.179L360.875 112.469H362.265Z",
    fill: "#4B3C93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.656 112.469L403.556 201.949V205.069L362.266 112.469H363.656Z",
    fill: "#4B3C93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.042 112.469L403.552 198.829V201.949L363.652 112.469H365.042Z",
    fill: "#4C3C94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.433 112.469L403.553 195.719V198.829L365.043 112.469H366.433Z",
    fill: "#4C3D94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.824 112.469L403.554 192.599V195.719L366.434 112.469H367.824Z",
    fill: "#4C3D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.214 112.469L403.554 189.489V192.599L367.824 112.469H369.214Z",
    fill: "#4D3D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.605 112.469L403.555 186.369V189.489L369.215 112.469H370.605Z",
    fill: "#4D3D96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.995 112.469L403.555 183.249V186.369L370.605 112.469H371.995Z",
    fill: "#4D3D96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.382 112.469L403.552 180.139V183.249L371.992 112.469H373.382Z",
    fill: "#4D3E96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.773 112.469L403.553 177.019V180.139L373.383 112.469H374.773Z",
    fill: "#4E3E97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.153 112.469L403.553 173.909V177.019L374.773 112.469H376.153Z",
    fill: "#4E3E97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.542 112.469L403.552 170.789V173.909L376.152 112.469H377.542Z",
    fill: "#4E3E97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.933 112.469L403.553 167.679V170.789L377.543 112.469H378.933Z",
    fill: "#4E3E98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.324 112.469L403.554 164.559V167.679L378.934 112.469H380.324Z",
    fill: "#4E3E98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.714 112.469L403.554 161.439V164.559L380.324 112.469H381.714Z",
    fill: "#4E3E98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.105 112.469L403.555 158.329V161.439L381.715 112.469H383.105Z",
    fill: "#4F3F98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.495 112.469L403.555 155.209V158.329L383.105 112.469H384.495Z",
    fill: "#4F3F98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.882 112.469L403.552 152.099V155.209L384.492 112.469H385.882Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.273 112.469L403.553 148.979V152.099L385.883 112.469H387.273Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.663 112.469L403.553 145.869V148.979L387.273 112.469H388.663Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.054 112.469L403.554 142.749V145.869L388.664 112.469H390.054Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.445 112.469L403.555 139.629V142.749L390.055 112.469H391.445Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.835 112.469L403.555 136.519V139.629L391.445 112.469H392.835Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.222 112.469L403.552 133.399V136.519L392.832 112.469H394.222Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.603 112.469L403.553 130.289V133.399L394.223 112.469H395.603Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.555 130.289L395.605 112.469H403.555V130.289Z",
    fill: "#4F3F99"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M375.132 144.648C372.082 140.098 366.262 136.508 360.172 137.008C350.082 137.838 345.762 149.378 345.112 151.128C344.662 152.338 341.442 161.378 346.332 170.468C348.732 174.928 352.082 177.538 353.982 178.798C348.072 193.158 344.512 206.798 345.432 221.638C345.792 227.498 345.032 233.428 349.162 237.598C354.882 243.388 364.072 243.418 372.212 243.058C378.402 242.778 384.982 242.378 390.042 238.808C396.282 234.398 398.632 226.278 399.442 218.678C400.282 210.818 399.842 204.778 398.962 199.348C398.032 193.618 396.012 185.108 391.162 175.428C393.382 173.548 396.992 169.958 399.302 164.378C400.092 162.468 404.582 151.648 399.022 143.078C398.372 142.078 394.452 136.018 388.932 136.358C383.512 136.688 380.102 142.928 379.432 144.398C378.192 147.098 377.632 149.258 377.532 150.278C377.222 148.868 376.572 146.778 375.142 144.648H375.132Z",
    fill: "#F4F3F9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_90771_36502",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 343,
    y: 136,
    width: 59,
    height: 108
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M375.132 144.648C372.082 140.098 366.262 136.508 360.172 137.008C350.082 137.838 345.762 149.378 345.112 151.128C344.662 152.338 341.442 161.378 346.332 170.468C348.732 174.928 352.082 177.538 353.982 178.798C348.072 193.158 344.512 206.798 345.432 221.638C345.792 227.498 345.032 233.428 349.162 237.598C354.882 243.388 364.072 243.418 372.212 243.058C378.402 242.778 384.982 242.378 390.042 238.808C396.282 234.398 398.632 226.278 399.442 218.678C400.282 210.818 399.842 204.778 398.962 199.348C398.032 193.618 396.012 185.108 391.162 175.428C393.382 173.548 396.992 169.958 399.302 164.378C400.092 162.468 404.582 151.648 399.022 143.078C398.372 142.078 394.452 136.018 388.932 136.358C383.512 136.688 380.102 142.928 379.432 144.398C378.192 147.098 377.632 149.258 377.532 150.278C377.222 148.868 376.572 146.778 375.142 144.648H375.132Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_90771_36502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.003 250.738C392.356 250.738 407.233 234.173 407.233 213.738C407.233 193.304 392.356 176.738 374.003 176.738C355.651 176.738 340.773 193.304 340.773 213.738C340.773 234.173 355.651 250.738 374.003 250.738Z",
    fill: "url(#paint1_linear_90771_36502)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M393.892 153.394C394.307 149.45 392.079 145.983 388.915 145.65C385.752 145.317 382.851 148.244 382.435 152.188C382.02 156.131 384.248 159.598 387.412 159.931C390.576 160.264 393.477 157.337 393.892 153.394Z",
    fill: "#100D20"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M370.727 153.392C370.948 149.433 368.553 146.079 365.377 145.902C362.201 145.724 359.446 148.79 359.225 152.749C359.004 156.708 361.399 160.062 364.575 160.24C367.751 160.417 370.506 157.351 370.727 153.392Z",
    fill: "#100D20"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M362.754 153.263C363.579 153.195 364.179 152.305 364.094 151.275C364.008 150.246 363.27 149.467 362.444 149.536C361.618 149.605 361.019 150.495 361.104 151.524C361.19 152.553 361.928 153.332 362.754 153.263Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M367.431 157.507C367.777 157.478 368.029 157.102 367.993 156.667C367.957 156.233 367.646 155.903 367.3 155.932C366.953 155.961 366.701 156.337 366.737 156.772C366.773 157.206 367.084 157.536 367.431 157.507Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M385.914 152.63C386.74 152.562 387.339 151.672 387.254 150.642C387.168 149.613 386.43 148.835 385.604 148.903C384.779 148.972 384.179 149.862 384.264 150.891C384.35 151.92 385.088 152.699 385.914 152.63Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M390.587 156.87C390.934 156.841 391.185 156.465 391.149 156.031C391.113 155.596 390.803 155.267 390.456 155.295C390.109 155.324 389.857 155.7 389.894 156.135C389.93 156.57 390.24 156.899 390.587 156.87Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M376.481 159.177C375.671 159.697 371.831 162.987 372.811 164.727C373.331 165.647 374.911 165.627 377.761 165.587C380.261 165.557 381.511 165.537 381.961 164.767C382.941 163.067 379.051 159.697 378.421 159.227C377.961 158.887 377.581 158.857 377.491 158.857C377.011 158.837 376.651 159.067 376.491 159.167L376.481 159.177Z",
    fill: "#EDBF1C"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.71 164.127C375.54 162.627 375.87 159.947 377.71 159.117C377.82 159.067 377.94 159.047 378.07 159.027C377.77 158.877 377.54 158.867 377.47 158.857C376.99 158.837 376.63 159.067 376.47 159.167C375.66 159.687 371.82 162.977 372.8 164.717C373.32 165.637 374.9 165.617 377.75 165.577C378.22 165.577 378.65 165.567 379.04 165.557C378.09 165.387 377.24 165.037 376.71 164.117V164.127Z",
    fill: "#A84424"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M365.473 164.131C365.625 163.216 364.481 162.263 362.917 162.003C361.353 161.744 359.962 162.275 359.81 163.19C359.658 164.106 360.803 165.058 362.366 165.318C363.93 165.578 365.321 165.046 365.473 164.131Z",
    fill: "#CAA3CB"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.079 165.048C380.669 165.035 381.142 164.742 381.134 164.394C381.126 164.046 380.641 163.775 380.05 163.788C379.459 163.802 378.987 164.094 378.995 164.442C379.002 164.79 379.488 165.061 380.079 165.048Z",
    fill: "#F4F3F9"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M391.758 164.05C392.993 163.707 393.826 162.825 393.619 162.08C393.412 161.335 392.243 161.009 391.009 161.352C389.774 161.695 388.941 162.577 389.148 163.322C389.355 164.067 390.523 164.393 391.758 164.05Z",
    fill: "#CAA3CB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M354.119 179.15C354.289 178.48 354.269 177.9 354.229 177.52C354.129 177.85 353.969 178.29 353.699 178.79C353.559 179.05 351.969 181.87 349.759 181.82C349.439 181.82 349.189 181.75 349.049 181.71C349.179 181.82 349.299 181.94 349.429 182.05C349.539 182.14 349.649 182.2 349.749 182.24C350.939 182.71 352.499 181.03 352.619 180.9C351.579 181.81 351.199 182.67 351.059 183.32C350.859 184.26 351.039 185.35 350.339 185.86C350.189 185.97 350.039 186.02 349.939 186.05C350.079 186.22 350.249 186.29 350.359 186.24C350.379 186.23 350.409 186.21 350.439 186.17C350.379 186.27 350.329 186.36 350.269 186.46C350.179 186.62 350.269 186.76 350.389 186.81C350.369 186.88 350.339 186.95 350.309 187.02C350.309 187.04 350.289 187.05 350.289 187.07C350.279 187.1 350.059 187.72 350.009 187.85C349.679 188.84 349.289 193.06 346.989 194.74C346.739 194.92 346.299 195.2 345.619 195.38C345.939 195.62 346.209 195.69 346.409 195.71C347.389 195.78 348.479 194.67 349.019 192.9C348.849 193.28 348.569 193.94 348.259 194.77C347.439 197.02 347.259 198.32 346.419 198.54C346.279 198.58 346.049 198.6 345.739 198.49C345.959 198.98 346.479 199.19 346.859 199.03C347.249 198.87 347.329 198.37 347.329 198.35C347.219 199.29 347.079 200.05 346.969 200.6C346.639 202.25 346.419 203.3 345.729 204.44C345.409 204.97 345.079 205.36 344.859 205.6C345.659 204.99 345.999 204.9 346.119 205.01C346.709 205.49 343.009 210.21 344.149 211.47C344.279 211.61 344.439 211.68 344.569 211.71C344.329 211.38 344.329 210.94 344.569 210.63C344.779 210.35 345.129 210.21 345.489 210.28C345.499 210.72 345.489 212.23 344.399 213.32C344.139 213.58 343.859 213.77 343.609 213.91C344.099 213.87 344.599 213.83 345.089 213.79C345.209 214.16 345.579 215.42 344.939 216.64C344.769 216.96 344.569 217.21 344.379 217.4C344.529 217.42 344.689 217.43 344.839 217.45C344.949 217.46 345.049 217.47 345.159 217.48C345.229 217.91 345.299 218.78 344.909 219.76C344.679 220.35 344.359 220.77 344.119 221.05C344.919 221.3 345.329 221.17 345.559 221C346.829 220.04 345.889 215.06 345.989 214.58C346.019 214.4 346.049 214.22 346.079 214.04C346.079 214.04 346.079 214.02 346.079 214.01C346.079 213.99 346.079 213.97 346.079 213.94C346.089 213.82 346.009 213.73 345.899 213.71C346.049 212.99 346.169 212.26 346.269 211.53C346.269 211.51 346.269 211.49 346.269 211.46C346.299 211.23 345.999 211.15 345.849 211.28C346.049 210.56 346.209 209.83 346.309 209.08C346.309 209.04 346.309 209 346.309 208.96C346.429 208.69 346.549 208.42 346.649 208.14C346.739 207.9 346.409 207.74 346.249 207.88C346.599 207.02 346.859 206.13 346.999 205.22C347.239 204.56 347.489 203.91 347.729 203.25C347.829 202.97 347.419 202.83 347.269 203.06C347.229 203.12 347.189 203.18 347.149 203.24C347.149 203.05 347.149 202.86 347.129 202.66C347.129 202.55 347.049 202.47 346.959 202.44C346.959 202.37 346.939 202.31 346.899 202.27C346.909 202.19 346.919 202.11 346.939 202.04C346.959 202.02 346.979 201.99 346.989 201.95C347.689 199.46 348.389 196.96 349.089 194.47C349.639 193.08 350.089 191.64 350.429 190.18C350.479 189.95 350.259 189.83 350.089 189.89C350.429 189.07 350.779 188.26 351.119 187.44C351.169 187.31 351.059 187.17 350.949 187.13C350.889 187.11 350.829 187.13 350.779 187.15C350.899 186.79 351.019 186.43 351.139 186.07C351.469 185.6 351.809 185.14 352.139 184.67C352.299 184.45 352.009 184.23 351.799 184.33C352.049 183.95 352.279 183.56 352.489 183.16C352.859 182.83 353.189 182.46 353.479 182.05C353.609 181.87 353.439 181.69 353.269 181.69C353.259 181.65 353.239 181.62 353.209 181.59C353.189 181.57 353.179 181.56 353.159 181.55C353.189 181.5 353.229 181.44 353.259 181.39C353.329 181.28 353.279 181.11 353.169 181.05C353.139 181.03 353.109 181.02 353.079 181.02C353.359 180.71 353.849 180.08 354.089 179.15H354.119Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M399.542 201.67C399.542 201.67 399.542 201.61 399.532 201.6C399.322 201.16 399.352 200.64 399.212 200.18C398.992 199.43 398.692 197.4 398.462 196.01C398.242 194.71 397.952 192.95 397.452 190.9C396.692 187.77 396.512 188.36 396.282 186.75C396.042 185.11 395.542 183.51 395.062 181.93C395.042 181.86 395.012 181.78 394.962 181.73C394.832 181.61 394.592 181.71 394.522 181.87C394.452 182.04 394.482 182.23 394.522 182.4C394.432 181.87 394.012 177.65 393.452 177.69C393.342 177.69 393.262 177.8 393.202 177.9C393.062 178.12 392.922 178.33 392.792 178.55C392.952 178.3 392.792 175.05 392.522 175.07C392.552 175.07 392.652 174.63 392.482 174.54C392.402 174.5 392.282 174.56 392.102 174.68C391.552 175.04 391.272 175.22 391.142 175.45C390.892 175.87 391.132 176.04 390.902 176.43C390.582 177 389.822 177.12 389.832 177.15C389.842 177.18 390.282 177.08 390.802 176.82C391.192 176.62 391.482 176.4 391.662 176.23C391.532 177.11 391.272 178.25 390.672 179.47C390.422 179.99 390.142 180.45 389.872 180.84C390.262 180.53 390.722 180.09 391.182 179.51C391.722 178.82 392.052 178.16 392.272 177.65C392.382 178.09 392.482 178.67 392.462 179.34C392.422 180.69 391.942 181.72 391.622 182.27C392.202 181.38 392.782 180.49 393.362 179.6C393.362 179.77 393.482 179.88 393.612 179.87C393.322 182.31 393.642 184.3 394.202 185.89C394.222 185.95 394.242 186 394.262 186.05C394.222 185.87 394.072 185.18 394.472 184.54C394.602 184.33 394.762 184.18 394.902 184.08C395.532 189.31 396.122 191.39 396.592 192.19C396.722 192.42 397.382 193.46 397.302 194.8C397.292 194.97 397.272 195.11 397.252 195.2C397.352 194.83 397.452 194.46 397.562 194.08C398.412 197.17 398.942 199.47 399.012 200.07C399.072 200.62 399.012 201.1 399.012 201.1C398.972 201.36 398.912 201.56 398.872 201.68C399.042 201.38 399.122 201.32 399.162 201.33C399.212 201.34 399.192 201.44 399.282 201.54C399.372 201.64 399.522 201.69 399.552 201.65L399.542 201.67Z",
    fill: "#4F3F99"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M400.852 218.789C400.892 218.319 400.962 217.399 400.842 216.469C400.822 216.319 400.772 215.949 400.772 215.429C400.772 215.189 400.782 214.909 400.842 214.469C401.052 212.819 401.002 211.149 400.952 209.489C400.952 209.419 400.952 209.339 400.912 209.269C400.812 209.119 400.562 209.149 400.452 209.289C400.332 209.429 400.322 209.619 400.312 209.809C400.362 209.269 401.082 205.089 400.542 204.979C400.432 204.959 400.332 205.039 400.242 205.109C400.052 205.279 399.862 205.449 399.672 205.619C399.892 205.419 400.612 202.249 400.342 202.199C400.372 202.199 400.582 201.809 400.442 201.669C400.372 201.609 400.242 201.639 400.032 201.699C399.402 201.899 399.092 201.999 398.902 202.179C398.552 202.519 398.732 202.739 398.412 203.059C397.952 203.519 397.192 203.429 397.192 203.469C397.192 203.499 397.652 203.519 398.212 203.409C398.642 203.319 398.972 203.179 399.202 203.079C398.842 203.889 398.282 204.919 397.382 205.939C397.002 206.379 396.612 206.739 396.242 207.049C396.702 206.849 397.262 206.559 397.852 206.119C398.552 205.599 399.052 205.049 399.402 204.609C399.392 205.059 399.332 205.639 399.132 206.289C398.732 207.579 397.992 208.439 397.542 208.889C398.342 208.189 399.132 207.489 399.932 206.779C399.882 206.939 399.972 207.079 400.102 207.109C399.172 209.389 398.952 211.389 399.062 213.069C399.062 213.129 399.062 213.189 399.072 213.239C399.072 213.049 399.122 212.349 399.672 211.839C399.862 211.669 400.052 211.569 400.212 211.509C399.422 216.719 399.432 218.879 399.672 219.779C399.742 220.039 400.092 221.219 399.652 222.489C399.622 222.579 399.482 222.859 399.502 222.859C399.532 222.869 399.882 222.299 400.092 221.869C400.692 220.679 400.792 219.559 400.862 218.759L400.852 218.789Z",
    fill: "#4F3F99"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M404.322 149.976C403.152 145.586 400.032 136.766 391.792 131.186C375.702 120.296 352.632 130.316 345.672 140.656C343.892 143.296 342.651 146.436 342.651 146.436C340.451 151.976 339.891 157.956 340.841 163.736C337.311 154.126 338.132 143.236 344.012 134.326C352.402 121.616 374.962 115.816 390.202 126.166C401.382 133.756 403.811 146.766 404.311 149.966L404.322 149.976Z",
    fill: "#EDBF1C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M390.202 124.786C376.392 115.166 353.852 118.036 344.012 132.946C338.132 141.846 337.311 152.746 340.841 162.356C340.631 160.366 340.511 157.696 340.871 154.576C340.871 154.576 341.251 151.326 342.241 148.126C345.621 137.286 352.941 130.736 352.941 130.736C360.341 123.236 375.871 119.236 387.941 125.746C394.171 129.106 397.801 134.346 398.901 135.986C400.781 138.766 401.921 141.376 402.621 143.286C401.571 139.506 398.531 130.606 390.191 124.796L390.202 124.786Z",
    fill: "#E9AB21"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M342.922 138.794C344.962 133.624 348.151 128.614 352.301 124.734C349.061 126.864 346.222 129.594 344.012 132.934C338.132 141.834 337.311 152.734 340.841 162.344C340.631 160.354 340.511 157.684 340.871 154.564C340.871 154.564 341.002 153.414 341.322 151.804C340.922 147.454 341.172 143.044 342.922 138.794Z",
    fill: "#FFCA65"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M399.619 153.76C399.929 162.19 403.519 165.18 406.059 162.49C407.709 160.74 408.639 156.77 408.589 153.06C408.539 149.28 407.469 145.2 405.689 143.56C402.869 140.97 399.289 144.92 399.619 153.76Z",
    fill: "#E9AB21"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M401.598 153.61C401.828 161.01 404.438 164.22 406.448 162.09C407.838 160.62 408.648 156.77 408.598 153.06C408.548 149.28 407.608 145.32 406.108 143.94C403.898 141.91 401.358 145.89 401.598 153.61Z",
    fill: "#EDBF1C"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_90771_36502",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 405,
    y: 144,
    width: 4,
    height: 19
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M406.718 144.682C406.998 145.192 407.338 145.902 407.648 146.782C407.838 147.322 408.038 148.012 408.228 149.112C408.648 151.512 408.608 153.532 408.598 153.962C408.598 153.962 408.518 157.502 407.558 160.122C407.398 160.562 407.238 160.852 407.088 161.122C406.508 162.162 406.048 162.432 405.908 162.512C405.678 162.642 405.458 162.702 405.328 162.732C405.718 162.022 406.198 161.042 406.618 159.822C406.798 159.282 407.428 157.372 407.618 154.702C407.758 152.632 407.518 150.732 407.038 146.922C406.918 145.982 406.808 145.202 406.728 144.672L406.718 144.682Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_90771_36502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.328 162.745L408.638 152.535V162.745H408.328Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.305 162.745L408.635 152.105V152.535L408.325 162.745H408.305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.297 162.742L408.637 151.672V152.102L408.307 162.742H408.297Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.285 162.742L408.635 151.242V151.672L408.295 162.742H408.285Z",
    fill: "#FFFEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.266 162.743L408.636 150.812V151.243L408.286 162.743H408.266Z",
    fill: "#FFFEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.258 162.745L408.638 150.395V150.815L408.268 162.745H408.258Z",
    fill: "#FFFEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.246 162.745L408.636 149.965V150.395L408.256 162.745H408.246Z",
    fill: "#FFFEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.227 162.745L408.637 149.535V149.965L408.247 162.745H408.227Z",
    fill: "#FFFDF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.215 162.745L408.635 149.105V149.535L408.225 162.745H408.215Z",
    fill: "#FEFDF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.207 162.742L408.637 148.672V149.102L408.217 162.742H408.207Z",
    fill: "#FEFDF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.188 162.742L408.638 148.242V148.672L408.207 162.742H408.188Z",
    fill: "#FEFCF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.176 162.744L408.636 147.824V148.244L408.186 162.744H408.176Z",
    fill: "#FEFCF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.168 162.745L408.638 147.395V147.825L408.178 162.745H408.168Z",
    fill: "#FEFCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.145 162.745L408.635 146.965V147.395L408.165 162.745H408.145Z",
    fill: "#FEFCF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.137 162.745L408.637 146.535V146.965L408.147 162.745H408.137Z",
    fill: "#FEFBF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.125 162.745L408.635 146.105V146.535L408.135 162.745H408.125Z",
    fill: "#FEFBF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.105 162.742L408.635 145.672V146.102L408.125 162.742H408.105Z",
    fill: "#FEFBF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.098 162.742L408.638 145.242V145.672L408.108 162.742H408.098Z",
    fill: "#FEFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.086 162.744L408.636 144.824V145.244L408.096 162.744H408.086Z",
    fill: "#FEFAEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.066 162.744L408.626 144.684H408.636V144.824L408.086 162.744H408.066Z",
    fill: "#FEFAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.055 162.744L408.615 144.684H408.625L408.065 162.744H408.055Z",
    fill: "#FDFAEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.047 162.744L408.607 144.684H408.617L408.057 162.744H408.047Z",
    fill: "#FDF9EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.027 162.744L408.587 144.684H408.607L408.047 162.744H408.027Z",
    fill: "#FDF9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.016 162.744L408.576 144.684H408.586L408.026 162.744H408.016Z",
    fill: "#FDF9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.008 162.744L408.568 144.684H408.578L408.018 162.744H408.008Z",
    fill: "#FDF8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.988 162.744L408.548 144.684H408.568L408.008 162.744H407.988Z",
    fill: "#FDF8E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.977 162.744L408.537 144.684H408.547L407.987 162.744H407.977Z",
    fill: "#FDF8E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.965 162.744L408.525 144.684H408.535L407.975 162.744H407.965Z",
    fill: "#FDF8E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.957 162.744L408.507 144.684H408.527L407.967 162.744H407.957Z",
    fill: "#FDF7E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.938 162.744L408.497 144.684H408.508L407.957 162.744H407.938Z",
    fill: "#FDF7E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.926 162.744L408.486 144.684H408.496L407.936 162.744H407.926Z",
    fill: "#FDF7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.918 162.744L408.468 144.684H408.488L407.928 162.744H407.918Z",
    fill: "#FDF7E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.895 162.744L408.455 144.684H408.465L407.915 162.744H407.895Z",
    fill: "#FDF6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.887 162.744L408.447 144.684H408.457L407.897 162.744H407.887Z",
    fill: "#FCF6DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.875 162.744L408.425 144.684H408.445L407.885 162.744H407.875Z",
    fill: "#FCF6DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.855 162.744L408.415 144.684H408.425L407.875 162.744H407.855Z",
    fill: "#FCF5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.848 162.744L408.408 144.684H408.418L407.858 162.744H407.848Z",
    fill: "#FCF5DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.836 162.744L408.386 144.684H408.406L407.846 162.744H407.836Z",
    fill: "#FCF5DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.816 162.744L408.376 144.684H408.386L407.836 162.744H407.816Z",
    fill: "#FCF5DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.805 162.744L408.365 144.684H408.375L407.815 162.744H407.805Z",
    fill: "#FCF4D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.797 162.744L408.347 144.684H408.367L407.807 162.744H407.797Z",
    fill: "#FCF4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.777 162.744L408.337 144.684H408.347L407.797 162.744H407.777Z",
    fill: "#FCF4D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.766 162.744L408.326 144.684H408.336L407.776 162.744H407.766Z",
    fill: "#FCF3D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.758 162.744L408.308 144.684H408.328L407.768 162.744H407.758Z",
    fill: "#FCF3D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.738 162.744L408.298 144.684H408.308L407.758 162.744H407.738Z",
    fill: "#FCF3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.727 162.744L408.287 144.684H408.297L407.737 162.744H407.727Z",
    fill: "#FBF3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.715 162.744L408.265 144.684H408.285L407.725 162.744H407.715Z",
    fill: "#FBF2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.695 162.744L408.255 144.684H408.265L407.715 162.744H407.695Z",
    fill: "#FBF2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.688 162.744L408.247 144.684H408.258L407.698 162.744H407.688Z",
    fill: "#FBF2D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.676 162.744L408.236 144.684H408.246L407.686 162.744H407.676Z",
    fill: "#FBF1CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.656 162.744L408.216 144.684H408.236L407.676 162.744H407.656Z",
    fill: "#FBF1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.645 162.744L408.205 144.684H408.215L407.655 162.744H407.645Z",
    fill: "#FBF1CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.637 162.744L408.197 144.684H408.207L407.647 162.744H407.637Z",
    fill: "#FBF1CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.617 162.744L408.177 144.684H408.197L407.637 162.744H407.617Z",
    fill: "#FBF0CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.605 162.744L408.165 144.684H408.175L407.615 162.744H407.605Z",
    fill: "#FBF0CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.598 162.744L408.158 144.684H408.168L407.608 162.744H407.598Z",
    fill: "#FBF0C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.578 162.744L408.138 144.684H408.158L407.598 162.744H407.578Z",
    fill: "#FBEFC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.566 162.744L408.126 144.684H408.136L407.576 162.744H407.566Z",
    fill: "#FBEFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.555 162.744L408.115 144.684H408.125L407.565 162.744H407.555Z",
    fill: "#FAEFC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.535 162.744L408.095 144.684H408.115L407.555 162.744H407.535Z",
    fill: "#FAEFC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.527 162.744L408.087 144.684H408.097L407.537 162.744H407.527Z",
    fill: "#FAEEC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.516 162.744L408.076 144.684H408.086L407.526 162.744H407.516Z",
    fill: "#FAEEC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.508 162.744L408.058 144.684H408.078L407.518 162.744H407.508Z",
    fill: "#FAEEC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.488 162.744L408.048 144.684H408.058L407.508 162.744H407.488Z",
    fill: "#FAEDC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.477 162.744L408.037 144.684H408.047L407.487 162.744H407.477Z",
    fill: "#FAEDC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.465 162.744L408.015 144.684H408.035L407.475 162.744H407.465Z",
    fill: "#FAEDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.445 162.744L408.005 144.684H408.015L407.465 162.744H407.445Z",
    fill: "#FAEDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.438 162.744L407.997 144.684H408.008L407.448 162.744H407.438Z",
    fill: "#FAECBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.426 162.744L407.976 144.684H407.996L407.436 162.744H407.426Z",
    fill: "#FAECBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.406 162.744L407.966 144.684H407.976L407.426 162.744H407.406Z",
    fill: "#FAECBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.395 162.744L407.955 144.684H407.965L407.405 162.744H407.395Z",
    fill: "#FAEBBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.387 162.744L407.937 144.684H407.957L407.397 162.744H407.387Z",
    fill: "#F9EBB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.367 162.744L407.927 144.684H407.937L407.387 162.744H407.367Z",
    fill: "#F9EBB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.355 162.744L407.915 144.684H407.925L407.365 162.744H407.355Z",
    fill: "#F9EBB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.348 162.744L407.898 144.684H407.918L407.358 162.744H407.348Z",
    fill: "#F9EAB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.328 162.744L407.888 144.684H407.898L407.348 162.744H407.328Z",
    fill: "#F9EAB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.316 162.744L407.876 144.684H407.886L407.326 162.744H407.316Z",
    fill: "#F9EAB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.305 162.744L407.855 144.684H407.875L407.315 162.744H407.305Z",
    fill: "#F9E9B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.285 162.744L407.845 144.684H407.855L407.305 162.744H407.285Z",
    fill: "#F9E9B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.277 162.744L407.837 144.684H407.847L407.287 162.744H407.277Z",
    fill: "#F9E9B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.266 162.744L407.816 144.684H407.836L407.276 162.744H407.266Z",
    fill: "#F9E9B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.246 162.744L407.806 144.684H407.816L407.266 162.744H407.246Z",
    fill: "#F9E8AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.238 162.744L407.798 144.684H407.808L407.248 162.744H407.238Z",
    fill: "#F9E8AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.227 162.744L407.777 144.684H407.797L407.237 162.744H407.227Z",
    fill: "#F8E8AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.207 162.744L407.767 144.684H407.777L407.227 162.744H407.207Z",
    fill: "#F8E7AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.195 162.744L407.755 144.684H407.765L407.205 162.744H407.195Z",
    fill: "#F8E7AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.188 162.744L407.747 144.684H407.758L407.198 162.744H407.188Z",
    fill: "#F8E7AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.168 162.744L407.728 144.684H407.748L407.188 162.744H407.168Z",
    fill: "#F8E7A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.156 162.744L407.716 144.684H407.726L407.166 162.744H407.156Z",
    fill: "#F8E6A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.145 162.744L407.705 144.684H407.715L407.155 162.744H407.145Z",
    fill: "#F8E6A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.125 162.744L407.685 144.684H407.705L407.145 162.744H407.125Z",
    fill: "#F8E6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.117 162.744L407.677 144.684H407.687L407.127 162.744H407.117Z",
    fill: "#F8E6A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.105 162.744L407.665 144.684H407.675L407.115 162.744H407.105Z",
    fill: "#F8E5A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.086 162.744L407.646 144.684H407.666L407.106 162.744H407.086Z",
    fill: "#F8E5A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.078 162.744L407.638 144.684H407.648L407.088 162.744H407.078Z",
    fill: "#F8E5A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.066 162.744L407.626 144.684H407.636L407.076 162.744H407.066Z",
    fill: "#F8E4A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.055 162.744L407.605 144.684H407.625L407.065 162.744H407.055Z",
    fill: "#F7E4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.035 162.744L407.595 144.684H407.605L407.055 162.744H407.035Z",
    fill: "#F7E49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.027 162.744L407.587 144.684H407.597L407.037 162.744H407.027Z",
    fill: "#F7E49E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.016 162.744L407.566 144.684H407.586L407.026 162.744H407.016Z",
    fill: "#F7E39D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.996 162.744L407.556 144.684H407.566L407.016 162.744H406.996Z",
    fill: "#F7E39C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.988 162.744L407.548 144.684H407.558L406.998 162.744H406.988Z",
    fill: "#F7E39B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.977 162.744L407.527 144.684H407.547L406.987 162.744H406.977Z",
    fill: "#F7E29A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.957 162.744L407.517 144.684H407.527L406.977 162.744H406.957Z",
    fill: "#F7E299"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.945 162.744L407.505 144.684H407.515L406.955 162.744H406.945Z",
    fill: "#F7E298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.938 162.744L407.487 144.684H407.508L406.948 162.744H406.938Z",
    fill: "#F7E297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.918 162.744L407.478 144.684H407.488L406.938 162.744H406.918Z",
    fill: "#F7E196"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.906 162.744L407.466 144.684H407.476L406.916 162.744H406.906Z",
    fill: "#F7E195"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.895 162.744L407.445 144.684H407.465L406.905 162.744H406.895Z",
    fill: "#F6E194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.875 162.744L407.435 144.684H407.445L406.895 162.744H406.875Z",
    fill: "#F6E093"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.867 162.744L407.427 144.684H407.437L406.877 162.744H406.867Z",
    fill: "#F6E092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.855 162.744L407.405 144.684H407.425L406.865 162.744H406.855Z",
    fill: "#F6E091"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.836 162.744L407.396 144.684H407.406L406.856 162.744H406.836Z",
    fill: "#F6E090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.828 162.744L407.388 144.684H407.398L406.838 162.744H406.828Z",
    fill: "#F6DF8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.816 162.744L407.366 144.684H407.386L406.826 162.744H406.816Z",
    fill: "#F6DF8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.797 162.744L407.357 144.684H407.367L406.817 162.744H406.797Z",
    fill: "#F6DF8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.785 162.744L407.345 144.684H407.355L406.795 162.744H406.785Z",
    fill: "#F6DE8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.777 162.744L407.327 144.684H407.347L406.787 162.744H406.777Z",
    fill: "#F6DE8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.758 162.744L407.318 144.684H407.328L406.778 162.744H406.758Z",
    fill: "#F6DE89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.746 162.744L407.306 144.684H407.316L406.756 162.744H406.746Z",
    fill: "#F6DE88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.738 162.744L407.298 144.684H407.308L406.748 162.744H406.738Z",
    fill: "#F6DD87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.715 162.744L407.275 144.684H407.295L406.735 162.744H406.715Z",
    fill: "#F5DD86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.707 162.744L407.267 144.684H407.277L406.717 162.744H406.707Z",
    fill: "#F5DD85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.695 162.744L407.255 144.684H407.265L406.705 162.744H406.695Z",
    fill: "#F5DC84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.676 162.744L407.236 144.684H407.256L406.696 162.744H406.676Z",
    fill: "#F5DC83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.668 162.744L407.228 144.684H407.238L406.678 162.744H406.668Z",
    fill: "#F5DC82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.656 162.744L407.216 144.684H407.226L406.666 162.744H406.656Z",
    fill: "#F5DC81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.637 162.744L407.197 144.684H407.217L406.657 162.744H406.637Z",
    fill: "#F5DB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.625 162.744L407.185 144.684H407.195L406.635 162.744H406.625Z",
    fill: "#F5DB7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.617 162.744L407.177 144.684H407.187L406.627 162.744H406.617Z",
    fill: "#F5DB7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.605 162.744L407.155 144.684H407.175L406.615 162.744H406.605Z",
    fill: "#F5DA7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.586 162.744L407.146 144.684H407.156L406.606 162.744H406.586Z",
    fill: "#F5DA7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.578 162.744L407.138 144.684H407.148L406.588 162.744H406.578Z",
    fill: "#F5DA7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.566 162.744L407.116 144.684H407.136L406.576 162.744H406.566Z",
    fill: "#F4DA7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.547 162.744L407.107 144.684H407.117L406.567 162.744H406.547Z",
    fill: "#F4D979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.535 162.744L407.095 144.684H407.105L406.545 162.744H406.535Z",
    fill: "#F4D978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.527 162.744L407.077 144.684H407.097L406.537 162.744H406.527Z",
    fill: "#F4D977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.508 162.744L407.068 144.684H407.078L406.528 162.744H406.508Z",
    fill: "#F4D876"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.496 162.744L407.056 144.684H407.066L406.506 162.744H406.496Z",
    fill: "#F4D875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.488 162.744L407.038 144.684H407.058L406.498 162.744H406.488Z",
    fill: "#F4D874"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.465 162.744L407.025 144.684H407.035L406.485 162.744H406.465Z",
    fill: "#F4D873"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.457 162.744L407.017 144.684H407.027L406.467 162.744H406.457Z",
    fill: "#F4D772"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.445 162.744L406.995 144.684H407.015L406.455 162.744H406.445Z",
    fill: "#F4D771"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.426 162.744L406.986 144.684H406.996L406.446 162.744H406.426Z",
    fill: "#F4D770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.418 162.744L406.978 144.684H406.988L406.428 162.744H406.418Z",
    fill: "#F4D76F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.406 162.744L406.956 144.684H406.976L406.416 162.744H406.406Z",
    fill: "#F4D66E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.387 162.744L406.947 144.684H406.957L406.407 162.744H406.387Z",
    fill: "#F3D66D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.375 162.744L406.935 144.684H406.945L406.385 162.744H406.375Z",
    fill: "#F3D66C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.367 162.744L406.917 144.684H406.937L406.377 162.744H406.367Z",
    fill: "#F3D56B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.348 162.744L406.908 144.684H406.918L406.368 162.744H406.348Z",
    fill: "#F3D56A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.336 162.744L406.896 144.684H406.906L406.346 162.744H406.336Z",
    fill: "#F3D569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.328 162.744L406.878 144.684H406.898L406.338 162.744H406.328Z",
    fill: "#F3D568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.305 162.744L406.865 144.684H406.875L406.325 162.744H406.305Z",
    fill: "#F3D467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.297 162.744L406.857 144.684H406.867L406.307 162.744H406.297Z",
    fill: "#F3D466"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.285 162.744L406.845 144.684H406.855L406.295 162.744H406.285Z",
    fill: "#F3D465"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.266 162.744L406.826 144.684H406.846L406.286 162.744H406.266Z",
    fill: "#F3D364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.258 162.744L406.818 144.684H406.828L406.268 162.744H406.258Z",
    fill: "#F3D363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.246 162.744L406.806 144.684H406.816L406.256 162.744H406.246Z",
    fill: "#F3D362"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.227 162.744L406.787 144.684H406.807L406.247 162.744H406.227Z",
    fill: "#F2D361"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.215 162.744L406.775 144.684H406.785L406.225 162.744H406.215Z",
    fill: "#F2D260"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.207 162.744L406.767 144.684H406.777L406.217 162.744H406.207Z",
    fill: "#F2D25F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.188 162.744L406.747 144.684H406.767L406.207 162.744H406.188Z",
    fill: "#F2D25E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.176 162.744L406.736 144.684H406.746L406.186 162.744H406.176Z",
    fill: "#F2D15D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.168 162.744L406.728 144.684H406.738L406.178 162.744H406.168Z",
    fill: "#F2D15C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.156 162.744L406.706 144.684H406.726L406.166 162.744H406.156Z",
    fill: "#F2D15B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.137 162.744L406.697 144.684H406.707L406.157 162.744H406.137Z",
    fill: "#F2D15A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.125 162.744L406.685 144.684H406.695L406.135 162.744H406.125Z",
    fill: "#F2D059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.117 162.744L406.667 144.684H406.687L406.127 162.744H406.117Z",
    fill: "#F2D058"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.098 162.744L406.658 144.684H406.668L406.118 162.744H406.098Z",
    fill: "#F2D057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.086 162.744L406.646 144.684H406.656L406.096 162.744H406.086Z",
    fill: "#F2CF56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.078 162.744L406.628 144.684H406.648L406.088 162.744H406.078Z",
    fill: "#F2CF55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.055 162.744L406.615 144.684H406.625L406.075 162.744H406.055Z",
    fill: "#F1CF54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.047 162.744L406.607 144.684H406.617L406.057 162.744H406.047Z",
    fill: "#F1CF53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.035 162.744L406.585 144.684H406.605L406.045 162.744H406.035Z",
    fill: "#F1CE52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.016 162.744L406.576 144.684H406.586L406.036 162.744H406.016Z",
    fill: "#F1CE51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.008 162.744L406.568 144.684H406.578L406.018 162.744H406.008Z",
    fill: "#F1CE50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.996 162.744L406.546 144.684H406.566L406.006 162.744H405.996Z",
    fill: "#F1CD4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.977 162.744L406.537 144.684H406.547L405.997 162.744H405.977Z",
    fill: "#F1CD4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.965 162.744L406.525 144.684H406.535L405.975 162.744H405.965Z",
    fill: "#F1CD4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.957 162.744L406.507 144.684H406.527L405.967 162.744H405.957Z",
    fill: "#F1CD4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.938 162.744L406.497 144.684H406.508L405.957 162.744H405.938Z",
    fill: "#F1CC4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.926 162.744L406.486 144.684H406.496L405.936 162.744H405.926Z",
    fill: "#F1CC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.918 162.744L406.468 144.684H406.488L405.928 162.744H405.918Z",
    fill: "#F1CC49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.895 162.744L406.455 144.684H406.465L405.915 162.744H405.895Z",
    fill: "#F1CB48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.887 162.744L406.447 144.684H406.457L405.897 162.744H405.887Z",
    fill: "#F0CB47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.875 162.744L406.425 144.684H406.445L405.885 162.744H405.875Z",
    fill: "#F0CB46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.855 162.744L406.415 144.684H406.425L405.875 162.744H405.855Z",
    fill: "#F0CB45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.848 162.744L406.408 144.684H406.418L405.858 162.744H405.848Z",
    fill: "#F0CA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.836 162.744L406.396 144.684H406.406L405.846 162.744H405.836Z",
    fill: "#F0CA43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.816 162.744L406.376 144.684H406.396L405.836 162.744H405.816Z",
    fill: "#F0CA42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.805 162.744L406.365 144.684H406.375L405.815 162.744H405.805Z",
    fill: "#F0C941"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.797 162.744L406.357 144.684H406.367L405.807 162.744H405.797Z",
    fill: "#F0C940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.777 162.744L406.337 144.684H406.357L405.797 162.744H405.777Z",
    fill: "#F0C93F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.766 162.744L406.326 144.684H406.336L405.776 162.744H405.766Z",
    fill: "#F0C93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.758 162.744L406.318 144.684H406.328L405.768 162.744H405.758Z",
    fill: "#F0C83D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.738 162.744L406.298 144.684H406.318L405.758 162.744H405.738Z",
    fill: "#F0C83C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.727 162.744L406.287 144.684H406.297L405.737 162.744H405.727Z",
    fill: "#EFC83B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.715 162.744L406.275 144.684H406.285L405.725 162.744H405.715Z",
    fill: "#EFC73A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.707 162.744L406.257 144.684H406.277L405.717 162.744H405.707Z",
    fill: "#EFC739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.688 162.744L406.247 144.684H406.258L405.707 162.744H405.688Z",
    fill: "#EFC738"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.676 162.744L406.236 144.684H406.246L405.686 162.744H405.676Z",
    fill: "#EFC737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.668 162.744L406.218 144.684H406.238L405.678 162.744H405.668Z",
    fill: "#EFC636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.645 162.744L406.205 144.684H406.215L405.665 162.744H405.645Z",
    fill: "#EFC635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.637 162.744L406.197 144.684H406.207L405.647 162.744H405.637Z",
    fill: "#EFC634"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.625 162.744L406.175 144.684H406.195L405.635 162.744H405.625Z",
    fill: "#EFC633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.605 162.744L406.165 144.684H406.175L405.625 162.744H405.605Z",
    fill: "#EFC532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.598 162.744L406.158 144.684H406.168L405.608 162.744H405.598Z",
    fill: "#EFC531"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.586 162.744L406.136 144.684H406.156L405.596 162.744H405.586Z",
    fill: "#EFC530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.566 162.744L406.126 144.684H406.136L405.586 162.744H405.566Z",
    fill: "#EFC42F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.555 162.744L406.115 144.684H406.125L405.565 162.744H405.555Z",
    fill: "#EEC42E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.547 162.744L406.097 144.684H406.117L405.557 162.744H405.547Z",
    fill: "#EEC42D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.527 162.744L406.087 144.684H406.097L405.547 162.744H405.527Z",
    fill: "#EEC42C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.516 162.744L406.076 144.684H406.086L405.526 162.744H405.516Z",
    fill: "#EEC32B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.508 162.744L406.058 144.684H406.078L405.518 162.744H405.508Z",
    fill: "#EEC32A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.488 162.744L406.048 144.684H406.058L405.508 162.744H405.488Z",
    fill: "#EEC329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.477 162.744L406.037 144.684H406.047L405.487 162.744H405.477Z",
    fill: "#EEC228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.465 162.744L406.015 144.684H406.035L405.475 162.744H405.465Z",
    fill: "#EEC227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.445 162.744L406.005 144.684H406.015L405.465 162.744H405.445Z",
    fill: "#EEC226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.438 162.744L405.997 144.684H406.008L405.448 162.744H405.438Z",
    fill: "#EEC225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.426 162.744L405.976 144.684H405.996L405.436 162.744H405.426Z",
    fill: "#EEC124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.406 162.744L405.966 144.684H405.976L405.426 162.744H405.406Z",
    fill: "#EEC123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.395 162.744L405.955 144.684H405.965L405.405 162.744H405.395Z",
    fill: "#EDC122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.387 162.744L405.947 144.684H405.957L405.397 162.744H405.387Z",
    fill: "#EDC021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.367 162.744L405.927 144.684H405.947L405.387 162.744H405.367Z",
    fill: "#EDC020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.355 162.744L405.915 144.684H405.925L405.365 162.744H405.355Z",
    fill: "#EDC01F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.348 162.744L405.908 144.684H405.918L405.358 162.744H405.348Z",
    fill: "#EDC01E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.328 162.744L405.888 144.684H405.908L405.348 162.744H405.328Z",
    fill: "#EDBF1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.316 162.744L405.876 144.684H405.886L405.326 162.744H405.316Z",
    fill: "#EDBF1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.876 144.684L405.316 162.744V144.684H405.876Z",
    fill: "#EDBF1C"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_90771_36502",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 373,
    y: 122,
    width: 13,
    height: 24
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M381.981 133.718C381.411 133.268 381.541 132.258 381.801 130.628C382.281 127.628 382.761 125.328 382.671 125.308C382.611 125.288 382.351 126.208 381.611 127.988C381.541 128.148 381.461 128.338 381.421 128.438C380.661 130.168 377.971 132.208 376.911 131.558C376.101 131.058 376.461 129.088 376.681 127.868C377.251 124.758 378.741 123.098 378.561 122.958C378.201 122.688 371.831 128.878 373.221 131.258C373.611 131.918 374.481 132.108 375.001 132.178C375.151 132.558 375.321 132.938 375.531 133.318C375.751 133.698 376.241 133.898 376.661 133.778C378.351 133.288 379.801 132.328 380.891 131.048C380.351 132.848 379.271 134.498 377.781 135.718C376.871 136.458 377.961 137.648 378.891 137.328C377.361 139.348 376.281 141.628 376.461 144.298C376.531 145.338 377.861 145.538 378.321 144.888C378.471 144.678 378.481 144.388 378.471 144.298C378.351 142.618 382.641 139.338 384.271 136.008C385.731 133.018 384.991 130.078 384.901 130.068C384.811 130.068 384.851 133.168 383.341 133.818C382.911 133.998 382.331 134.008 381.961 133.708L381.981 133.718Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_90771_36502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.751 123.188L384.711 122.688H385.351L385.751 122.877V123.188Z",
    fill: "#231B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.752 123.487L384.082 122.688H384.712L385.752 123.188V123.487Z",
    fill: "#241C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.751 123.787L383.441 122.688H384.081L385.751 123.487V123.787Z",
    fill: "#251C56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.753 124.097L382.812 122.688H383.443L385.753 123.787V124.097Z",
    fill: "#261D57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.752 124.397L382.172 122.688H382.812L385.752 124.097V124.397Z",
    fill: "#261E59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.753 124.697L381.543 122.688H382.173L385.753 124.397V124.697Z",
    fill: "#271E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.752 125.007L380.902 122.688H381.542L385.752 124.697V125.007Z",
    fill: "#281F5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.752 125.307L380.262 122.688H380.902L385.752 125.007V125.307Z",
    fill: "#291F5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.753 125.618L379.633 122.688H380.263L385.753 125.307V125.618Z",
    fill: "#29205D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.752 125.917L378.992 122.688H379.632L385.752 125.618V125.917Z",
    fill: "#2A215F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.753 126.217L378.363 122.688H378.993L385.753 125.917V126.217Z",
    fill: "#2B2160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.753 126.527L377.723 122.688H378.363L385.753 126.217V126.527Z",
    fill: "#2C2261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.752 126.827L377.082 122.688H377.722L385.752 126.527V126.827Z",
    fill: "#2D2362"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.753 127.127L376.453 122.688H377.083L385.753 126.827V127.127Z",
    fill: "#2D2363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.753 127.438L375.812 122.688H376.453L385.753 127.127V127.438Z",
    fill: "#2E2465"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.754 127.737L375.184 122.688H375.814L385.754 127.438V127.737Z",
    fill: "#2F2466"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.753 128.048L374.543 122.688H375.183L385.753 127.737V128.048Z",
    fill: "#2F2567"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.752 128.348L373.902 122.688H374.542L385.752 128.048V128.348Z",
    fill: "#302668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.751 128.647L373.621 122.857L373.701 122.688H373.901L385.751 128.348V128.647Z",
    fill: "#312669"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.754 128.959L373.504 123.109L373.624 122.859L385.754 128.649V128.959Z",
    fill: "#32276A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.753 129.259L373.383 123.359L373.503 123.109L385.753 128.959V129.259Z",
    fill: "#32276C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.753 129.559L373.273 123.599L373.383 123.359L385.753 129.259V129.559Z",
    fill: "#33286D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.752 129.868L373.152 123.848L373.272 123.598L385.752 129.558V129.868Z",
    fill: "#34296E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.751 130.168L373.031 124.098L373.151 123.848L385.751 129.868V130.168Z",
    fill: "#35296F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.75 130.468L372.91 124.338L373.03 124.098L385.75 130.168V130.468Z",
    fill: "#352A70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.753 130.776L372.793 124.586L372.913 124.336L385.753 130.466V130.776Z",
    fill: "#362A71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.754 131.076L372.684 124.836L372.794 124.586L385.754 130.776V131.076Z",
    fill: "#372B72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.753 131.386L372.562 125.086L372.682 124.836L385.753 131.076V131.386Z",
    fill: "#372C73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.751 131.686L372.441 125.326L372.561 125.086L385.751 131.386V131.686Z",
    fill: "#382C75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.75 131.988L372.32 125.578L372.44 125.328L385.75 131.688V131.988Z",
    fill: "#392D76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.753 132.298L372.203 125.828L372.323 125.578L385.753 131.988V132.298Z",
    fill: "#392D77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.752 132.598L372.082 126.078L372.202 125.828L385.752 132.298V132.598Z",
    fill: "#3A2E78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.753 132.898L371.973 126.318L372.083 126.078L385.753 132.598V132.898Z",
    fill: "#3B2E79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.752 133.206L371.852 126.566L371.972 126.316L385.752 132.896V133.206Z",
    fill: "#3B2F7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.752 133.506L371.832 126.866V126.596L371.852 126.566L385.752 133.206V133.506Z",
    fill: "#3C2F7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.752 133.817L371.832 127.167V126.867L385.752 133.507V133.817Z",
    fill: "#3D307C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.752 134.118L371.832 127.468V127.168L385.752 133.818V134.118Z",
    fill: "#3D307D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.752 134.419L371.832 127.779V127.469L385.752 134.119V134.419Z",
    fill: "#3E317E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.752 134.727L371.832 128.077V127.777L385.752 134.417V134.727Z",
    fill: "#3F327F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.752 135.028L371.832 128.388V128.078L385.752 134.728V135.028Z",
    fill: "#3F3280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.752 135.297L385.732 135.327L371.832 128.687V128.387L385.752 135.027V135.297Z",
    fill: "#403381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.732 135.327L385.622 135.577L371.832 128.988V128.688L385.732 135.327Z",
    fill: "#413382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.622 135.578L385.502 135.818L371.832 129.298V128.988L385.622 135.578Z",
    fill: "#413483"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.502 135.817L385.382 136.067L371.832 129.597V129.297L385.502 135.817Z",
    fill: "#423484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.382 136.068L385.262 136.318L371.832 129.898V129.598L385.382 136.068Z",
    fill: "#423585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.262 136.318L385.142 136.558L371.832 130.208V129.898L385.262 136.318Z",
    fill: "#433586"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.142 136.557L385.022 136.807L371.832 130.507V130.207L385.142 136.557Z",
    fill: "#443687"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.022 136.808L384.912 137.058L371.832 130.808V130.508L385.022 136.808Z",
    fill: "#443688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.912 137.059L384.792 137.309L371.832 131.119V130.809L384.912 137.059Z",
    fill: "#453789"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.792 137.307L384.672 137.547L371.832 131.417V131.117L384.792 137.307Z",
    fill: "#45378A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.672 137.548L384.552 137.798L371.832 131.728V131.418L384.672 137.548Z",
    fill: "#46378A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.552 137.797L384.432 138.047L371.832 132.027V131.727L384.552 137.797Z",
    fill: "#46388B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.432 138.047L384.322 138.297L371.832 132.327V132.027L384.432 138.047Z",
    fill: "#47388C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.322 138.298L384.202 138.538L371.832 132.638V132.328L384.322 138.298Z",
    fill: "#47398D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.202 138.537L384.082 138.787L371.832 132.937V132.637L384.202 138.537Z",
    fill: "#48398E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.082 138.787L383.962 139.037L371.832 133.238V132.938L384.082 138.787Z",
    fill: "#493A8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.962 139.038L383.842 139.278L371.832 133.548V133.238L383.962 139.038Z",
    fill: "#493A90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.842 139.277L383.732 139.527L371.832 133.847V133.547L383.842 139.277Z",
    fill: "#4A3B90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.732 139.528L383.612 139.778L371.832 134.158V133.848L383.732 139.528Z",
    fill: "#4A3B91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.612 139.776L383.492 140.026L371.832 134.456V134.156L383.612 139.776Z",
    fill: "#4B3B92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.492 140.027L383.372 140.267L371.832 134.757V134.457L383.492 140.027Z",
    fill: "#4B3C93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.372 140.268L383.252 140.518L371.832 135.068V134.758L383.372 140.268Z",
    fill: "#4B3C93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.252 140.516L383.142 140.766L371.832 135.366V135.066L383.252 140.516Z",
    fill: "#4C3C94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.142 140.767L383.022 141.017L371.832 135.667V135.367L383.142 140.767Z",
    fill: "#4C3D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.022 141.018L382.902 141.258L371.832 135.978V135.668L383.022 141.018Z",
    fill: "#4D3D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.902 141.257L382.782 141.507L371.832 136.277V135.977L382.902 141.257Z",
    fill: "#4D3D96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.782 141.507L382.662 141.757L371.832 136.587V136.277L382.782 141.507Z",
    fill: "#4E3E97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.662 141.756L382.542 141.996L371.832 136.886V136.586L382.662 141.756Z",
    fill: "#4E3E97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.542 141.997L382.432 142.247L371.832 137.187V136.887L382.542 141.997Z",
    fill: "#4E3E98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.432 142.247L382.312 142.497L371.832 137.497V137.188L382.432 142.247Z",
    fill: "#4F3F98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.312 142.496L382.192 142.746L371.832 137.796V137.496L382.312 142.496Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.192 142.747L382.072 142.987L371.832 138.097V137.797L382.192 142.747Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.072 142.988L380.852 145.548H371.832V138.098L382.072 142.988Z",
    fill: "#4F3F99"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_90771_36502",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 372,
    y: 122,
    width: 14,
    height: 29
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M381.571 133.479C381.001 133.029 381.131 132.019 381.391 130.389C381.871 127.389 382.351 125.089 382.261 125.069C382.201 125.049 381.941 125.969 381.201 127.749C381.131 127.909 381.051 128.099 381.011 128.199C380.251 129.929 377.561 131.97 376.501 131.32C375.691 130.82 376.051 128.849 376.271 127.629C376.841 124.519 378.331 122.859 378.151 122.719C377.791 122.449 371.421 128.64 372.811 131.02C373.201 131.68 374.071 131.869 374.591 131.939C374.741 132.319 374.911 132.699 375.121 133.079C375.341 133.459 375.831 133.659 376.251 133.539C377.941 133.049 379.391 132.089 380.481 130.809C379.941 132.609 378.861 134.259 377.371 135.479C376.461 136.219 377.551 137.409 378.481 137.089C375.871 140.689 375.961 143.199 376.051 144.059C376.141 144.899 376.501 146.63 376.901 148.13C377.121 148.98 377.341 149.679 377.491 150.169C377.741 148.689 378.201 146.969 379.011 145.16C379.011 145.16 379.851 143.279 381.071 141.579C381.721 140.669 382.391 139.949 382.391 139.949C382.661 139.679 382.851 139.469 382.911 139.41C383.701 138.609 384.461 137.059 384.821 135.649C385.491 133.009 384.791 130.689 384.491 129.829C384.631 131.689 383.981 133.189 382.931 133.579C382.871 133.599 382.071 133.879 381.551 133.469L381.571 133.479Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_90771_36502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.513 122.719L384.953 122.449H385.513V122.719Z",
    fill: "#241C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.514 123.089L384.184 122.449H384.954L385.514 122.719V123.089Z",
    fill: "#251C56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.51 123.459L383.41 122.449H384.18L385.51 123.089V123.459Z",
    fill: "#261D57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.511 123.819L382.641 122.449H383.411L385.511 123.459V123.819Z",
    fill: "#261E59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.511 124.189L381.871 122.449H382.641L385.511 123.819V124.189Z",
    fill: "#271E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.512 124.559L381.102 122.449H381.872L385.512 124.189V124.559Z",
    fill: "#281F5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.512 124.929L380.332 122.449H381.102L385.512 124.559V124.929Z",
    fill: "#291F5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.513 125.289L379.562 122.449H380.332L385.513 124.929V125.289Z",
    fill: "#29205D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.513 125.659L378.793 122.449H379.563L385.513 125.289V125.659Z",
    fill: "#2A215F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.513 126.029L378.023 122.449H378.793L385.513 125.659V126.029Z",
    fill: "#2B2160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.51 126.399L377.25 122.449H378.02L385.51 126.029V126.399Z",
    fill: "#2C2261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.51 126.769L376.48 122.449H377.25L385.51 126.399V126.769Z",
    fill: "#2D2362"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.511 127.129L375.711 122.449H376.481L385.511 126.769V127.129Z",
    fill: "#2D2363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.511 127.499L374.941 122.449H375.711L385.511 127.129V127.499Z",
    fill: "#2E2465"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.512 127.869L374.172 122.449H374.942L385.512 127.499V127.869Z",
    fill: "#2F2466"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.512 128.239L373.402 122.449H374.172L385.512 127.869V128.239Z",
    fill: "#2F2567"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.512 128.609L373.172 122.709L373.292 122.449H373.402L385.512 128.239V128.609Z",
    fill: "#302668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.511 128.971L373.031 123.011L373.171 122.711L385.511 128.611V128.971Z",
    fill: "#312669"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.513 129.338L372.883 123.308L373.033 123.008L385.513 128.968V129.338Z",
    fill: "#32276A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.512 129.709L372.742 123.609L372.882 123.309L385.512 129.339V129.709Z",
    fill: "#32276C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.512 130.079L372.602 123.909L372.742 123.609L385.512 129.709V130.079Z",
    fill: "#33286D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.513 130.44L372.453 124.21L372.603 123.91L385.513 130.08V130.44Z",
    fill: "#34296E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.513 130.811L372.312 124.511L372.453 124.211L385.513 130.441V130.811Z",
    fill: "#35296F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.512 131.178L372.172 124.808L372.312 124.508L385.512 130.808V131.178Z",
    fill: "#352A70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.513 131.549L372.023 125.109L372.173 124.809L385.513 131.179V131.549Z",
    fill: "#362A71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.513 131.919L371.883 125.409L372.023 125.109L385.513 131.549V131.919Z",
    fill: "#372B72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.512 132.28L371.742 125.7L371.882 125.41L385.512 131.92V132.28Z",
    fill: "#372C73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.512 132.649L371.602 125.999L371.742 125.699L385.512 132.279V132.649Z",
    fill: "#382C75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.513 133.02L371.453 126.3L371.603 126L385.513 132.65V133.02Z",
    fill: "#392D76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.512 133.391L371.422 126.661V126.361L371.452 126.301L385.512 133.021V133.391Z",
    fill: "#392D77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.512 133.76L371.422 127.03V126.66L385.512 133.39V133.76Z",
    fill: "#3A2E78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.512 134.117L371.422 127.387V127.027L385.512 133.757V134.117Z",
    fill: "#3B2E79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.512 134.491L371.422 127.761V127.391L385.512 134.121V134.491Z",
    fill: "#3B2F7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.512 134.858L371.422 128.128V127.758L385.512 134.488V134.858Z",
    fill: "#3C2F7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.512 135.229L371.422 128.499V128.129L385.512 134.859V135.229Z",
    fill: "#3D307C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.512 135.59L371.422 128.87V128.5L385.512 135.23V135.59Z",
    fill: "#3D307D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.512 135.961L371.422 129.231V128.871L385.512 135.591V135.961Z",
    fill: "#3E317E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.512 136.33L371.422 129.6V129.23L385.512 135.96V136.33Z",
    fill: "#3F327F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.512 136.698L371.422 129.968V129.598L385.512 136.328V136.698Z",
    fill: "#3F3280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.512 137.069L371.422 130.339V129.969L385.512 136.699V137.069Z",
    fill: "#403381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.512 137.19L385.422 137.39L371.422 130.7V130.34L385.512 137.07V137.19Z",
    fill: "#413382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.422 137.389L385.282 137.689L371.422 131.069V130.699L385.422 137.389Z",
    fill: "#413483"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.282 137.69L385.132 137.99L371.422 131.44V131.07L385.282 137.69Z",
    fill: "#423484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.132 137.988L384.992 138.287L371.422 131.807V131.438L385.132 137.988Z",
    fill: "#423585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.992 138.289L384.852 138.589L371.422 132.179V131.809L384.992 138.289Z",
    fill: "#433586"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.852 138.59L384.702 138.89L371.422 132.54V132.18L384.852 138.59Z",
    fill: "#443687"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.702 138.889L384.562 139.189L371.422 132.909V132.539L384.702 138.889Z",
    fill: "#443688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.562 139.19L384.422 139.49L371.422 133.28V132.91L384.562 139.19Z",
    fill: "#453789"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.422 139.487L384.272 139.777L371.422 133.647V133.277L384.422 139.487Z",
    fill: "#45378A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.272 139.778L384.132 140.078L371.422 134.018V133.648L384.272 139.778Z",
    fill: "#46378A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.132 140.08L383.992 140.38L371.422 134.38V134.02L384.132 140.08Z",
    fill: "#46388B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.992 140.379L383.852 140.679L371.422 134.749V134.379L383.992 140.379Z",
    fill: "#47388C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.852 140.68L383.702 140.98L371.422 135.12V134.75L383.852 140.68Z",
    fill: "#47398D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.702 140.981L383.562 141.281L371.422 135.491V135.121L383.702 140.981Z",
    fill: "#48398E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.562 141.278L383.422 141.578L371.422 135.848V135.488L383.562 141.278Z",
    fill: "#493A8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.422 141.578L383.272 141.878L371.422 136.218V135.848L383.422 141.578Z",
    fill: "#493A90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.272 141.879L383.132 142.179L371.422 136.589V136.219L383.272 141.879Z",
    fill: "#4A3B90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.132 142.18L382.992 142.48L371.422 136.96V136.59L383.132 142.18Z",
    fill: "#4A3B91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.992 142.481L382.842 142.781L371.422 137.331V136.961L382.992 142.481Z",
    fill: "#4B3B92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.842 142.778L382.702 143.078L371.422 137.688V137.328L382.842 142.778Z",
    fill: "#4B3C93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.702 143.077L382.562 143.378L371.422 138.057V137.688L382.702 143.077Z",
    fill: "#4B3C93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.562 143.379L382.412 143.679L371.422 138.429V138.059L382.562 143.379Z",
    fill: "#4C3C94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.412 143.68L382.272 143.98L371.422 138.8V138.43L382.412 143.68Z",
    fill: "#4C3D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.272 143.981L382.132 144.281L371.422 139.171V138.801L382.272 143.981Z",
    fill: "#4D3D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.132 144.278L381.992 144.578L371.422 139.528V139.168L382.132 144.278Z",
    fill: "#4D3D96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.992 144.577L381.842 144.877L371.422 139.897V139.527L381.992 144.577Z",
    fill: "#4E3E97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.842 144.878L381.702 145.178L371.422 140.268V139.898L381.842 144.878Z",
    fill: "#4E3E97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.702 145.18L381.562 145.48L371.422 140.64V140.27L381.702 145.18Z",
    fill: "#4E3E98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.562 145.481L381.412 145.781L371.422 141.001V140.641L381.562 145.481Z",
    fill: "#4F3F98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.412 145.78L381.272 146.07L371.422 141.37V141L381.412 145.78Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.272 146.071L381.132 146.371L371.422 141.741V141.371L381.272 146.071Z",
    fill: "#4F3F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.132 146.368L379.312 150.178H371.422V141.738L381.132 146.368Z",
    fill: "#4F3F99"
  })))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M348.483 156.732C348.525 150.155 344.054 144.794 338.499 144.759C332.943 144.724 328.405 150.028 328.364 156.606C328.323 163.183 332.793 168.544 338.349 168.579C343.905 168.614 348.442 163.31 348.483 156.732Z",
    fill: "#E9AB21"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M346.288 156.707C346.329 150.129 342.347 144.772 337.393 144.741C332.439 144.71 328.39 150.017 328.348 156.594C328.307 163.172 332.289 168.529 337.243 168.56C342.197 168.591 346.247 163.284 346.288 156.707Z",
    fill: "#EDBF1C"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_90771_36502",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 328,
    y: 144,
    width: 10,
    height: 25
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M337.504 168.609C337.424 168.609 337.334 168.609 337.254 168.609C332.304 168.579 328.324 163.219 328.364 156.639C328.404 150.059 332.374 144.859 337.264 144.789C334.804 147.449 333.314 151.269 332.814 154.609C332.224 159.629 333.264 165.589 337.504 168.609Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_90771_36502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.444 144.789L328.324 163.229V144.789H328.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.484 144.789L328.334 168.619H328.324V163.229L328.444 144.789H328.484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.526 144.789L328.376 168.619H328.336L328.486 144.789H328.526Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.565 144.789L328.415 168.619H328.375L328.525 144.789H328.565Z",
    fill: "#FFFEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.604 144.789L328.454 168.619H328.414L328.564 144.789H328.604Z",
    fill: "#FFFEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.643 144.789L328.493 168.619H328.453L328.603 144.789H328.643Z",
    fill: "#FFFEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.686 144.789L328.536 168.619H328.496L328.646 144.789H328.686Z",
    fill: "#FFFEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.725 144.789L328.575 168.619H328.535L328.685 144.789H328.725Z",
    fill: "#FFFDF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.764 144.789L328.614 168.619H328.574L328.724 144.789H328.764Z",
    fill: "#FEFDF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.803 144.789L328.653 168.619H328.613L328.763 144.789H328.803Z",
    fill: "#FEFDF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.842 144.789L328.692 168.619H328.652L328.802 144.789H328.842Z",
    fill: "#FEFCF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.885 144.789L328.735 168.619H328.695L328.845 144.789H328.885Z",
    fill: "#FEFCF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.934 144.789L328.774 168.619H328.734L328.884 144.789H328.934Z",
    fill: "#FEFCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.973 144.789L328.823 168.619H328.773L328.933 144.789H328.973Z",
    fill: "#FEFCF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.014 144.789L328.864 168.619H328.824L328.974 144.789H329.014Z",
    fill: "#FEFBF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.053 144.789L328.903 168.619H328.863L329.013 144.789H329.053Z",
    fill: "#FEFBF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.092 144.789L328.942 168.619H328.902L329.052 144.789H329.092Z",
    fill: "#FEFBF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.135 144.789L328.985 168.619H328.945L329.095 144.789H329.135Z",
    fill: "#FEFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.174 144.789L329.024 168.619H328.984L329.134 144.789H329.174Z",
    fill: "#FEFAEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.213 144.789L329.063 168.619H329.023L329.173 144.789H329.213Z",
    fill: "#FEFAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.253 144.789L329.103 168.619H329.062L329.212 144.789H329.253Z",
    fill: "#FDFAEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.295 144.789L329.145 168.619H329.105L329.255 144.789H329.295Z",
    fill: "#FDF9EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.335 144.789L329.185 168.619H329.145L329.295 144.789H329.335Z",
    fill: "#FDF9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.374 144.789L329.224 168.619H329.184L329.334 144.789H329.374Z",
    fill: "#FDF9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.413 144.789L329.263 168.619H329.223L329.373 144.789H329.413Z",
    fill: "#FDF8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.456 144.789L329.306 168.619H329.266L329.416 144.789H329.456Z",
    fill: "#FDF8E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.495 144.789L329.345 168.619H329.305L329.455 144.789H329.495Z",
    fill: "#FDF8E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.534 144.789L329.384 168.619H329.344L329.494 144.789H329.534Z",
    fill: "#FDF8E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.573 144.789L329.423 168.619H329.383L329.533 144.789H329.573Z",
    fill: "#FDF7E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.626 144.789L329.476 168.619H329.426L329.576 144.789H329.626Z",
    fill: "#FDF7E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.663 144.789L329.513 168.619H329.473L329.623 144.789H329.663Z",
    fill: "#FDF7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.706 144.789L329.556 168.619H329.516L329.666 144.789H329.706Z",
    fill: "#FDF7E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.745 144.789L329.595 168.619H329.555L329.705 144.789H329.745Z",
    fill: "#FDF6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.784 144.789L329.634 168.619H329.594L329.744 144.789H329.784Z",
    fill: "#FCF6DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.823 144.789L329.673 168.619H329.633L329.783 144.789H329.823Z",
    fill: "#FCF6DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.866 144.789L329.716 168.619H329.676L329.826 144.789H329.866Z",
    fill: "#FCF5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.905 144.789L329.755 168.619H329.715L329.865 144.789H329.905Z",
    fill: "#FCF5DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.944 144.789L329.794 168.619H329.754L329.904 144.789H329.944Z",
    fill: "#FCF5DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.983 144.789L329.833 168.619H329.793L329.943 144.789H329.983Z",
    fill: "#FCF5DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.026 144.789L329.876 168.619H329.836L329.986 144.789H330.026Z",
    fill: "#FCF4D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.065 144.789L329.915 168.619H329.875L330.025 144.789H330.065Z",
    fill: "#FCF4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.104 144.789L329.954 168.619H329.914L330.064 144.789H330.104Z",
    fill: "#FCF4D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.143 144.789L329.993 168.619H329.953L330.103 144.789H330.143Z",
    fill: "#FCF3D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.186 144.789L330.036 168.619H329.996L330.146 144.789H330.186Z",
    fill: "#FCF3D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.225 144.789L330.075 168.619H330.035L330.185 144.789H330.225Z",
    fill: "#FCF3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.274 144.789L330.114 168.619H330.074L330.224 144.789H330.274Z",
    fill: "#FBF3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.313 144.789L330.163 168.619H330.113L330.273 144.789H330.313Z",
    fill: "#FBF2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.354 144.789L330.204 168.619H330.164L330.314 144.789H330.354Z",
    fill: "#FBF2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.393 144.789L330.243 168.619H330.203L330.353 144.789H330.393Z",
    fill: "#FBF2D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.436 144.789L330.286 168.619H330.246L330.396 144.789H330.436Z",
    fill: "#FBF1CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.475 144.789L330.325 168.619H330.285L330.435 144.789H330.475Z",
    fill: "#FBF1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.514 144.789L330.364 168.619H330.324L330.474 144.789H330.514Z",
    fill: "#FBF1CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.553 144.789L330.403 168.619H330.363L330.513 144.789H330.553Z",
    fill: "#FBF1CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.592 144.789L330.442 168.619H330.402L330.552 144.789H330.592Z",
    fill: "#FBF0CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.635 144.789L330.485 168.619H330.445L330.595 144.789H330.635Z",
    fill: "#FBF0CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.674 144.789L330.524 168.619H330.484L330.634 144.789H330.674Z",
    fill: "#FBF0C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.713 144.789L330.563 168.619H330.523L330.673 144.789H330.713Z",
    fill: "#FBEFC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.753 144.789L330.603 168.619H330.562L330.712 144.789H330.753Z",
    fill: "#FBEFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.795 144.789L330.645 168.619H330.605L330.755 144.789H330.795Z",
    fill: "#FAEFC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.835 144.789L330.685 168.619H330.645L330.795 144.789H330.835Z",
    fill: "#FAEFC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.874 144.789L330.724 168.619H330.684L330.834 144.789H330.874Z",
    fill: "#FAEEC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.913 144.789L330.763 168.619H330.723L330.873 144.789H330.913Z",
    fill: "#FAEEC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.966 144.789L330.806 168.619H330.766L330.916 144.789H330.966Z",
    fill: "#FAEEC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.005 144.789L330.855 168.619H330.805L330.965 144.789H331.005Z",
    fill: "#FAEDC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.045 144.789L330.895 168.619H330.855L331.005 144.789H331.045Z",
    fill: "#FAEDC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.085 144.789L330.935 168.619H330.895L331.045 144.789H331.085Z",
    fill: "#FAEDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.124 144.789L330.974 168.619H330.934L331.084 144.789H331.124Z",
    fill: "#FAEDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.163 144.789L331.013 168.619H330.973L331.123 144.789H331.163Z",
    fill: "#FAECBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.206 144.789L331.056 168.619H331.016L331.166 144.789H331.206Z",
    fill: "#FAECBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.245 144.789L331.095 168.619H331.055L331.205 144.789H331.245Z",
    fill: "#FAECBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.284 144.789L331.134 168.619H331.094L331.244 144.789H331.284Z",
    fill: "#FAEBBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.323 144.789L331.173 168.619H331.133L331.283 144.789H331.323Z",
    fill: "#F9EBB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.366 144.789L331.216 168.619H331.176L331.326 144.789H331.366Z",
    fill: "#F9EBB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.405 144.789L331.255 168.619H331.215L331.365 144.789H331.405Z",
    fill: "#F9EBB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.444 144.789L331.294 168.619H331.254L331.404 144.789H331.444Z",
    fill: "#F9EAB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.483 144.789L331.333 168.619H331.293L331.443 144.789H331.483Z",
    fill: "#F9EAB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.526 144.789L331.376 168.619H331.336L331.486 144.789H331.526Z",
    fill: "#F9EAB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.565 144.789L331.415 168.619H331.375L331.525 144.789H331.565Z",
    fill: "#F9E9B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.604 144.789L331.454 168.619H331.414L331.564 144.789H331.604Z",
    fill: "#F9E9B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.653 144.789L331.493 168.619H331.453L331.603 144.789H331.653Z",
    fill: "#F9E9B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.696 144.789L331.546 168.619H331.496L331.656 144.789H331.696Z",
    fill: "#F9E9B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.733 144.789L331.583 168.619H331.543L331.693 144.789H331.733Z",
    fill: "#F9E8AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.776 144.789L331.626 168.619H331.586L331.736 144.789H331.776Z",
    fill: "#F9E8AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.815 144.789L331.665 168.619H331.625L331.775 144.789H331.815Z",
    fill: "#F8E8AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.854 144.789L331.704 168.619H331.664L331.814 144.789H331.854Z",
    fill: "#F8E7AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.893 144.789L331.743 168.619H331.703L331.853 144.789H331.893Z",
    fill: "#F8E7AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.936 144.789L331.786 168.619H331.746L331.896 144.789H331.936Z",
    fill: "#F8E7AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.975 144.789L331.825 168.619H331.785L331.935 144.789H331.975Z",
    fill: "#F8E7A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.014 144.789L331.864 168.619H331.824L331.974 144.789H332.014Z",
    fill: "#F8E6A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.053 144.789L331.903 168.619H331.863L332.013 144.789H332.053Z",
    fill: "#F8E6A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.092 144.789L331.942 168.619H331.902L332.052 144.789H332.092Z",
    fill: "#F8E6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.135 144.789L331.985 168.619H331.945L332.095 144.789H332.135Z",
    fill: "#F8E6A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.174 144.789L332.024 168.619H331.984L332.134 144.789H332.174Z",
    fill: "#F8E5A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.213 144.789L332.063 168.619H332.023L332.173 144.789H332.213Z",
    fill: "#F8E5A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.253 144.789L332.103 168.619H332.062L332.212 144.789H332.253Z",
    fill: "#F8E5A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.295 144.789L332.145 168.619H332.105L332.255 144.789H332.295Z",
    fill: "#F8E4A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.345 144.789L332.195 168.619H332.145L332.295 144.789H332.345Z",
    fill: "#F7E4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.385 144.789L332.235 168.619H332.195L332.345 144.789H332.385Z",
    fill: "#F7E49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.424 144.789L332.274 168.619H332.234L332.384 144.789H332.424Z",
    fill: "#F7E49E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.463 144.789L332.313 168.619H332.273L332.423 144.789H332.463Z",
    fill: "#F7E39D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.503 144.789L332.353 168.619H332.312L332.462 144.789H332.503Z",
    fill: "#F7E39C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.545 144.789L332.395 168.619H332.355L332.505 144.789H332.545Z",
    fill: "#F7E39B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.585 144.789L332.435 168.619H332.395L332.545 144.789H332.585Z",
    fill: "#F7E29A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.624 144.789L332.474 168.619H332.434L332.584 144.789H332.624Z",
    fill: "#F7E299"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.663 144.789L332.513 168.619H332.473L332.623 144.789H332.663Z",
    fill: "#F7E298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.706 144.789L332.556 168.619H332.516L332.666 144.789H332.706Z",
    fill: "#F7E297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.745 144.789L332.595 168.619H332.555L332.705 144.789H332.745Z",
    fill: "#F7E196"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.784 144.789L332.634 168.619H332.594L332.744 144.789H332.784Z",
    fill: "#F7E195"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.823 144.789L332.673 168.619H332.633L332.783 144.789H332.823Z",
    fill: "#F6E194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.866 144.789L332.716 168.619H332.676L332.826 144.789H332.866Z",
    fill: "#F6E093"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.905 144.789L332.755 168.619H332.715L332.865 144.789H332.905Z",
    fill: "#F6E092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.944 144.789L332.794 168.619H332.754L332.904 144.789H332.944Z",
    fill: "#F6E091"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.993 144.789L332.833 168.619H332.793L332.943 144.789H332.993Z",
    fill: "#F6E090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.036 144.789L332.886 168.619H332.836L332.996 144.789H333.036Z",
    fill: "#F6DF8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.073 144.789L332.923 168.619H332.883L333.033 144.789H333.073Z",
    fill: "#F6DF8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.116 144.789L332.966 168.619H332.926L333.076 144.789H333.116Z",
    fill: "#F6DF8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.155 144.789L333.005 168.619H332.965L333.115 144.789H333.155Z",
    fill: "#F6DE8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.194 144.789L333.044 168.619H333.004L333.154 144.789H333.194Z",
    fill: "#F6DE8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.233 144.789L333.083 168.619H333.043L333.193 144.789H333.233Z",
    fill: "#F6DE89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.276 144.789L333.126 168.619H333.086L333.236 144.789H333.276Z",
    fill: "#F6DE88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.315 144.789L333.165 168.619H333.125L333.275 144.789H333.315Z",
    fill: "#F6DD87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.354 144.789L333.204 168.619H333.164L333.314 144.789H333.354Z",
    fill: "#F5DD86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.393 144.789L333.243 168.619H333.203L333.353 144.789H333.393Z",
    fill: "#F5DD85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.436 144.789L333.286 168.619H333.246L333.396 144.789H333.436Z",
    fill: "#F5DC84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.475 144.789L333.325 168.619H333.285L333.435 144.789H333.475Z",
    fill: "#F5DC83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.514 144.789L333.364 168.619H333.324L333.474 144.789H333.514Z",
    fill: "#F5DC82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.553 144.789L333.403 168.619H333.363L333.513 144.789H333.553Z",
    fill: "#F5DC81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.592 144.789L333.442 168.619H333.402L333.552 144.789H333.592Z",
    fill: "#F5DB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.635 144.789L333.485 168.619H333.445L333.595 144.789H333.635Z",
    fill: "#F5DB7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.684 144.789L333.524 168.619H333.484L333.634 144.789H333.684Z",
    fill: "#F5DB7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.723 144.789L333.573 168.619H333.523L333.683 144.789H333.723Z",
    fill: "#F5DA7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.764 144.789L333.614 168.619H333.574L333.724 144.789H333.764Z",
    fill: "#F5DA7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.803 144.789L333.653 168.619H333.613L333.763 144.789H333.803Z",
    fill: "#F5DA7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.842 144.789L333.692 168.619H333.652L333.802 144.789H333.842Z",
    fill: "#F4DA7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.885 144.789L333.735 168.619H333.695L333.845 144.789H333.885Z",
    fill: "#F4D979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.924 144.789L333.774 168.619H333.734L333.884 144.789H333.924Z",
    fill: "#F4D978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.963 144.789L333.813 168.619H333.773L333.923 144.789H333.963Z",
    fill: "#F4D977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.003 144.789L333.853 168.619H333.812L333.962 144.789H334.003Z",
    fill: "#F4D876"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.045 144.789L333.895 168.619H333.855L334.005 144.789H334.045Z",
    fill: "#F4D875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.085 144.789L333.935 168.619H333.895L334.045 144.789H334.085Z",
    fill: "#F4D874"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.124 144.789L333.974 168.619H333.934L334.084 144.789H334.124Z",
    fill: "#F4D873"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.163 144.789L334.013 168.619H333.973L334.123 144.789H334.163Z",
    fill: "#F4D772"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.206 144.789L334.056 168.619H334.016L334.166 144.789H334.206Z",
    fill: "#F4D771"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.245 144.789L334.095 168.619H334.055L334.205 144.789H334.245Z",
    fill: "#F4D770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.284 144.789L334.134 168.619H334.094L334.244 144.789H334.284Z",
    fill: "#F4D76F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.323 144.789L334.173 168.619H334.133L334.283 144.789H334.323Z",
    fill: "#F4D66E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.376 144.789L334.216 168.619H334.176L334.326 144.789H334.376Z",
    fill: "#F3D66D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.415 144.789L334.265 168.619H334.215L334.375 144.789H334.415Z",
    fill: "#F3D66C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.456 144.789L334.306 168.619H334.266L334.416 144.789H334.456Z",
    fill: "#F3D56B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.495 144.789L334.345 168.619H334.305L334.455 144.789H334.495Z",
    fill: "#F3D56A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.534 144.789L334.384 168.619H334.344L334.494 144.789H334.534Z",
    fill: "#F3D569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.573 144.789L334.423 168.619H334.383L334.533 144.789H334.573Z",
    fill: "#F3D568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.616 144.789L334.466 168.619H334.426L334.576 144.789H334.616Z",
    fill: "#F3D467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.655 144.789L334.505 168.619H334.465L334.615 144.789H334.655Z",
    fill: "#F3D466"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.694 144.789L334.544 168.619H334.504L334.654 144.789H334.694Z",
    fill: "#F3D465"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.733 144.789L334.583 168.619H334.543L334.693 144.789H334.733Z",
    fill: "#F3D364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.776 144.789L334.626 168.619H334.586L334.736 144.789H334.776Z",
    fill: "#F3D363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.815 144.789L334.665 168.619H334.625L334.775 144.789H334.815Z",
    fill: "#F3D362"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.854 144.789L334.704 168.619H334.664L334.814 144.789H334.854Z",
    fill: "#F2D361"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.893 144.789L334.743 168.619H334.703L334.853 144.789H334.893Z",
    fill: "#F2D260"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.936 144.789L334.786 168.619H334.746L334.896 144.789H334.936Z",
    fill: "#F2D25F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.975 144.789L334.825 168.619H334.785L334.935 144.789H334.975Z",
    fill: "#F2D25E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.014 144.789L334.864 168.619H334.824L334.974 144.789H335.014Z",
    fill: "#F2D15D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.063 144.789L334.913 168.619H334.863L335.013 144.789H335.063Z",
    fill: "#F2D15C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.104 144.789L334.954 168.619H334.914L335.064 144.789H335.104Z",
    fill: "#F2D15B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.143 144.789L334.993 168.619H334.953L335.103 144.789H335.143Z",
    fill: "#F2D15A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.186 144.789L335.036 168.619H334.996L335.146 144.789H335.186Z",
    fill: "#F2D059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.225 144.789L335.075 168.619H335.035L335.185 144.789H335.225Z",
    fill: "#F2D058"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.264 144.789L335.114 168.619H335.074L335.224 144.789H335.264Z",
    fill: "#F2D057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.303 144.789L335.153 168.619H335.113L335.263 144.789H335.303Z",
    fill: "#F2CF56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.342 144.789L335.192 168.619H335.152L335.302 144.789H335.342Z",
    fill: "#F2CF55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.385 144.789L335.235 168.619H335.195L335.345 144.789H335.385Z",
    fill: "#F1CF54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.424 144.789L335.274 168.619H335.234L335.384 144.789H335.424Z",
    fill: "#F1CF53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.463 144.789L335.313 168.619H335.273L335.423 144.789H335.463Z",
    fill: "#F1CE52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.503 144.789L335.353 168.619H335.312L335.462 144.789H335.503Z",
    fill: "#F1CE51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.545 144.789L335.395 168.619H335.355L335.505 144.789H335.545Z",
    fill: "#F1CE50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.585 144.789L335.435 168.619H335.395L335.545 144.789H335.585Z",
    fill: "#F1CD4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.624 144.789L335.474 168.619H335.434L335.584 144.789H335.624Z",
    fill: "#F1CD4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.663 144.789L335.513 168.619H335.473L335.623 144.789H335.663Z",
    fill: "#F1CD4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.716 144.789L335.556 168.619H335.516L335.666 144.789H335.716Z",
    fill: "#F1CD4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.755 144.789L335.605 168.619H335.555L335.715 144.789H335.755Z",
    fill: "#F1CC4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.795 144.789L335.645 168.619H335.605L335.755 144.789H335.795Z",
    fill: "#F1CC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.835 144.789L335.685 168.619H335.645L335.795 144.789H335.835Z",
    fill: "#F1CC49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.874 144.789L335.724 168.619H335.684L335.834 144.789H335.874Z",
    fill: "#F1CB48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.913 144.789L335.763 168.619H335.723L335.873 144.789H335.913Z",
    fill: "#F0CB47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.956 144.789L335.806 168.619H335.766L335.916 144.789H335.956Z",
    fill: "#F0CB46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.995 144.789L335.845 168.619H335.805L335.955 144.789H335.995Z",
    fill: "#F0CB45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.034 144.789L335.884 168.619H335.844L335.994 144.789H336.034Z",
    fill: "#F0CA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.073 144.789L335.923 168.619H335.883L336.033 144.789H336.073Z",
    fill: "#F0CA43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.116 144.789L335.966 168.619H335.926L336.076 144.789H336.116Z",
    fill: "#F0CA42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.155 144.789L336.005 168.619H335.965L336.115 144.789H336.155Z",
    fill: "#F0C941"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.194 144.789L336.044 168.619H336.004L336.154 144.789H336.194Z",
    fill: "#F0C940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.233 144.789L336.083 168.619H336.043L336.193 144.789H336.233Z",
    fill: "#F0C93F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.276 144.789L336.126 168.619H336.086L336.236 144.789H336.276Z",
    fill: "#F0C93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.315 144.789L336.165 168.619H336.125L336.275 144.789H336.315Z",
    fill: "#F0C83D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.354 144.789L336.204 168.619H336.164L336.314 144.789H336.354Z",
    fill: "#F0C83C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.403 144.789L336.243 168.619H336.203L336.353 144.789H336.403Z",
    fill: "#EFC83B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.446 144.789L336.296 168.619H336.246L336.406 144.789H336.446Z",
    fill: "#EFC73A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.483 144.789L336.333 168.619H336.293L336.443 144.789H336.483Z",
    fill: "#EFC739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.526 144.789L336.376 168.619H336.336L336.486 144.789H336.526Z",
    fill: "#EFC738"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.565 144.789L336.415 168.619H336.375L336.525 144.789H336.565Z",
    fill: "#EFC737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.604 144.789L336.454 168.619H336.414L336.564 144.789H336.604Z",
    fill: "#EFC636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.643 144.789L336.493 168.619H336.453L336.603 144.789H336.643Z",
    fill: "#EFC635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.686 144.789L336.536 168.619H336.496L336.646 144.789H336.686Z",
    fill: "#EFC634"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.725 144.789L336.575 168.619H336.535L336.685 144.789H336.725Z",
    fill: "#EFC633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.764 144.789L336.614 168.619H336.574L336.724 144.789H336.764Z",
    fill: "#EFC532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.803 144.789L336.653 168.619H336.613L336.763 144.789H336.803Z",
    fill: "#EFC531"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.842 144.789L336.692 168.619H336.652L336.802 144.789H336.842Z",
    fill: "#EFC530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.885 144.789L336.735 168.619H336.695L336.845 144.789H336.885Z",
    fill: "#EFC42F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.924 144.789L336.774 168.619H336.734L336.884 144.789H336.924Z",
    fill: "#EEC42E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.963 144.789L336.813 168.619H336.773L336.923 144.789H336.963Z",
    fill: "#EEC42D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.003 144.789L336.853 168.619H336.812L336.962 144.789H337.003Z",
    fill: "#EEC42C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.045 144.789L336.895 168.619H336.855L337.005 144.789H337.045Z",
    fill: "#EEC32B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.095 144.789L336.945 168.619H336.895L337.045 144.789H337.095Z",
    fill: "#EEC32A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.135 144.789L336.985 168.619H336.945L337.095 144.789H337.135Z",
    fill: "#EEC329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.174 144.789L337.024 168.619H336.984L337.134 144.789H337.174Z",
    fill: "#EEC228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.213 144.789L337.063 168.619H337.023L337.173 144.789H337.213Z",
    fill: "#EEC227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.253 144.789L337.103 168.619H337.062L337.212 144.789H337.253Z",
    fill: "#EEC226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.295 144.789L337.145 168.619H337.105L337.255 144.789H337.295Z",
    fill: "#EEC225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.335 144.789L337.185 168.619H337.145L337.295 144.789H337.335Z",
    fill: "#EEC124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.374 144.789L337.224 168.619H337.184L337.334 144.789H337.374Z",
    fill: "#EEC123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.413 144.789L337.263 168.619H337.223L337.373 144.789H337.413Z",
    fill: "#EDC122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.456 144.789L337.306 168.619H337.266L337.416 144.789H337.456Z",
    fill: "#EDC021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.495 144.789L337.345 168.619H337.305L337.455 144.789H337.495Z",
    fill: "#EDC020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.504 149.319L337.384 168.619H337.344L337.494 144.789H337.504V149.319Z",
    fill: "#EDC01F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.503 155.75L337.423 168.62H337.383L337.503 149.32V155.75Z",
    fill: "#EDC01E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.506 162.18L337.466 168.62H337.426L337.506 155.75V162.18Z",
    fill: "#EDBF1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.505 168.61V168.62H337.465L337.505 162.18V168.61Z",
    fill: "#EDBF1C"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_90771_36502",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 337,
    y: 144,
    width: 12,
    height: 25
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M337.893 168.558C338.683 168.598 339.883 168.558 341.243 168.108C343.863 167.238 345.313 165.378 345.983 164.478C348.423 161.258 348.433 157.708 348.423 156.418C348.413 155.328 348.333 152.198 346.333 149.258C345.123 147.478 343.693 146.498 343.383 146.288C342.153 145.468 341.103 145.148 340.873 145.078C339.913 144.798 339.083 144.738 338.493 144.738C339.493 144.918 342.903 145.668 345.413 148.768C347.433 151.268 347.753 153.908 347.863 154.928C348.433 160.278 345.463 166.048 341.343 167.818C340.013 168.388 338.773 168.528 337.883 168.538L337.893 168.558Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_90771_36502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.454 161.04L348.344 144.75H348.454V161.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.455 168.44L348.305 144.75H348.345L348.455 161.04V168.44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.404 168.6L348.254 144.75H348.304L348.454 168.44V168.6H348.404Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.353 168.6L348.203 144.75H348.253L348.403 168.6H348.353Z",
    fill: "#FFFEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.314 168.6L348.164 144.75H348.204L348.354 168.6H348.314Z",
    fill: "#FFFEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.263 168.6L348.113 144.75H348.163L348.313 168.6H348.263Z",
    fill: "#FFFEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.216 168.6L348.066 144.75H348.116L348.266 168.6H348.216Z",
    fill: "#FFFEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.173 168.6L348.023 144.75H348.063L348.213 168.6H348.173Z",
    fill: "#FFFDF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.123 168.6L347.973 144.75H348.023L348.173 168.6H348.123Z",
    fill: "#FEFDF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.076 168.6L347.926 144.75H347.976L348.126 168.6H348.076Z",
    fill: "#FEFDF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.033 168.6L347.883 144.75H347.923L348.073 168.6H348.033Z",
    fill: "#FEFCF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.986 168.6L347.836 144.75H347.886L348.036 168.6H347.986Z",
    fill: "#FEFCF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.935 168.6L347.785 144.75H347.835L347.985 168.6H347.935Z",
    fill: "#FEFCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.896 168.6L347.746 144.75H347.786L347.936 168.6H347.896Z",
    fill: "#FEFCF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.845 168.6L347.695 144.75H347.745L347.895 168.6H347.845Z",
    fill: "#FEFBF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.795 168.6L347.645 144.75H347.695L347.845 168.6H347.795Z",
    fill: "#FEFBF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.754 168.6L347.594 144.75H347.644L347.794 168.6H347.754Z",
    fill: "#FEFBF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.705 168.6L347.555 144.75H347.595L347.755 168.6H347.705Z",
    fill: "#FEFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.654 168.6L347.504 144.75H347.554L347.704 168.6H347.654Z",
    fill: "#FEFAEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.613 168.6L347.453 144.75H347.503L347.653 168.6H347.613Z",
    fill: "#FEFAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.564 168.6L347.414 144.75H347.454L347.614 168.6H347.564Z",
    fill: "#FDFAEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.513 168.6L347.363 144.75H347.413L347.563 168.6H347.513Z",
    fill: "#FDF9EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.476 168.6L347.316 144.75H347.366L347.516 168.6H347.476Z",
    fill: "#FDF9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.423 168.6L347.273 144.75H347.313L347.473 168.6H347.423Z",
    fill: "#FDF9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.373 168.6L347.223 144.75H347.273L347.423 168.6H347.373Z",
    fill: "#FDF8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.326 168.6L347.176 144.75H347.226L347.376 168.6H347.326Z",
    fill: "#FDF8E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.283 168.6L347.133 144.75H347.173L347.323 168.6H347.283Z",
    fill: "#FDF8E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.236 168.6L347.086 144.75H347.136L347.286 168.6H347.236Z",
    fill: "#FDF8E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.185 168.6L347.035 144.75H347.085L347.235 168.6H347.185Z",
    fill: "#FDF7E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.146 168.6L346.996 144.75H347.036L347.186 168.6H347.146Z",
    fill: "#FDF7E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.095 168.6L346.945 144.75H346.995L347.145 168.6H347.095Z",
    fill: "#FDF7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.045 168.6L346.895 144.75H346.945L347.095 168.6H347.045Z",
    fill: "#FDF7E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.005 168.6L346.855 144.75H346.895L347.045 168.6H347.005Z",
    fill: "#FDF6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.955 168.6L346.805 144.75H346.855L347.005 168.6H346.955Z",
    fill: "#FCF6DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.904 168.6L346.754 144.75H346.804L346.954 168.6H346.904Z",
    fill: "#FCF6DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.865 168.6L346.715 144.75H346.755L346.905 168.6H346.865Z",
    fill: "#FCF5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.814 168.6L346.664 144.75H346.714L346.864 168.6H346.814Z",
    fill: "#FCF5DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.763 168.6L346.613 144.75H346.663L346.813 168.6H346.763Z",
    fill: "#FCF5DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.724 168.6L346.574 144.75H346.614L346.764 168.6H346.724Z",
    fill: "#FCF5DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.673 168.6L346.523 144.75H346.573L346.723 168.6H346.673Z",
    fill: "#FCF4D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.623 168.6L346.473 144.75H346.523L346.673 168.6H346.623Z",
    fill: "#FCF4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.584 168.6L346.434 144.75H346.474L346.624 168.6H346.584Z",
    fill: "#FCF4D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.533 168.6L346.383 144.75H346.433L346.583 168.6H346.533Z",
    fill: "#FCF3D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.486 168.6L346.336 144.75H346.386L346.536 168.6H346.486Z",
    fill: "#FCF3D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.443 168.6L346.293 144.75H346.333L346.483 168.6H346.443Z",
    fill: "#FCF3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.396 168.6L346.246 144.75H346.296L346.446 168.6H346.396Z",
    fill: "#FBF3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.345 168.6L346.195 144.75H346.245L346.395 168.6H346.345Z",
    fill: "#FBF2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.306 168.6L346.156 144.75H346.196L346.346 168.6H346.306Z",
    fill: "#FBF2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.255 168.6L346.105 144.75H346.155L346.305 168.6H346.255Z",
    fill: "#FBF2D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.205 168.6L346.055 144.75H346.105L346.255 168.6H346.205Z",
    fill: "#FBF1CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.166 168.6L346.016 144.75H346.056L346.206 168.6H346.166Z",
    fill: "#FBF1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.115 168.6L345.965 144.75H346.015L346.165 168.6H346.115Z",
    fill: "#FBF1CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.064 168.6L345.914 144.75H345.964L346.114 168.6H346.064Z",
    fill: "#FBF1CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.025 168.6L345.875 144.75H345.915L346.065 168.6H346.025Z",
    fill: "#FBF0CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.974 168.6L345.824 144.75H345.874L346.024 168.6H345.974Z",
    fill: "#FBF0CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.923 168.6L345.773 144.75H345.823L345.973 168.6H345.923Z",
    fill: "#FBF0C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.884 168.6L345.734 144.75H345.774L345.924 168.6H345.884Z",
    fill: "#FBEFC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.834 168.6L345.684 144.75H345.734L345.884 168.6H345.834Z",
    fill: "#FBEFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.783 168.6L345.633 144.75H345.683L345.833 168.6H345.783Z",
    fill: "#FAEFC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.744 168.6L345.594 144.75H345.634L345.784 168.6H345.744Z",
    fill: "#FAEFC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.693 168.6L345.543 144.75H345.593L345.743 168.6H345.693Z",
    fill: "#FAEEC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.646 168.6L345.496 144.75H345.546L345.696 168.6H345.646Z",
    fill: "#FAEEC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.603 168.6L345.453 144.75H345.493L345.643 168.6H345.603Z",
    fill: "#FAEEC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.556 168.6L345.406 144.75H345.456L345.606 168.6H345.556Z",
    fill: "#FAEDC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.505 168.6L345.355 144.75H345.405L345.555 168.6H345.505Z",
    fill: "#FAEDC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.466 168.6L345.316 144.75H345.356L345.506 168.6H345.466Z",
    fill: "#FAEDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.416 168.6L345.266 144.75H345.316L345.466 168.6H345.416Z",
    fill: "#FAEDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.365 168.6L345.215 144.75H345.265L345.415 168.6H345.365Z",
    fill: "#FAECBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.326 168.6L345.176 144.75H345.216L345.366 168.6H345.326Z",
    fill: "#FAECBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.275 168.6L345.125 144.75H345.175L345.325 168.6H345.275Z",
    fill: "#FAECBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.224 168.6L345.074 144.75H345.124L345.274 168.6H345.224Z",
    fill: "#FAEBBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.185 168.6L345.035 144.75H345.075L345.225 168.6H345.185Z",
    fill: "#F9EBB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.134 168.6L344.984 144.75H345.034L345.184 168.6H345.134Z",
    fill: "#F9EBB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.084 168.6L344.934 144.75H344.984L345.134 168.6H345.084Z",
    fill: "#F9EBB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.045 168.6L344.895 144.75H344.935L345.085 168.6H345.045Z",
    fill: "#F9EAB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.994 168.6L344.844 144.75H344.894L345.044 168.6H344.994Z",
    fill: "#F9EAB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.943 168.6L344.793 144.75H344.843L344.993 168.6H344.943Z",
    fill: "#F9EAB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.904 168.6L344.754 144.75H344.794L344.944 168.6H344.904Z",
    fill: "#F9E9B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.853 168.6L344.703 144.75H344.753L344.903 168.6H344.853Z",
    fill: "#F9E9B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.806 168.6L344.656 144.75H344.706L344.856 168.6H344.806Z",
    fill: "#F9E9B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.765 168.6L344.605 144.75H344.655L344.805 168.6H344.765Z",
    fill: "#F9E9B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.716 168.6L344.566 144.75H344.606L344.766 168.6H344.716Z",
    fill: "#F9E8AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.666 168.6L344.516 144.75H344.566L344.716 168.6H344.666Z",
    fill: "#F9E8AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.625 168.6L344.465 144.75H344.515L344.665 168.6H344.625Z",
    fill: "#F8E8AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.576 168.6L344.426 144.75H344.466L344.626 168.6H344.576Z",
    fill: "#F8E7AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.525 168.6L344.375 144.75H344.425L344.575 168.6H344.525Z",
    fill: "#F8E7AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.484 168.6L344.324 144.75H344.374L344.524 168.6H344.484Z",
    fill: "#F8E7AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.435 168.6L344.285 144.75H344.325L344.485 168.6H344.435Z",
    fill: "#F8E7A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.384 168.6L344.234 144.75H344.284L344.434 168.6H344.384Z",
    fill: "#F8E6A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.334 168.6L344.184 144.75H344.234L344.384 168.6H344.334Z",
    fill: "#F8E6A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.295 168.6L344.145 144.75H344.185L344.335 168.6H344.295Z",
    fill: "#F8E6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.244 168.6L344.094 144.75H344.144L344.294 168.6H344.244Z",
    fill: "#F8E6A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.193 168.6L344.043 144.75H344.093L344.243 168.6H344.193Z",
    fill: "#F8E5A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.154 168.6L344.004 144.75H344.044L344.194 168.6H344.154Z",
    fill: "#F8E5A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.103 168.6L343.953 144.75H344.003L344.153 168.6H344.103Z",
    fill: "#F8E5A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.056 168.6L343.906 144.75H343.956L344.106 168.6H344.056Z",
    fill: "#F8E4A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.013 168.6L343.863 144.75H343.903L344.053 168.6H344.013Z",
    fill: "#F7E4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.966 168.6L343.816 144.75H343.866L344.016 168.6H343.966Z",
    fill: "#F7E49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.916 168.6L343.766 144.75H343.816L343.966 168.6H343.916Z",
    fill: "#F7E49E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.873 168.6L343.723 144.75H343.763L343.913 168.6H343.873Z",
    fill: "#F7E39D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.826 168.6L343.676 144.75H343.726L343.876 168.6H343.826Z",
    fill: "#F7E39C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.775 168.6L343.625 144.75H343.675L343.825 168.6H343.775Z",
    fill: "#F7E39B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.736 168.6L343.586 144.75H343.626L343.776 168.6H343.736Z",
    fill: "#F7E29A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.685 168.6L343.535 144.75H343.585L343.735 168.6H343.685Z",
    fill: "#F7E299"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.634 168.6L343.484 144.75H343.534L343.684 168.6H343.634Z",
    fill: "#F7E298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.595 168.6L343.445 144.75H343.485L343.635 168.6H343.595Z",
    fill: "#F7E297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.545 168.6L343.395 144.75H343.445L343.595 168.6H343.545Z",
    fill: "#F7E196"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.494 168.6L343.344 144.75H343.394L343.544 168.6H343.494Z",
    fill: "#F7E195"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.455 168.6L343.305 144.75H343.345L343.495 168.6H343.455Z",
    fill: "#F6E194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.404 168.6L343.254 144.75H343.304L343.454 168.6H343.404Z",
    fill: "#F6E093"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.353 168.6L343.203 144.75H343.253L343.403 168.6H343.353Z",
    fill: "#F6E092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.314 168.6L343.164 144.75H343.204L343.354 168.6H343.314Z",
    fill: "#F6E091"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.263 168.6L343.113 144.75H343.163L343.313 168.6H343.263Z",
    fill: "#F6E090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.216 168.6L343.066 144.75H343.116L343.266 168.6H343.216Z",
    fill: "#F6DF8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.173 168.6L343.023 144.75H343.063L343.213 168.6H343.173Z",
    fill: "#F6DF8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.123 168.6L342.973 144.75H343.023L343.173 168.6H343.123Z",
    fill: "#F6DF8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.076 168.6L342.926 144.75H342.976L343.126 168.6H343.076Z",
    fill: "#F6DE8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.033 168.6L342.883 144.75H342.923L343.073 168.6H343.033Z",
    fill: "#F6DE8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.986 168.6L342.836 144.75H342.886L343.036 168.6H342.986Z",
    fill: "#F6DE89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.935 168.6L342.785 144.75H342.835L342.985 168.6H342.935Z",
    fill: "#F6DE88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.896 168.6L342.746 144.75H342.786L342.936 168.6H342.896Z",
    fill: "#F6DD87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.845 168.6L342.695 144.75H342.745L342.895 168.6H342.845Z",
    fill: "#F5DD86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.795 168.6L342.645 144.75H342.695L342.845 168.6H342.795Z",
    fill: "#F5DD85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.755 168.6L342.605 144.75H342.645L342.795 168.6H342.755Z",
    fill: "#F5DC84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.705 168.6L342.555 144.75H342.605L342.755 168.6H342.705Z",
    fill: "#F5DC83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.654 168.6L342.504 144.75H342.554L342.704 168.6H342.654Z",
    fill: "#F5DC82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.615 168.6L342.465 144.75H342.505L342.655 168.6H342.615Z",
    fill: "#F5DC81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.564 168.6L342.414 144.75H342.464L342.614 168.6H342.564Z",
    fill: "#F5DB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.513 168.6L342.363 144.75H342.413L342.563 168.6H342.513Z",
    fill: "#F5DB7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.474 168.6L342.324 144.75H342.364L342.514 168.6H342.474Z",
    fill: "#F5DB7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.423 168.6L342.273 144.75H342.323L342.473 168.6H342.423Z",
    fill: "#F5DA7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.373 168.6L342.223 144.75H342.273L342.423 168.6H342.373Z",
    fill: "#F5DA7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.334 168.6L342.184 144.75H342.224L342.374 168.6H342.334Z",
    fill: "#F5DA7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.283 168.6L342.133 144.75H342.183L342.333 168.6H342.283Z",
    fill: "#F4DA7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.236 168.6L342.086 144.75H342.136L342.286 168.6H342.236Z",
    fill: "#F4D979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.193 168.6L342.043 144.75H342.083L342.233 168.6H342.193Z",
    fill: "#F4D978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.146 168.6L341.996 144.75H342.046L342.196 168.6H342.146Z",
    fill: "#F4D977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.095 168.6L341.945 144.75H341.995L342.145 168.6H342.095Z",
    fill: "#F4D876"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.056 168.6L341.906 144.75H341.946L342.096 168.6H342.056Z",
    fill: "#F4D875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.005 168.6L341.855 144.75H341.905L342.055 168.6H342.005Z",
    fill: "#F4D874"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.955 168.6L341.805 144.75H341.855L342.005 168.6H341.955Z",
    fill: "#F4D873"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.914 168.6L341.754 144.75H341.804L341.954 168.6H341.914Z",
    fill: "#F4D772"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.865 168.6L341.715 144.75H341.755L341.915 168.6H341.865Z",
    fill: "#F4D771"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.814 168.6L341.664 144.75H341.714L341.864 168.6H341.814Z",
    fill: "#F4D770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.773 168.6L341.613 144.75H341.663L341.813 168.6H341.773Z",
    fill: "#F4D76F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.724 168.6L341.574 144.75H341.614L341.774 168.6H341.724Z",
    fill: "#F4D66E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.673 168.6L341.523 144.75H341.573L341.723 168.6H341.673Z",
    fill: "#F3D66D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.633 168.6L341.473 144.75H341.523L341.673 168.6H341.633Z",
    fill: "#F3D66C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.584 168.6L341.434 144.75H341.474L341.634 168.6H341.584Z",
    fill: "#F3D56B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.533 168.6L341.383 144.75H341.433L341.583 168.6H341.533Z",
    fill: "#F3D56A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.486 168.6L341.336 144.75H341.386L341.536 168.6H341.486Z",
    fill: "#F3D569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.443 168.6L341.293 144.75H341.333L341.483 168.6H341.443Z",
    fill: "#F3D568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.396 168.6L341.246 144.75H341.296L341.446 168.6H341.396Z",
    fill: "#F3D467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.345 168.6L341.195 144.75H341.245L341.395 168.6H341.345Z",
    fill: "#F3D466"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.306 168.6L341.156 144.75H341.196L341.346 168.6H341.306Z",
    fill: "#F3D465"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.255 168.6L341.105 144.75H341.155L341.305 168.6H341.255Z",
    fill: "#F3D364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.205 168.6L341.055 144.75H341.105L341.255 168.6H341.205Z",
    fill: "#F3D363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.166 168.6L341.016 144.75H341.056L341.206 168.6H341.166Z",
    fill: "#F3D362"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.115 168.6L340.965 144.75H341.015L341.165 168.6H341.115Z",
    fill: "#F2D361"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.064 168.6L340.914 144.75H340.964L341.114 168.6H341.064Z",
    fill: "#F2D260"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.025 168.6L340.875 144.75H340.915L341.065 168.6H341.025Z",
    fill: "#F2D25F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.974 168.6L340.824 144.75H340.874L341.024 168.6H340.974Z",
    fill: "#F2D25E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.923 168.6L340.773 144.75H340.823L340.973 168.6H340.923Z",
    fill: "#F2D15D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.884 168.6L340.734 144.75H340.774L340.924 168.6H340.884Z",
    fill: "#F2D15C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.834 168.6L340.684 144.75H340.734L340.884 168.6H340.834Z",
    fill: "#F2D15B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.783 168.6L340.633 144.75H340.683L340.833 168.6H340.783Z",
    fill: "#F2D15A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.744 168.6L340.594 144.75H340.634L340.784 168.6H340.744Z",
    fill: "#F2D059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.693 168.6L340.543 144.75H340.593L340.743 168.6H340.693Z",
    fill: "#F2D058"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.646 168.6L340.496 144.75H340.546L340.696 168.6H340.646Z",
    fill: "#F2D057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.603 168.6L340.453 144.75H340.493L340.643 168.6H340.603Z",
    fill: "#F2CF56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.556 168.6L340.406 144.75H340.456L340.606 168.6H340.556Z",
    fill: "#F2CF55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.505 168.6L340.355 144.75H340.405L340.555 168.6H340.505Z",
    fill: "#F1CF54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.466 168.6L340.316 144.75H340.356L340.506 168.6H340.466Z",
    fill: "#F1CF53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.416 168.6L340.266 144.75H340.316L340.466 168.6H340.416Z",
    fill: "#F1CE52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.365 168.6L340.215 144.75H340.265L340.415 168.6H340.365Z",
    fill: "#F1CE51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.326 168.6L340.176 144.75H340.216L340.366 168.6H340.326Z",
    fill: "#F1CE50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.275 168.6L340.125 144.75H340.175L340.325 168.6H340.275Z",
    fill: "#F1CD4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.224 168.6L340.074 144.75H340.124L340.274 168.6H340.224Z",
    fill: "#F1CD4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.185 168.6L340.035 144.75H340.075L340.225 168.6H340.185Z",
    fill: "#F1CD4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.134 168.6L339.984 144.75H340.034L340.184 168.6H340.134Z",
    fill: "#F1CD4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.084 168.6L339.934 144.75H339.984L340.134 168.6H340.084Z",
    fill: "#F1CC4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.045 168.6L339.895 144.75H339.935L340.085 168.6H340.045Z",
    fill: "#F1CC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.994 168.6L339.844 144.75H339.894L340.044 168.6H339.994Z",
    fill: "#F1CC49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.943 168.6L339.793 144.75H339.843L339.993 168.6H339.943Z",
    fill: "#F1CB48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.904 168.6L339.754 144.75H339.794L339.944 168.6H339.904Z",
    fill: "#F0CB47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.853 168.6L339.703 144.75H339.753L339.903 168.6H339.853Z",
    fill: "#F0CB46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.806 168.6L339.656 144.75H339.706L339.856 168.6H339.806Z",
    fill: "#F0CB45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.763 168.6L339.613 144.75H339.653L339.803 168.6H339.763Z",
    fill: "#F0CA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.716 168.6L339.566 144.75H339.616L339.766 168.6H339.716Z",
    fill: "#F0CA43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.666 168.6L339.516 144.75H339.566L339.716 168.6H339.666Z",
    fill: "#F0CA42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.623 168.6L339.473 144.75H339.513L339.663 168.6H339.623Z",
    fill: "#F0C941"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.576 168.6L339.426 144.75H339.476L339.626 168.6H339.576Z",
    fill: "#F0C940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.525 168.6L339.375 144.75H339.425L339.575 168.6H339.525Z",
    fill: "#F0C93F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.486 168.6L339.336 144.75H339.376L339.526 168.6H339.486Z",
    fill: "#F0C93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.435 168.6L339.285 144.75H339.335L339.485 168.6H339.435Z",
    fill: "#F0C83D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.384 168.6L339.234 144.75H339.284L339.434 168.6H339.384Z",
    fill: "#F0C83C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.345 168.6L339.195 144.75H339.235L339.385 168.6H339.345Z",
    fill: "#EFC83B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.295 168.6L339.145 144.75H339.195L339.345 168.6H339.295Z",
    fill: "#EFC73A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.244 168.6L339.094 144.75H339.144L339.294 168.6H339.244Z",
    fill: "#EFC739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.205 168.6L339.055 144.75H339.095L339.245 168.6H339.205Z",
    fill: "#EFC738"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.154 168.6L339.004 144.75H339.054L339.204 168.6H339.154Z",
    fill: "#EFC737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.103 168.6L338.953 144.75H339.003L339.153 168.6H339.103Z",
    fill: "#EFC636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.064 168.6L338.914 144.75H338.954L339.104 168.6H339.064Z",
    fill: "#EFC635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.013 168.6L338.863 144.75H338.913L339.063 168.6H339.013Z",
    fill: "#EFC634"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.966 168.6L338.816 144.75H338.866L339.016 168.6H338.966Z",
    fill: "#EFC633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.926 168.6L338.766 144.75H338.816L338.966 168.6H338.926Z",
    fill: "#EFC532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.873 168.6L338.723 144.75H338.763L338.923 168.6H338.873Z",
    fill: "#EFC531"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.826 168.6L338.676 144.75H338.726L338.876 168.6H338.826Z",
    fill: "#EFC530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.785 168.6L338.625 144.75H338.675L338.825 168.6H338.785Z",
    fill: "#EFC42F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.736 168.6L338.586 144.75H338.626L338.786 168.6H338.736Z",
    fill: "#EEC42E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.685 168.6L338.535 144.75H338.585L338.735 168.6H338.685Z",
    fill: "#EEC42D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.644 168.6L338.484 144.75H338.534L338.684 168.6H338.644Z",
    fill: "#EEC42C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.595 168.6L338.445 144.75H338.485L338.645 168.6H338.595Z",
    fill: "#EEC32B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.545 168.6L338.395 144.75H338.445L338.595 168.6H338.545Z",
    fill: "#EEC32A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.494 168.6L338.344 144.75H338.394L338.544 168.6H338.494Z",
    fill: "#EEC329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.455 168.6L338.305 144.75H338.345L338.495 168.6H338.455Z",
    fill: "#EEC228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.404 168.6L338.254 144.75H338.304L338.454 168.6H338.404Z",
    fill: "#EEC227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.353 168.6L338.203 144.75H338.253L338.403 168.6H338.353Z",
    fill: "#EEC226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.314 168.6L338.164 144.75H338.204L338.354 168.6H338.314Z",
    fill: "#EEC225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.263 168.6L338.113 144.75H338.163L338.313 168.6H338.263Z",
    fill: "#EEC124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.216 168.6L338.066 144.75H338.116L338.266 168.6H338.216Z",
    fill: "#EEC123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.173 168.6L338.023 144.75H338.063L338.213 168.6H338.173Z",
    fill: "#EDC122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.123 168.6L337.973 144.75H338.023L338.173 168.6H338.123Z",
    fill: "#EDC021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.076 168.6L337.926 144.75H337.976L338.126 168.6H338.076Z",
    fill: "#EDC020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.035 168.6L337.895 146.35V144.75H337.925L338.075 168.6H338.035Z",
    fill: "#EDC01F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.985 168.602L337.895 153.752V146.352L338.035 168.602H337.985Z",
    fill: "#EDC01E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.935 168.6L337.895 161.15V153.75L337.985 168.6H337.935Z",
    fill: "#EDBF1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.895 168.598V168.558V161.148L337.935 168.598H337.895Z",
    fill: "#EDBF1C"
  })))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M343.019 160.377C344.189 161.917 347.439 165.757 353.169 167.697C358.089 169.367 362.329 168.777 364.259 168.387C364.129 169.047 363.999 169.707 363.859 170.367C362.209 170.917 357.589 172.227 352.079 170.567C345.739 168.657 342.439 164.097 341.539 162.747C342.029 161.957 342.529 161.167 343.019 160.367V160.377Z",
    fill: "#EDBF1C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_90771_36502",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 160,
    width: 24,
    height: 12
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M343.019 160.377C344.189 161.917 347.439 165.757 353.169 167.697C358.089 169.367 362.329 168.777 364.259 168.387C364.129 169.047 363.999 169.707 363.859 170.367C362.209 170.917 357.589 172.227 352.079 170.567C345.739 168.657 342.439 164.097 341.539 162.747C342.029 161.957 342.529 161.167 343.019 160.367V160.377Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_90771_36502)"
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M363.829 169.98C361.539 170.46 356.939 171.1 351.579 169.46C347.889 168.33 345.199 166.53 343.559 165.23C344.189 166.93 345.499 169.58 348.159 171.69C348.709 172.12 354.919 176.9 360.109 174.14C362.239 173.01 363.329 171.07 363.819 169.98H363.829Z",
    fill: "#E9AB21"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_90771_36502",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 345,
    y: 162,
    width: 21,
    height: 8
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M351.319 162.609C349.479 162.299 345.559 161.619 345.079 162.749C344.609 163.859 347.679 166.379 350.309 167.729C353.719 169.469 356.949 169.529 359.409 169.549C362.199 169.569 364.789 169.589 365.009 168.739C365.399 167.259 358.279 163.809 351.309 162.609H351.319Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_90771_36502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.609 163.98L355.109 169.58H344.609V163.98Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 163.91L355.239 169.58H355.109L344.609 163.98V163.91Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 163.84L355.379 169.58H355.239L344.609 163.91V163.84Z",
    fill: "#FFFEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 163.758L355.519 169.578H355.379L344.609 163.838V163.758Z",
    fill: "#FEFDF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 163.688L355.659 169.577H355.519L344.609 163.757V163.688Z",
    fill: "#FEFCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 163.609L355.789 169.579H355.659L344.609 163.689V163.609Z",
    fill: "#FEFBF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 163.539L355.929 169.579H355.789L344.609 163.609V163.539Z",
    fill: "#FEFAEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 163.469L356.069 169.579H355.929L344.609 163.539V163.469Z",
    fill: "#FDF9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 163.391L356.209 169.581H356.069L344.609 163.471V163.391Z",
    fill: "#FDF8E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 163.32L356.349 169.58H356.209L344.609 163.39V163.32Z",
    fill: "#FDF7E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 163.25L356.479 169.58H356.349L344.609 163.32V163.25Z",
    fill: "#FCF6DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 163.168L356.619 169.578H356.479L344.609 163.248V163.168Z",
    fill: "#FCF5DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 163.098L356.759 169.578H356.619L344.609 163.168V163.098Z",
    fill: "#FCF4D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 163.027L356.899 169.577H356.759L344.609 163.097V163.027Z",
    fill: "#FCF3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 162.949L357.029 169.579H356.899L344.609 163.029V162.949Z",
    fill: "#FBF2D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 162.879L357.169 169.579H357.029L344.609 162.949V162.879Z",
    fill: "#FBF1CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 162.809L357.309 169.579H357.169L344.609 162.879V162.809Z",
    fill: "#FBF0CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 162.73L357.449 169.58H357.309L344.609 162.81V162.73Z",
    fill: "#FBEFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 162.66L357.579 169.58H357.449L344.609 162.73V162.66Z",
    fill: "#FAEEC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 162.59L357.719 169.58H357.579L344.609 162.66V162.59Z",
    fill: "#FAEDC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 162.508L357.859 169.578H357.719L344.609 162.588V162.508Z",
    fill: "#FAEDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 162.438L357.999 169.577H357.859L344.609 162.507V162.438Z",
    fill: "#FAECBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 162.367L358.139 169.577H357.999L344.609 162.437V162.367Z",
    fill: "#F9EBB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 162.289L358.269 169.579H358.139L344.609 162.369V162.289Z",
    fill: "#F9EAB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 162.219L358.409 169.579H358.269L344.609 162.289V162.219Z",
    fill: "#F9E9B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 162.148L358.549 169.578H358.409L344.609 162.218V162.148Z",
    fill: "#F9E8AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 162.07L358.689 169.58H358.549L344.609 162.15V162.07Z",
    fill: "#F8E8AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 162L358.819 169.58H358.689L344.609 162.07V162Z",
    fill: "#F8E7A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 161.918L358.959 169.578H358.819L344.609 161.998V161.918Z",
    fill: "#F8E6A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 161.848L359.099 169.578H358.959L344.609 161.918V161.848Z",
    fill: "#F8E5A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 161.777L359.239 169.577H359.099L344.609 161.847V161.777Z",
    fill: "#F8E5A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 161.699L359.369 169.579H359.239L344.609 161.779V161.699Z",
    fill: "#F7E49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.609 161.629L359.509 169.579H359.369L344.609 161.699V161.629Z",
    fill: "#F7E39C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.739 161.629L359.649 169.579H359.509L344.609 161.629H344.739Z",
    fill: "#F7E29A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.878 161.629L359.788 169.579H359.648L344.738 161.629H344.878Z",
    fill: "#F7E297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.019 161.629L359.929 169.579H359.789L344.879 161.629H345.019Z",
    fill: "#F7E195"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.16 161.629L360.06 169.579H359.93L345.02 161.629H345.16Z",
    fill: "#F6E092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.29 161.629L360.2 169.579H360.06L345.16 161.629H345.29Z",
    fill: "#F6E090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.429 161.629L360.339 169.579H360.199L345.289 161.629H345.429Z",
    fill: "#F6DF8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.57 161.629L360.48 169.579H360.34L345.43 161.629H345.57Z",
    fill: "#F6DE8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.71 161.629L360.61 169.579H360.48L345.57 161.629H345.71Z",
    fill: "#F6DE89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.841 161.629L360.751 169.579H360.611L345.711 161.629H345.841Z",
    fill: "#F5DD87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.98 161.629L360.89 169.579H360.75L345.84 161.629H345.98Z",
    fill: "#F5DC85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.12 161.629L361.03 169.579H360.89L345.98 161.629H346.12Z",
    fill: "#F5DC82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.261 161.629L361.161 169.579H361.031L346.121 161.629H346.261Z",
    fill: "#F5DB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.398 161.629L361.298 169.579H361.158L346.258 161.629H346.398Z",
    fill: "#F5DB7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.528 161.629L361.438 169.579H361.298L346.398 161.629H346.528Z",
    fill: "#F5DA7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.671 161.629L361.581 169.579H361.441L346.531 161.629H346.671Z",
    fill: "#F4DA7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.808 161.629L361.718 169.579H361.578L346.668 161.629H346.808Z",
    fill: "#F4D978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.949 161.629L361.849 169.579H361.719L346.809 161.629H346.949Z",
    fill: "#F4D876"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.079 161.629L361.989 169.579H361.849L346.949 161.629H347.079Z",
    fill: "#F4D874"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.218 161.629L362.128 169.579H361.988L347.078 161.629H347.218Z",
    fill: "#F4D772"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.359 161.629L362.269 169.579H362.129L347.219 161.629H347.359Z",
    fill: "#F4D770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.499 161.629L362.399 169.579H362.269L347.359 161.629H347.499Z",
    fill: "#F4D66E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.63 161.629L362.54 169.579H362.4L347.5 161.629H347.63Z",
    fill: "#F3D66D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.769 161.629L362.679 169.579H362.539L347.629 161.629H347.769Z",
    fill: "#F3D56B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.91 161.629L362.82 169.579H362.68L347.77 161.629H347.91Z",
    fill: "#F3D569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.05 161.629L362.95 169.579H362.82L347.91 161.629H348.05Z",
    fill: "#F3D467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.191 161.629L363.091 169.579H362.951L348.051 161.629H348.191Z",
    fill: "#F3D466"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.318 161.629L363.228 169.579H363.087L348.188 161.629H348.318Z",
    fill: "#F3D364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.46 161.629L363.37 169.579H363.23L348.32 161.629H348.46Z",
    fill: "#F3D362"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.601 161.629L363.511 169.579H363.371L348.461 161.629H348.601Z",
    fill: "#F2D261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.738 161.629L363.638 169.579H363.508L348.598 161.629H348.738Z",
    fill: "#F2D25F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.868 161.629L363.778 169.579H363.638L348.738 161.629H348.868Z",
    fill: "#F2D15E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.011 161.629L363.921 169.579H363.781L348.871 161.629H349.011Z",
    fill: "#F2D15C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.148 161.629L364.058 169.579H363.918L349.008 161.629H349.148Z",
    fill: "#F2D15B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.288 161.629L364.188 169.579H364.058L349.148 161.629H349.288Z",
    fill: "#F2D059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.419 161.629L364.329 169.579H364.189L349.289 161.629H349.419Z",
    fill: "#F2D058"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.558 161.629L364.468 169.579H364.328L349.418 161.629H349.558Z",
    fill: "#F2CF56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.699 161.629L364.609 169.579H364.469L349.559 161.629H349.699Z",
    fill: "#F2CF55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.839 161.629L364.739 169.579H364.609L349.699 161.629H349.839Z",
    fill: "#F1CF53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.98 161.629L364.88 169.579H364.74L349.84 161.629H349.98Z",
    fill: "#F1CE52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.11 161.629L365.02 169.579H364.88L349.98 161.629H350.11Z",
    fill: "#F1CE51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.249 161.629L365.159 169.579H365.019L350.109 161.629H350.249Z",
    fill: "#F1CD4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.39 161.629L365.3 169.579H365.16L350.25 161.629H350.39Z",
    fill: "#F1CD4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.531 161.629L365.411 169.569V169.579H365.301L350.391 161.629H350.531Z",
    fill: "#F1CD4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.661 161.629L365.411 169.499V169.569L350.531 161.629H350.661Z",
    fill: "#F1CC4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.8 161.629L365.41 169.419V169.499L350.66 161.629H350.8Z",
    fill: "#F1CC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.941 161.629L365.411 169.349V169.419L350.801 161.629H350.941Z",
    fill: "#F1CC49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.077 161.629L365.408 169.279V169.349L350.938 161.629H351.077Z",
    fill: "#F0CB48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.208 161.629L365.408 169.199V169.279L351.078 161.629H351.208Z",
    fill: "#F0CB47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.351 161.629L365.411 169.129V169.199L351.211 161.629H351.351Z",
    fill: "#F0CB46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.488 161.629L365.408 169.059V169.129L351.348 161.629H351.488Z",
    fill: "#F0CA45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.628 161.629L365.408 168.979V169.059L351.488 161.629H351.628Z",
    fill: "#F0CA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.769 161.629L365.409 168.909V168.979L351.629 161.629H351.769Z",
    fill: "#F0CA43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.9 161.629L365.41 168.839V168.909L351.77 161.629H351.9Z",
    fill: "#F0CA42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.038 161.629L365.408 168.759V168.839L351.898 161.629H352.038Z",
    fill: "#F0C941"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.179 161.629L365.409 168.689V168.759L352.039 161.629H352.179Z",
    fill: "#F0C940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.32 161.629L365.41 168.619V168.689L352.18 161.629H352.32Z",
    fill: "#F0C93F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.45 161.629L365.41 168.539V168.619L352.32 161.629H352.45Z",
    fill: "#F0C83E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.589 161.629L365.409 168.469V168.539L352.449 161.629H352.589Z",
    fill: "#F0C83D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.73 161.629L365.41 168.389V168.469L352.59 161.629H352.73Z",
    fill: "#F0C83C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.87 161.629L365.41 168.319V168.389L352.73 161.629H352.87Z",
    fill: "#EFC83B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.001 161.629L365.411 168.249V168.319L352.871 161.629H353.001Z",
    fill: "#EFC73A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.14 161.629L365.41 168.169V168.249L353 161.629H353.14Z",
    fill: "#EFC739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.281 161.629L365.411 168.099V168.169L353.141 161.629H353.281Z",
    fill: "#EFC738"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.421 161.629L365.411 168.029V168.099L353.281 161.629H353.421Z",
    fill: "#EFC737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.558 161.629L365.408 167.949V168.029L353.418 161.629H353.558Z",
    fill: "#EFC737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.689 161.629L365.409 167.879V167.949L353.559 161.629H353.689Z",
    fill: "#EFC636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.827 161.629L365.408 167.809V167.879L353.688 161.629H353.827Z",
    fill: "#EFC635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.968 161.629L365.408 167.729V167.809L353.828 161.629H353.968Z",
    fill: "#EFC634"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.109 161.629L365.409 167.659V167.729L353.969 161.629H354.109Z",
    fill: "#EFC634"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.239 161.629L365.409 167.589V167.659L354.109 161.629H354.239Z",
    fill: "#EFC533"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.378 161.629L365.408 167.509V167.589L354.238 161.629H354.378Z",
    fill: "#EFC532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.519 161.629L365.409 167.439V167.509L354.379 161.629H354.519Z",
    fill: "#EFC532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.66 161.629L365.41 167.369V167.439L354.52 161.629H354.66Z",
    fill: "#EFC531"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.79 161.629L365.41 167.289V167.369L354.66 161.629H354.79Z",
    fill: "#EFC530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.929 161.629L365.409 167.219V167.289L354.789 161.629H354.929Z",
    fill: "#EFC530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.07 161.629L365.41 167.149V167.219L354.93 161.629H355.07Z",
    fill: "#EFC42F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.21 161.629L365.41 167.069V167.149L355.07 161.629H355.21Z",
    fill: "#EEC42E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.351 161.629L365.411 166.999V167.069L355.211 161.629H355.351Z",
    fill: "#EEC42E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.478 161.629L365.408 166.929V166.999L355.348 161.629H355.478Z",
    fill: "#EEC42D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.62 161.629L365.41 166.849V166.929L355.48 161.629H355.62Z",
    fill: "#EEC42D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.761 161.629L365.411 166.779V166.849L355.621 161.629H355.761Z",
    fill: "#EEC42C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.898 161.629L365.408 166.699V166.779L355.758 161.629H355.898Z",
    fill: "#EEC32C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.028 161.629L365.408 166.629V166.699L355.898 161.629H356.028Z",
    fill: "#EEC32B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.171 161.629L365.411 166.559V166.629L356.031 161.629H356.171Z",
    fill: "#EEC32A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.308 161.629L365.408 166.479V166.559L356.168 161.629H356.308Z",
    fill: "#EEC32A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.449 161.629L365.409 166.409V166.479L356.309 161.629H356.449Z",
    fill: "#EEC329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.579 161.629L365.409 166.339V166.409L356.449 161.629H356.579Z",
    fill: "#EEC329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.718 161.629L365.408 166.259V166.339L356.578 161.629H356.718Z",
    fill: "#EEC329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.859 161.629L365.409 166.189V166.259L356.719 161.629H356.859Z",
    fill: "#EEC228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.999 161.629L365.409 166.119V166.189L356.859 161.629H356.999Z",
    fill: "#EEC228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.14 161.629L365.41 166.039V166.119L357 161.629H357.14Z",
    fill: "#EEC227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.271 161.629L365.411 165.969V166.039L357.141 161.629H357.271Z",
    fill: "#EEC227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.41 161.629L365.41 165.899V165.969L357.27 161.629H357.41Z",
    fill: "#EEC226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.55 161.629L365.41 165.819V165.899L357.41 161.629H357.55Z",
    fill: "#EEC226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.691 161.629L365.411 165.749V165.819L357.551 161.629H357.691Z",
    fill: "#EEC226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.818 161.629L365.408 165.679V165.749L357.688 161.629H357.818Z",
    fill: "#EEC225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.96 161.629L365.41 165.599V165.679L357.82 161.629H357.96Z",
    fill: "#EEC225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.101 161.629L365.411 165.529V165.599L357.961 161.629H358.101Z",
    fill: "#EEC125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.238 161.629L365.408 165.459V165.529L358.098 161.629H358.238Z",
    fill: "#EEC124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.368 161.629L365.408 165.379V165.459L358.238 161.629H358.368Z",
    fill: "#EEC124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.511 161.629L365.411 165.309V165.379L358.371 161.629H358.511Z",
    fill: "#EEC124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.648 161.629L365.408 165.229V165.309L358.508 161.629H358.648Z",
    fill: "#EEC123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.788 161.629L365.408 165.159V165.229L358.648 161.629H358.788Z",
    fill: "#EEC123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.929 161.629L365.409 165.089V165.159L358.789 161.629H358.929Z",
    fill: "#EEC123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.06 161.629L365.41 165.009V165.089L358.93 161.629H359.06Z",
    fill: "#EEC122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.199 161.629L365.409 164.939V165.009L359.059 161.629H359.199Z",
    fill: "#EDC122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.339 161.629L365.409 164.869V164.939L359.199 161.629H359.339Z",
    fill: "#EDC122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.48 161.629L365.41 164.789V164.869L359.34 161.629H359.48Z",
    fill: "#EDC122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.61 161.629L365.41 164.719V164.789L359.48 161.629H359.61Z",
    fill: "#EDC121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.749 161.629L365.409 164.649V164.719L359.609 161.629H359.749Z",
    fill: "#EDC021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.89 161.629L365.41 164.569V164.649L359.75 161.629H359.89Z",
    fill: "#EDC021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.031 161.629L365.411 164.499V164.569L359.891 161.629H360.031Z",
    fill: "#EDC021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.161 161.629L365.411 164.429V164.499L360.031 161.629H360.161Z",
    fill: "#EDC020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.3 161.629L365.41 164.349V164.429L360.16 161.629H360.3Z",
    fill: "#EDC020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.441 161.629L365.411 164.279V164.349L360.301 161.629H360.441Z",
    fill: "#EDC020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.577 161.629L365.408 164.209V164.279L360.438 161.629H360.577Z",
    fill: "#EDC020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.718 161.629L365.408 164.129V164.209L360.578 161.629H360.718Z",
    fill: "#EDC020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.849 161.629L365.409 164.059V164.129L360.719 161.629H360.849Z",
    fill: "#EDC020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.988 161.629L365.408 163.989V164.059L360.848 161.629H360.988Z",
    fill: "#EDC01F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.128 161.629L365.408 163.909V163.989L360.988 161.629H361.128Z",
    fill: "#EDC01F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.269 161.629L365.409 163.839V163.909L361.129 161.629H361.269Z",
    fill: "#EDC01F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.4 161.629L365.41 163.769V163.839L361.27 161.629H361.4Z",
    fill: "#EDC01F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.538 161.629L365.408 163.689V163.769L361.398 161.629H361.538Z",
    fill: "#EDC01F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.679 161.629L365.409 163.619V163.689L361.539 161.629H361.679Z",
    fill: "#EDC01F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.82 161.629L365.41 163.539V163.619L361.68 161.629H361.82Z",
    fill: "#EDC01E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.95 161.629L365.41 163.469V163.539L361.82 161.629H361.95Z",
    fill: "#EDC01E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.089 161.629L365.409 163.399V163.469L361.949 161.629H362.089Z",
    fill: "#EDC01E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.23 161.629L365.41 163.319V163.399L362.09 161.629H362.23Z",
    fill: "#EDC01E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.37 161.629L365.41 163.249V163.319L362.23 161.629H362.37Z",
    fill: "#EDC01E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.511 161.629L365.411 163.179V163.249L362.371 161.629H362.511Z",
    fill: "#EDC01E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.638 161.629L365.408 163.099V163.179L362.508 161.629H362.638Z",
    fill: "#EDBF1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.781 161.629L365.411 163.029V163.099L362.641 161.629H362.781Z",
    fill: "#EDBF1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.921 161.629L365.411 162.959V163.029L362.781 161.629H362.921Z",
    fill: "#EDBF1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.058 161.629L365.408 162.879V162.959L362.918 161.629H363.058Z",
    fill: "#EDBF1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.189 161.629L365.409 162.809V162.879L363.059 161.629H363.189Z",
    fill: "#EDBF1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.327 161.629L365.408 162.739V162.809L363.188 161.629H363.327Z",
    fill: "#EDBF1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.468 161.629L365.408 162.659V162.739L363.328 161.629H363.468Z",
    fill: "#EDBF1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.609 161.629L365.409 162.589V162.659L363.469 161.629H363.609Z",
    fill: "#EDBF1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.739 161.629L365.409 162.519V162.589L363.609 161.629H363.739Z",
    fill: "#EDBF1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.878 161.629L365.408 162.439V162.519L363.738 161.629H363.878Z",
    fill: "#EDBF1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.019 161.629L365.409 162.369V162.439L363.879 161.629H364.019Z",
    fill: "#EDBF1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.16 161.629L365.41 162.299V162.369L364.02 161.629H364.16Z",
    fill: "#EDBF1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.3 161.629L365.41 162.219V162.299L364.16 161.629H364.3Z",
    fill: "#EDBF1D"
  }))))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M366.211 171.306C368.254 170.543 369.542 168.935 369.086 167.714C368.63 166.493 366.604 166.121 364.56 166.884C362.516 167.647 361.229 169.256 361.685 170.477C362.141 171.698 364.167 172.069 366.211 171.306Z",
    fill: "#E9AB21"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M366.112 171.348C368.047 170.626 369.246 169.051 368.79 167.829C368.334 166.608 366.396 166.204 364.461 166.926C362.526 167.649 361.327 169.224 361.782 170.445C362.238 171.666 364.176 172.071 366.112 171.348Z",
    fill: "#EDBF1C"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368.631 167.508C368.701 167.618 368.811 167.818 368.861 168.068C368.911 168.338 368.881 168.548 368.861 168.698C368.851 168.788 368.801 169.028 368.671 169.318C368.611 169.448 368.431 169.818 367.991 170.238C367.361 170.848 366.611 171.168 366.191 171.318C366.531 171.168 367.581 170.638 368.201 169.418C368.601 168.618 368.641 167.888 368.631 167.488V167.508Z",
    fill: "#F4F3F9"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.573 211.702C343.263 211.352 345.813 214.082 347.463 216.832C348.473 218.512 348.693 219.442 349.893 220.162C351.153 220.922 351.953 220.522 353.763 220.902C356.583 221.492 359.273 223.462 359.053 224.382C358.843 225.272 355.973 224.782 351.863 225.522C351.233 225.642 350.623 225.772 350.033 225.922C350.003 225.922 349.973 225.942 349.943 225.942C349.943 226.002 349.943 226.052 349.943 226.112C349.933 226.502 349.873 226.912 349.763 227.322C349.583 228.042 349.263 228.792 348.813 229.552C346.753 233.132 342.023 237.122 335.883 240.102C335.263 240.402 334.653 240.682 334.033 240.942C325.143 244.762 316.813 244.872 314.943 240.992C314.583 240.242 314.483 239.402 314.623 238.502C315.253 234.372 320.793 228.912 328.633 225.112C330.373 224.272 332.103 223.572 333.773 223.012C337.553 221.752 341.073 221.212 343.863 221.402C343.803 219.902 343.633 218.302 343.313 216.622C342.833 214.132 342.053 211.962 342.603 211.682L342.573 211.702Z",
    fill: "#090E16"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M342.253 211.05C342.943 210.7 345.493 213.43 347.143 216.18C348.153 217.86 348.373 218.79 349.573 219.51C350.833 220.27 351.633 219.87 353.443 220.25C356.263 220.84 358.953 222.81 358.733 223.73C358.523 224.62 355.653 224.13 351.543 224.87C350.913 224.99 350.303 225.12 349.713 225.27C349.683 225.27 349.653 225.29 349.623 225.29C349.623 225.35 349.623 225.4 349.623 225.46C349.613 225.85 349.553 226.26 349.443 226.67C349.263 227.39 348.943 228.14 348.493 228.9C346.433 232.48 341.703 236.47 335.563 239.45C334.943 239.75 334.333 240.03 333.713 240.29C324.823 244.11 316.493 244.22 314.623 240.34C314.263 239.59 314.163 238.75 314.303 237.85C314.933 233.72 320.473 228.26 328.313 224.46C330.053 223.62 331.783 222.92 333.453 222.36C337.233 221.1 340.753 220.56 343.543 220.75C343.483 219.25 343.313 217.65 342.993 215.97C342.513 213.48 341.733 211.31 342.283 211.03L342.253 211.05Z",
    fill: "#858F9E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_90771_36502",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 333,
    y: 211,
    width: 26,
    height: 19
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M342.271 211.081C342.961 210.731 345.511 213.461 347.161 216.211C348.171 217.891 348.391 218.821 349.591 219.541C350.851 220.301 351.651 219.901 353.461 220.281C356.281 220.871 358.971 222.841 358.751 223.761C358.541 224.651 355.671 224.161 351.561 224.901C350.931 225.021 350.321 225.151 349.731 225.301C349.691 225.371 349.661 225.431 349.631 225.491C349.621 225.881 349.561 226.291 349.451 226.701C349.271 227.421 348.951 228.171 348.501 228.931C345.331 229.331 342.311 229.011 339.771 228.061C339.661 228.021 339.551 227.981 339.451 227.931C336.661 226.811 334.511 224.921 333.461 222.391C337.241 221.131 340.761 220.591 343.551 220.781C343.491 219.281 343.321 217.681 343.001 216.001C342.521 213.511 341.741 211.341 342.291 211.061L342.271 211.081Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_90771_36502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.973 221.802L334.823 218.922L350.083 228.752L338.943 234.142L332.973 221.802Z",
    fill: "#858F9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.824 218.923L334.914 218.793L350.254 228.663L350.084 228.753L334.824 218.923Z",
    fill: "#858F9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.914 218.792L335.004 218.652L350.424 228.582L350.254 228.662L334.914 218.792Z",
    fill: "#848E9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.004 218.652L335.084 218.512L350.594 228.502L350.424 228.582L335.004 218.652Z",
    fill: "#838D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.082 218.511L335.172 218.371L350.762 228.411L350.592 228.501L335.082 218.511Z",
    fill: "#828B9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.172 218.372L335.262 218.242L350.932 228.332L350.762 228.412L335.172 218.372Z",
    fill: "#808A99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.262 218.242L335.352 218.102L351.112 228.252L350.932 228.332L335.262 218.242Z",
    fill: "#7F8998"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.352 218.101L335.442 217.961L351.282 228.171L351.112 228.251L335.352 218.101Z",
    fill: "#7E8896"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.441 217.962L335.531 217.832L351.451 228.082L351.281 228.172L335.441 217.962Z",
    fill: "#7D8795"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.531 217.831L335.611 217.691L351.621 228.001L351.451 228.081L335.531 217.831Z",
    fill: "#7C8594"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.613 217.691L335.703 217.551L351.793 227.921L351.623 228.001L335.613 217.691Z",
    fill: "#7B8493"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.703 217.552L335.793 217.422L351.963 227.832L351.793 227.922L335.703 217.552Z",
    fill: "#798391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.793 217.421L335.883 217.281L352.143 227.751L351.963 227.831L335.793 217.421Z",
    fill: "#788290"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.883 217.281L335.973 217.141L352.313 227.671L352.143 227.751L335.883 217.281Z",
    fill: "#77818F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.973 217.142L336.053 217.012L352.483 227.582L352.313 227.672L335.973 217.142Z",
    fill: "#767F8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.051 217.011L336.141 216.871L352.651 227.501L352.481 227.581L336.051 217.011Z",
    fill: "#757E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.145 216.87L336.235 216.73L352.825 227.42L352.655 227.5L336.145 216.87Z",
    fill: "#747D8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.234 216.732L336.324 216.602L352.994 227.332L352.824 227.422L336.234 216.732Z",
    fill: "#737C8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.324 216.601L336.414 216.461L353.164 227.251L352.994 227.331L336.324 216.601Z",
    fill: "#727B89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.414 216.46L336.494 216.32L353.344 227.17L353.164 227.25L336.414 216.46Z",
    fill: "#707A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.492 216.321L336.582 216.191L353.512 227.091L353.342 227.171L336.492 216.321Z",
    fill: "#6F7886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.582 216.191L336.672 216.051L353.682 227.001L353.512 227.091L336.582 216.191Z",
    fill: "#6E7785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.672 216.05L336.762 215.91L353.852 226.92L353.682 227L336.672 216.05Z",
    fill: "#6D7684"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.762 215.911L336.852 215.781L354.022 226.841L353.852 226.921L336.762 215.911Z",
    fill: "#6C7583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.852 215.781L336.942 215.641L354.192 226.751L354.022 226.841L336.852 215.781Z",
    fill: "#6B7481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.941 215.64L337.021 215.5L354.371 226.67L354.191 226.75L336.941 215.64Z",
    fill: "#6A7380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.023 215.503L337.113 215.363L354.543 226.593L354.373 226.673L337.023 215.503Z",
    fill: "#69717F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.113 215.36L337.203 215.23L354.713 226.5L354.543 226.59L337.113 215.36Z",
    fill: "#68707E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.203 215.23L337.293 215.09L354.883 226.42L354.713 226.5L337.203 215.23Z",
    fill: "#666F7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.293 215.093L337.383 214.953L355.053 226.343L354.883 226.423L337.293 215.093Z",
    fill: "#656E7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.383 214.95L337.463 214.82L355.223 226.25L355.053 226.34L337.383 214.95Z",
    fill: "#646D7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.461 214.824L337.551 214.684L355.391 226.174L355.221 226.254L337.461 214.824Z",
    fill: "#636C79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.551 214.683L337.641 214.543L355.571 226.093L355.391 226.173L337.551 214.683Z",
    fill: "#626B78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.645 214.54L337.735 214.41L355.745 226.01L355.575 226.09L337.645 214.54Z",
    fill: "#616A76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.734 214.413L337.824 214.273L355.914 225.923L355.744 226.013L337.734 214.413Z",
    fill: "#606875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.824 214.273L337.904 214.133L356.084 225.843L355.914 225.923L337.824 214.273Z",
    fill: "#5F6774"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.902 214.13L337.992 214L356.252 225.76L356.082 225.84L337.902 214.13Z",
    fill: "#5E6673"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.992 214.003L338.082 213.863L356.422 225.673L356.252 225.763L337.992 214.003Z",
    fill: "#5D6572"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.082 213.863L338.172 213.723L356.602 225.593L356.422 225.673L338.082 213.863Z",
    fill: "#5C6471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.172 213.72L338.262 213.59L356.772 225.51L356.602 225.59L338.172 213.72Z",
    fill: "#5B636F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.262 213.593L338.342 213.453L356.942 225.423L356.772 225.513L338.262 213.593Z",
    fill: "#59626E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.344 213.452L338.434 213.312L357.114 225.342L356.944 225.423L338.344 213.452Z",
    fill: "#58616D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.434 213.314L338.524 213.184L357.284 225.264L357.114 225.344L338.434 213.314Z",
    fill: "#575F6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.523 213.183L338.613 213.043L357.453 225.173L357.283 225.263L338.523 213.183Z",
    fill: "#565E6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.613 213.042L338.703 212.902L357.623 225.092L357.453 225.172L338.613 213.042Z",
    fill: "#555D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.703 212.903L338.793 212.773L357.803 225.013L357.623 225.093L338.703 212.903Z",
    fill: "#545C68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.793 212.774V212.754L338.953 212.684L357.973 224.934L357.803 225.014L338.793 212.774Z",
    fill: "#535B67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.123 212.59L358.143 224.84L357.973 224.93L338.953 212.68L339.123 212.59Z",
    fill: "#525A66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.291 212.512L358.311 224.762L358.141 224.842L339.121 212.592L339.291 212.512Z",
    fill: "#515965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.463 212.434L358.483 224.684L358.313 224.764L339.293 212.514L339.463 212.434Z",
    fill: "#505864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.631 212.34L358.651 224.59L358.481 224.68L339.461 212.43L339.631 212.34Z",
    fill: "#4F5763"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.813 212.262L358.833 224.512L358.653 224.592L339.633 212.342L339.813 212.262Z",
    fill: "#4E5662"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.983 212.184L359.003 224.434L358.832 224.514L339.812 212.264L339.983 212.184Z",
    fill: "#4D5560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.154 212.09L359.174 224.34L359.004 224.43L339.984 212.18L340.154 212.09Z",
    fill: "#4C545F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.322 212.012L359.342 224.262L359.172 224.342L340.152 212.092L340.322 212.012Z",
    fill: "#4B535E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.494 211.934L359.514 224.184L359.344 224.264L340.324 212.014L340.494 211.934Z",
    fill: "#4A515D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.662 211.852L359.522 223.992L359.592 224.142L359.512 224.182L340.492 211.932L340.662 211.852Z",
    fill: "#49505C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.834 211.762L359.384 223.712L359.524 223.992L340.664 211.852L340.834 211.762Z",
    fill: "#484F5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.012 211.684L359.242 223.424L359.382 223.714L340.832 211.764L341.012 211.684Z",
    fill: "#474E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.182 211.602L359.112 223.142L359.242 223.422L341.012 211.682L341.182 211.602Z",
    fill: "#464D59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.354 211.512L358.974 222.862L359.114 223.142L341.184 211.602L341.354 211.512Z",
    fill: "#454C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.522 211.434L358.842 222.584L358.972 222.864L341.352 211.514L341.522 211.434Z",
    fill: "#444B57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.693 211.352L358.703 222.302L358.843 222.582L341.523 211.432L341.693 211.352Z",
    fill: "#434A55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.861 211.262L358.561 222.022L358.701 222.302L341.691 211.352L341.861 211.262Z",
    fill: "#424954"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.043 211.184L358.433 221.744L358.563 222.024L341.863 211.264L342.043 211.184Z",
    fill: "#414853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.213 211.102L358.293 221.462L358.433 221.742L342.043 211.182L342.213 211.102Z",
    fill: "#404752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.381 211.012L358.151 221.172L358.291 221.462L342.211 211.102L342.381 211.012Z",
    fill: "#3F4651"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.553 210.934L358.023 220.894L358.153 221.174L342.383 211.014L342.553 210.934Z",
    fill: "#3E4550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.721 210.852L357.881 220.612L358.021 220.892L342.551 210.932L342.721 210.852Z",
    fill: "#3D444F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.893 210.773L357.753 220.333L357.883 220.613L342.723 210.853L342.893 210.773Z",
    fill: "#3C434E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.065 210.684L357.615 220.054L357.755 220.334L342.895 210.774L343.065 210.684Z",
    fill: "#3B424D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.242 210.602L357.473 219.772L357.612 220.052L343.062 210.682L343.242 210.602Z",
    fill: "#3A414C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.412 210.523L357.342 219.493L357.472 219.773L343.242 210.603L343.412 210.523Z",
    fill: "#39404B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.584 210.434L357.204 219.214L357.344 219.494L343.414 210.524L343.584 210.434Z",
    fill: "#383F4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.752 210.352L357.062 218.922L357.202 219.212L343.582 210.432L343.752 210.352Z",
    fill: "#373E49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.924 210.273L356.934 218.643L357.064 218.923L343.754 210.353L343.924 210.273Z",
    fill: "#363D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.092 210.184L356.792 218.364L356.932 218.644L343.922 210.274L344.092 210.184Z",
    fill: "#353C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.274 210.102L356.664 218.082L356.794 218.362L344.094 210.182L344.274 210.102Z",
    fill: "#343B46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.443 210.023L356.523 217.803L356.663 218.083L344.273 210.103L344.443 210.023Z",
    fill: "#333A45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.611 209.934L356.381 217.524L356.521 217.804L344.441 210.024L344.611 209.934Z",
    fill: "#333944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.783 209.852L356.253 217.242L356.383 217.522L344.613 209.932L344.783 209.852Z",
    fill: "#323843"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.951 209.773L356.111 216.953L356.251 217.243L344.781 209.853L344.951 209.773Z",
    fill: "#313742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.123 209.691L355.973 216.671L356.113 216.951L344.953 209.771L345.123 209.691Z",
    fill: "#303641"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.301 209.602L355.841 216.392L355.971 216.672L345.121 209.692L345.301 209.602Z",
    fill: "#2F3540"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.471 209.523L355.701 216.113L355.841 216.393L345.301 209.603L345.471 209.523Z",
    fill: "#2E343F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.643 209.441L355.573 215.831L355.703 216.111L345.473 209.521L345.643 209.441Z",
    fill: "#2D343E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.815 209.352L355.435 215.552L355.575 215.832L345.645 209.442L345.815 209.352Z",
    fill: "#2C333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.983 209.273L355.293 215.273L355.432 215.553L345.812 209.353L345.983 209.273Z",
    fill: "#2B323C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.154 209.191L355.164 214.991L355.294 215.271L345.984 209.271L346.154 209.191Z",
    fill: "#2A313B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.322 209.102L355.022 214.702L355.162 214.992L346.152 209.192L346.322 209.102Z",
    fill: "#2A303A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.504 209.023L354.884 214.423L355.024 214.703L346.324 209.103L346.504 209.023Z",
    fill: "#292F39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.674 208.941L354.754 214.141L354.884 214.421L346.504 209.021L346.674 208.941Z",
    fill: "#282E38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.842 208.852L354.612 213.862L354.752 214.142L346.672 208.942L346.842 208.852Z",
    fill: "#272D37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.014 208.773L354.484 213.583L354.614 213.863L346.844 208.853L347.014 208.773Z",
    fill: "#262C36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.182 208.691L354.342 213.301L354.482 213.581L347.012 208.771L347.182 208.691Z",
    fill: "#252B35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.354 208.613L354.204 213.023L354.344 213.303L347.184 208.693L347.354 208.613Z",
    fill: "#242A34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.532 208.523L354.072 212.743L354.202 213.023L347.352 208.613L347.532 208.523Z",
    fill: "#232A33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.701 208.441L353.931 212.451L354.071 212.741L347.531 208.521L347.701 208.441Z",
    fill: "#232932"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.873 208.363L353.803 212.173L353.933 212.453L347.703 208.443L347.873 208.363Z",
    fill: "#222831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.041 208.273L353.661 211.893L353.801 212.173L347.871 208.363L348.041 208.273Z",
    fill: "#212730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.213 208.191L353.523 211.611L353.663 211.891L348.043 208.271L348.213 208.191Z",
    fill: "#20262F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.381 208.113L353.391 211.333L353.521 211.613L348.211 208.193L348.381 208.113Z",
    fill: "#1F252F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.553 208.023L353.253 211.053L353.393 211.333L348.383 208.113L348.553 208.023Z",
    fill: "#1F242E"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.24
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M314.272 237.872C315.452 237.542 316.902 237.522 318.082 238.012C319.862 238.752 319.852 240.182 321.302 241.312C325.262 244.402 333.022 239.682 333.682 240.302C324.792 244.122 316.462 244.222 314.592 240.352C314.232 239.602 314.132 238.762 314.272 237.862V237.872Z",
    fill: "#090E16"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.524 233.262C322.849 233.262 323.114 232.998 323.114 232.672C323.114 232.346 322.849 232.082 322.524 232.082C322.198 232.082 321.934 232.346 321.934 232.672C321.934 232.998 322.198 233.262 322.524 233.262Z",
    fill: "#090E16"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.613 235.641C327.353 235.641 327.953 235.041 327.953 234.301C327.953 233.561 327.353 232.961 326.613 232.961C325.873 232.961 325.273 233.561 325.273 234.301C325.273 235.041 325.873 235.641 326.613 235.641Z",
    fill: "#090E16"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.813 230.412C328.062 230.412 328.263 230.21 328.263 229.962C328.263 229.713 328.062 229.512 327.813 229.512C327.565 229.512 327.363 229.713 327.363 229.962C327.363 230.21 327.565 230.412 327.813 230.412Z",
    fill: "#090E16"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.262 230.762C332.361 230.762 332.442 230.682 332.442 230.582C332.442 230.483 332.361 230.402 332.262 230.402C332.163 230.402 332.082 230.483 332.082 230.582C332.082 230.682 332.163 230.762 332.262 230.762Z",
    fill: "#090E16"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.353 233.369C338.563 233.369 338.733 233.199 338.733 232.989C338.733 232.78 338.563 232.609 338.353 232.609C338.143 232.609 337.973 232.78 337.973 232.989C337.973 233.199 338.143 233.369 338.353 233.369Z",
    fill: "#090E16"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.14 228.092C340.996 228.092 341.69 227.398 341.69 226.542C341.69 225.686 340.996 224.992 340.14 224.992C339.284 224.992 338.59 225.686 338.59 226.542C338.59 227.398 339.284 228.092 340.14 228.092Z",
    fill: "#090E16"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_90771_36502",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 314,
    y: 211,
    width: 32,
    height: 32
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M342.252 211.051C341.702 211.321 342.482 213.501 342.962 215.991C343.292 217.671 343.462 219.261 343.512 220.771C340.722 220.581 337.192 221.131 333.422 222.381C331.742 222.941 330.012 223.641 328.282 224.481C320.442 228.281 314.912 233.741 314.272 237.871C314.132 238.781 314.232 239.621 314.592 240.361C314.982 241.161 315.652 241.791 316.532 242.251C321.572 231.331 334.422 225.771 345.742 223.981C344.122 220.221 343.972 216.521 345.172 213.401C343.912 211.881 342.692 210.821 342.252 211.041V211.051Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_90771_36502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.965 225.388L315.621 242.504L315.704 242.675L351.047 225.559L350.965 225.388Z",
    fill: "#858F9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.91 225.259L315.566 242.375L315.623 242.492L350.967 225.376L350.91 225.259Z",
    fill: "#858F9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.847 225.157L315.504 242.273L315.561 242.39L350.904 225.274L350.847 225.157Z",
    fill: "#87909F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.793 225.032L315.449 242.148L315.506 242.265L350.849 225.149L350.793 225.032Z",
    fill: "#8892A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.734 224.907L315.391 242.023L315.447 242.14L350.791 225.024L350.734 224.907Z",
    fill: "#8A93A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.676 224.794L315.332 241.91L315.389 242.027L350.732 224.911L350.676 224.794Z",
    fill: "#8B95A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.617 224.685L315.273 241.801L315.33 241.918L350.674 224.802L350.617 224.685Z",
    fill: "#8D96A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.57 224.567L315.227 241.684L315.283 241.801L350.627 224.684L350.57 224.567Z",
    fill: "#8E97A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.504 224.446L315.16 241.562L315.217 241.68L350.56 224.563L350.504 224.446Z",
    fill: "#9099A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.449 224.333L315.105 241.449L315.162 241.566L350.506 224.45L350.449 224.333Z",
    fill: "#919AA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.394 224.216L315.051 241.332L315.107 241.449L350.451 224.333L350.394 224.216Z",
    fill: "#939BA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.336 224.095L314.992 241.211L315.049 241.328L350.392 224.212L350.336 224.095Z",
    fill: "#949DAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.273 223.981L314.93 241.098L314.986 241.215L350.33 224.098L350.273 223.981Z",
    fill: "#969EAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.226 223.864L314.883 240.98L314.939 241.097L350.283 223.981L350.226 223.864Z",
    fill: "#97A0AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.16 223.743L314.816 240.859L314.873 240.976L350.217 223.86L350.16 223.743Z",
    fill: "#98A1AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.117 223.626L314.773 240.742L314.83 240.859L350.174 223.743L350.117 223.626Z",
    fill: "#9AA2AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.062 223.513L314.719 240.629L314.775 240.746L350.119 223.63L350.062 223.513Z",
    fill: "#9BA4B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.996 223.392L314.652 240.508L314.709 240.625L350.053 223.509L349.996 223.392Z",
    fill: "#9DA5B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.953 223.286L314.609 240.402L314.666 240.519L350.01 223.403L349.953 223.286Z",
    fill: "#9EA6B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.887 223.161L314.543 240.277L314.6 240.394L349.943 223.278L349.887 223.161Z",
    fill: "#A0A7B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.828 223.04L314.484 240.156L314.541 240.273L349.885 223.157L349.828 223.04Z",
    fill: "#A1A9B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.777 222.935L314.434 240.051L314.49 240.168L349.834 223.052L349.777 222.935Z",
    fill: "#A2AAB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.719 222.813L314.375 239.93L314.432 240.047L349.775 222.93L349.719 222.813Z",
    fill: "#A4ABB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.652 222.688L314.309 239.805L314.365 239.922L349.709 222.805L349.652 222.688Z",
    fill: "#A5ADB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.609 222.583L314.266 239.699L314.322 239.816L349.666 222.7L349.609 222.583Z",
    fill: "#A7AEB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.547 222.462L314.203 239.578L314.26 239.695L349.603 222.579L349.547 222.462Z",
    fill: "#A8AFBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.488 222.341L314.145 239.457L314.201 239.574L349.545 222.458L349.488 222.341Z",
    fill: "#A9B0BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.437 222.231L314.094 239.348L314.15 239.465L349.494 222.348L349.437 222.231Z",
    fill: "#ABB2BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.379 222.11L314.035 239.227L314.092 239.344L349.435 222.227L349.379 222.11Z",
    fill: "#ACB3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.312 221.997L313.969 239.113L314.025 239.23L349.369 222.114L349.312 221.997Z",
    fill: "#ADB4BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.265 221.872L313.922 238.988L313.979 239.105L349.322 221.989L349.265 221.872Z",
    fill: "#AFB5BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.203 221.759L313.859 238.875L313.916 238.992L349.26 221.876L349.203 221.759Z",
    fill: "#B0B7C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.148 221.649L313.805 238.766L313.861 238.883L349.205 221.766L349.148 221.649Z",
    fill: "#B1B8C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.09 221.521L313.746 238.637L313.803 238.754L349.146 221.638L349.09 221.521Z",
    fill: "#B3B9C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.039 221.407L313.695 238.523L313.752 238.64L349.096 221.524L349.039 221.407Z",
    fill: "#B4BAC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.972 221.298L313.629 238.414L313.686 238.531L349.029 221.415L348.972 221.298Z",
    fill: "#B5BBC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.926 221.169L313.582 238.285L313.639 238.402L348.982 221.286L348.926 221.169Z",
    fill: "#B7BDC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.871 221.056L313.527 238.172L313.584 238.289L348.928 221.173L348.871 221.056Z",
    fill: "#B8BEC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.805 220.946L313.461 238.062L313.518 238.18L348.861 221.063L348.805 220.946Z",
    fill: "#B9BFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.758 220.821L313.414 237.938L313.471 238.055L348.814 220.938L348.758 220.821Z",
    fill: "#BAC0C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.695 220.716L313.352 237.832L313.408 237.949L348.752 220.833L348.695 220.716Z",
    fill: "#BCC1C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.64 220.595L313.297 237.711L313.354 237.828L348.697 220.712L348.64 220.595Z",
    fill: "#BDC2CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.582 220.47L313.238 237.586L313.295 237.703L348.639 220.587L348.582 220.47Z",
    fill: "#BEC3CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.531 220.364L313.188 237.48L313.244 237.597L348.588 220.481L348.531 220.364Z",
    fill: "#BFC5CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.465 220.243L313.121 237.359L313.178 237.476L348.521 220.36L348.465 220.243Z",
    fill: "#C1C6CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.418 220.118L313.074 237.234L313.131 237.351L348.474 220.235L348.418 220.118Z",
    fill: "#C2C7CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.355 220.017L313.012 237.133L313.068 237.25L348.412 220.134L348.355 220.017Z",
    fill: "#C3C8CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.308 219.888L312.965 237.004L313.022 237.121L348.365 220.005L348.308 219.888Z",
    fill: "#C4C9D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.242 219.778L312.898 236.895L312.955 237.012L348.299 219.895L348.242 219.778Z",
    fill: "#C5CAD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.191 219.665L312.848 236.781L312.904 236.898L348.248 219.782L348.191 219.665Z",
    fill: "#C7CBD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.133 219.536L312.789 236.652L312.846 236.769L348.189 219.653L348.133 219.536Z",
    fill: "#C8CCD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.078 219.427L312.734 236.543L312.791 236.66L348.135 219.544L348.078 219.427Z",
    fill: "#C9CDD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.015 219.313L312.672 236.43L312.729 236.547L348.072 219.43L348.015 219.313Z",
    fill: "#CACED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.969 219.188L312.625 236.305L312.682 236.422L348.025 219.305L347.969 219.188Z",
    fill: "#CBD0D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.902 219.075L312.559 236.191L312.615 236.308L347.959 219.192L347.902 219.075Z",
    fill: "#CCD1D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.844 218.954L312.5 236.07L312.557 236.187L347.9 219.071L347.844 218.954Z",
    fill: "#CED2D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.801 218.837L312.457 235.953L312.514 236.07L347.857 218.954L347.801 218.837Z",
    fill: "#CFD3D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.734 218.724L312.391 235.84L312.447 235.957L347.791 218.841L347.734 218.724Z",
    fill: "#D0D4D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.68 218.603L312.336 235.719L312.393 235.836L347.736 218.72L347.68 218.603Z",
    fill: "#D1D5DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.625 218.493L312.281 235.609L312.338 235.726L347.681 218.61L347.625 218.493Z",
    fill: "#D2D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.57 218.372L312.227 235.488L312.283 235.605L347.627 218.489L347.57 218.372Z",
    fill: "#D3D7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.504 218.251L312.16 235.367L312.217 235.484L347.56 218.368L347.504 218.251Z",
    fill: "#D4D8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.461 218.146L312.117 235.262L312.174 235.379L347.517 218.263L347.461 218.146Z",
    fill: "#D5D9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.394 218.021L312.051 235.137L312.107 235.254L347.451 218.138L347.394 218.021Z",
    fill: "#D6DADF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.34 217.899L311.996 235.016L312.053 235.133L347.396 218.016L347.34 217.899Z",
    fill: "#D7DBDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.285 217.794L311.941 234.91L311.998 235.027L347.342 217.911L347.285 217.794Z",
    fill: "#D8DCE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.23 217.673L311.887 234.789L311.943 234.906L347.287 217.79L347.23 217.673Z",
    fill: "#D9DCE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.164 217.548L311.82 234.664L311.877 234.781L347.221 217.665L347.164 217.548Z",
    fill: "#DADDE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.121 217.442L311.777 234.559L311.834 234.676L347.178 217.559L347.121 217.442Z",
    fill: "#DBDEE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.055 217.321L311.711 234.438L311.768 234.555L347.111 217.438L347.055 217.321Z",
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.996 217.208L311.652 234.324L311.709 234.441L347.053 217.325L346.996 217.208Z",
    fill: "#DDE0E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.945 217.091L311.602 234.207L311.658 234.324L347.002 217.208L346.945 217.091Z",
    fill: "#DEE1E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.887 216.97L311.543 234.086L311.6 234.203L346.943 217.087L346.887 216.97Z",
    fill: "#DFE2E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.82 216.856L311.477 233.973L311.533 234.09L346.877 216.973L346.82 216.856Z",
    fill: "#E0E3E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.777 216.739L311.434 233.855L311.49 233.972L346.834 216.856L346.777 216.739Z",
    fill: "#E1E4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.722 216.618L311.379 233.734L311.436 233.851L346.779 216.735L346.722 216.618Z",
    fill: "#E2E5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.656 216.505L311.312 233.621L311.369 233.738L346.713 216.622L346.656 216.505Z",
    fill: "#E3E5E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.613 216.388L311.27 233.504L311.326 233.621L346.67 216.505L346.613 216.388Z",
    fill: "#E4E6EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.547 216.278L311.203 233.395L311.26 233.512L346.603 216.395L346.547 216.278Z",
    fill: "#E5E7EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.492 216.157L311.148 233.273L311.205 233.39L346.549 216.274L346.492 216.157Z",
    fill: "#E6E8EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.433 216.028L311.09 233.145L311.147 233.262L346.49 216.145L346.433 216.028Z",
    fill: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.383 215.927L311.039 233.043L311.096 233.16L346.439 216.044L346.383 215.927Z",
    fill: "#E8EAEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.324 215.802L310.98 232.918L311.037 233.035L346.381 215.919L346.324 215.802Z",
    fill: "#E9EAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.269 215.677L310.926 232.793L310.982 232.91L346.326 215.794L346.269 215.677Z",
    fill: "#E9EBEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.207 215.575L310.863 232.691L310.92 232.808L346.264 215.692L346.207 215.575Z",
    fill: "#EAECEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.16 215.45L310.816 232.566L310.873 232.683L346.217 215.567L346.16 215.45Z",
    fill: "#EBEDEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.094 215.329L310.75 232.445L310.807 232.562L346.15 215.446L346.094 215.329Z",
    fill: "#ECEDF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.039 215.224L310.695 232.34L310.752 232.457L346.096 215.341L346.039 215.224Z",
    fill: "#EDEEF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.984 215.099L310.641 232.215L310.697 232.332L346.041 215.216L345.984 215.099Z",
    fill: "#EDEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.926 214.985L310.582 232.102L310.639 232.219L345.982 215.102L345.926 214.985Z",
    fill: "#EEF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.863 214.872L310.52 231.988L310.576 232.105L345.92 214.989L345.863 214.872Z",
    fill: "#EFF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.816 214.747L310.473 231.863L310.529 231.98L345.873 214.864L345.816 214.747Z",
    fill: "#F0F1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.75 214.638L310.406 231.754L310.463 231.871L345.806 214.755L345.75 214.638Z",
    fill: "#F1F2F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.699 214.524L310.355 231.641L310.412 231.758L345.756 214.641L345.699 214.524Z",
    fill: "#F1F2F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.64 214.396L310.297 231.512L310.354 231.629L345.697 214.513L345.64 214.396Z",
    fill: "#F2F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.586 214.286L310.242 231.402L310.299 231.519L345.642 214.403L345.586 214.286Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.535 214.173L310.191 231.289L310.248 231.406L345.592 214.29L345.535 214.173Z",
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.476 214.048L310.133 231.164L310.189 231.281L345.533 214.165L345.476 214.048Z",
    fill: "#F4F5F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.422 213.935L310.078 231.051L310.135 231.168L345.478 214.052L345.422 213.935Z",
    fill: "#F5F6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.359 213.821L310.016 230.938L310.072 231.055L345.416 213.938L345.359 213.821Z",
    fill: "#F5F6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.312 213.704L309.969 230.82L310.025 230.937L345.369 213.821L345.312 213.704Z",
    fill: "#F6F7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.246 213.583L309.902 230.699L309.959 230.816L345.303 213.7L345.246 213.583Z",
    fill: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.191 213.47L309.848 230.586L309.904 230.703L345.248 213.587L345.191 213.47Z",
    fill: "#F7F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.137 213.353L309.793 230.469L309.85 230.586L345.193 213.47L345.137 213.353Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.078 213.231L309.734 230.348L309.791 230.465L345.135 213.348L345.078 213.231Z",
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.015 213.118L309.672 230.234L309.729 230.351L345.072 213.235L345.015 213.118Z",
    fill: "#F9F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.969 213.005L309.625 230.121L309.682 230.238L345.025 213.122L344.969 213.005Z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.902 212.88L309.559 229.996L309.615 230.113L344.959 212.997L344.902 212.88Z",
    fill: "#FAFAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.847 212.771L309.504 229.887L309.561 230.004L344.904 212.888L344.847 212.771Z",
    fill: "#FAFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.793 212.653L309.449 229.77L309.506 229.887L344.849 212.77L344.793 212.653Z",
    fill: "#FBFBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.738 212.532L309.395 229.648L309.451 229.765L344.795 212.649L344.738 212.532Z",
    fill: "#FBFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.672 212.419L309.328 229.535L309.385 229.652L344.728 212.536L344.672 212.419Z",
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.629 212.302L309.285 229.418L309.342 229.535L344.685 212.419L344.629 212.302Z",
    fill: "#FCFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.562 212.181L309.219 229.297L309.275 229.414L344.619 212.298L344.562 212.181Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.515 212.063L309.172 229.18L309.229 229.297L344.572 212.18L344.515 212.063Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.465 211.95L309.121 229.066L309.178 229.183L344.521 212.067L344.465 211.95Z",
    fill: "#FDFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.398 211.829L309.055 228.945L309.111 229.062L344.455 211.946L344.398 211.829Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.347 211.712L309.004 228.828L309.061 228.945L344.404 211.829L344.347 211.712Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.289 211.599L308.945 228.715L309.002 228.832L344.346 211.716L344.289 211.599Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.23 211.489L308.887 228.605L308.943 228.722L344.287 211.606L344.23 211.489Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.176 211.36L308.832 228.477L308.889 228.594L344.232 211.477L344.176 211.36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.121 211.247L308.777 228.363L308.834 228.48L344.178 211.364L344.121 211.247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.055 211.138L308.711 228.254L308.768 228.371L344.111 211.255L344.055 211.138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.683 210.36L308.34 227.477L308.715 228.251L344.058 211.134L343.683 210.36Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.24
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M318.501 234.791L319.001 235.821L317.971 236.321C317.851 236.381 317.801 236.521 317.861 236.641C317.921 236.761 318.061 236.811 318.181 236.751L319.211 236.251L319.711 237.281C319.771 237.401 319.911 237.451 320.031 237.391C320.151 237.331 320.201 237.191 320.141 237.071L319.641 236.041L320.671 235.541C320.791 235.481 320.841 235.341 320.781 235.221C320.721 235.101 320.581 235.051 320.461 235.111L319.431 235.611L318.931 234.581C318.871 234.461 318.731 234.411 318.611 234.471C318.491 234.531 318.441 234.671 318.501 234.791Z",
    fill: "#090E16"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M318.15 234.662L318.65 235.692L317.62 236.192C317.5 236.252 317.45 236.392 317.51 236.512C317.57 236.632 317.71 236.682 317.83 236.622L318.86 236.122L319.36 237.152C319.42 237.272 319.56 237.322 319.68 237.262C319.8 237.202 319.85 237.062 319.79 236.942L319.29 235.912L320.32 235.412C320.44 235.352 320.49 235.212 320.43 235.092C320.37 234.972 320.23 234.922 320.11 234.982L319.08 235.482L318.58 234.452C318.52 234.332 318.38 234.282 318.26 234.342C318.14 234.402 318.09 234.542 318.15 234.662Z",
    fill: "#090E16"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.33 231.58C309 232.21 311.52 234.58 314.06 236.13C315.61 237.07 316.47 237.28 317.13 238.39C317.83 239.56 317.45 240.3 317.8 241.97C318.34 244.58 320.14 247.08 320.99 246.88C321.81 246.69 321.37 244.03 322.08 240.23C322.19 239.64 322.32 239.08 322.46 238.54C322.46 238.51 322.48 238.48 322.48 238.45C322.53 238.45 322.59 238.45 322.64 238.45C323 238.44 323.38 238.39 323.76 238.29C324.42 238.12 325.12 237.83 325.83 237.42C329.15 235.53 332.86 231.17 335.64 225.5C335.92 224.93 336.18 224.36 336.43 223.79C340 215.58 340.13 207.88 336.56 206.13C335.87 205.79 335.09 205.7 334.26 205.82C330.44 206.39 325.36 211.48 321.82 218.72C321.03 220.32 320.38 221.92 319.85 223.47C318.67 226.96 318.15 230.22 318.31 232.8C316.92 232.74 315.44 232.58 313.89 232.27C311.59 231.81 309.58 231.09 309.32 231.59L309.33 231.58Z",
    fill: "#090E16"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M308.721 231.279C308.391 231.909 310.911 234.279 313.451 235.829C315.001 236.769 315.861 236.979 316.521 238.089C317.221 239.259 316.841 239.999 317.191 241.669C317.731 244.279 319.531 246.779 320.381 246.579C321.201 246.389 320.761 243.729 321.471 239.929C321.581 239.339 321.711 238.779 321.851 238.239C321.851 238.209 321.871 238.179 321.871 238.149C321.921 238.149 321.981 238.149 322.031 238.149C322.391 238.139 322.771 238.089 323.151 237.989C323.811 237.819 324.511 237.529 325.221 237.119C328.541 235.229 332.251 230.869 335.031 225.199C335.311 224.629 335.571 224.059 335.821 223.489C339.391 215.279 339.521 207.579 335.951 205.829C335.261 205.489 334.481 205.399 333.651 205.519C329.831 206.089 324.751 211.179 321.211 218.419C320.421 220.019 319.771 221.619 319.241 223.169C318.061 226.659 317.541 229.919 317.701 232.499C316.311 232.439 314.831 232.279 313.281 231.969C310.981 231.509 308.971 230.789 308.711 231.289L308.721 231.279Z",
    fill: "#858F9E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_90771_36502",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 308,
    y: 223,
    width: 18,
    height: 24
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M308.752 231.301C308.422 231.931 310.942 234.301 313.482 235.851C315.032 236.791 315.892 237.001 316.552 238.111C317.252 239.281 316.872 240.021 317.222 241.691C317.762 244.301 319.562 246.801 320.412 246.601C321.232 246.411 320.792 243.751 321.502 239.951C321.612 239.361 321.742 238.801 321.882 238.261C321.942 238.231 322.002 238.201 322.062 238.171C322.422 238.161 322.802 238.111 323.182 238.011C323.842 237.841 324.542 237.551 325.252 237.141C325.632 234.211 325.352 231.411 324.482 229.061C324.442 228.961 324.412 228.861 324.362 228.761C323.342 226.171 321.602 224.181 319.262 223.191C318.082 226.681 317.562 229.941 317.722 232.521C316.332 232.461 314.852 232.301 313.302 231.991C311.002 231.531 308.992 230.811 308.732 231.311L308.752 231.301Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_90771_36502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.709 222.742L316.039 224.442L325.059 238.592L330.099 228.322L318.709 222.742Z",
    fill: "#858F9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.04 224.441L315.91 224.521L324.98 238.751L325.06 238.591L316.04 224.441Z",
    fill: "#858F9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.911 224.523L315.781 224.603L324.901 238.913L324.981 238.753L315.911 224.523Z",
    fill: "#848E9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.782 224.602L315.652 224.682L324.832 239.072L324.902 238.912L315.782 224.602Z",
    fill: "#838D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.651 224.684L315.531 224.764L324.751 239.234L324.831 239.074L315.651 224.684Z",
    fill: "#828B9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.532 224.762L315.402 224.842L324.672 239.392L324.752 239.232L315.532 224.762Z",
    fill: "#808A99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.4 224.844L315.27 224.924L324.59 239.544L324.67 239.394L315.4 224.844Z",
    fill: "#7F8998"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.272 224.922L315.152 225.002L324.522 239.702L324.592 239.542L315.272 224.922Z",
    fill: "#7E8896"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.15 225.004L315.02 225.094L324.44 239.864L324.52 239.704L315.15 225.004Z",
    fill: "#7D8795"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.021 225.094L314.891 225.174L324.361 240.024L324.441 239.864L315.021 225.094Z",
    fill: "#7C8594"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.89 225.172L314.77 225.252L324.28 240.182L324.36 240.022L314.89 225.172Z",
    fill: "#7B8493"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.771 225.254L314.641 225.334L324.211 240.344L324.281 240.184L314.771 225.254Z",
    fill: "#798391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.642 225.332L314.512 225.412L324.132 240.492L324.212 240.342L314.642 225.332Z",
    fill: "#788290"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.511 225.414L314.391 225.494L324.051 240.654L324.131 240.494L314.511 225.414Z",
    fill: "#77818F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.392 225.492L314.262 225.572L323.972 240.812L324.052 240.652L314.392 225.492Z",
    fill: "#767F8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.263 225.57L314.133 225.65L323.903 240.97L323.973 240.81L314.263 225.57Z",
    fill: "#757E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.13 225.652L314 225.732L323.82 241.132L323.9 240.972L314.13 225.652Z",
    fill: "#747D8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.003 225.73L313.883 225.81L323.743 241.29L323.823 241.13L314.003 225.73Z",
    fill: "#737C8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.88 225.812L313.75 225.893L323.66 241.443L323.74 241.292L313.88 225.812Z",
    fill: "#727B89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.751 225.891L313.621 225.981L323.591 241.601L323.661 241.441L313.751 225.891Z",
    fill: "#707A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.62 225.98L313.5 226.06L323.51 241.76L323.59 241.6L313.62 225.98Z",
    fill: "#6F7886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.501 226.062L313.371 226.143L323.431 241.923L323.511 241.762L313.501 226.062Z",
    fill: "#6E7785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.372 226.141L313.242 226.221L323.352 242.081L323.432 241.921L313.372 226.141Z",
    fill: "#6D7684"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.241 226.223L313.121 226.303L323.271 242.243L323.351 242.083L313.241 226.223Z",
    fill: "#6C7583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.122 226.301L312.992 226.381L323.202 242.391L323.272 242.241L313.122 226.301Z",
    fill: "#6B7481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.989 226.383L312.859 226.463L323.119 242.553L323.199 242.393L312.989 226.383Z",
    fill: "#6A7380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.862 226.461L312.742 226.541L323.042 242.711L323.122 242.551L312.862 226.461Z",
    fill: "#69717F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.739 226.543L312.609 226.623L322.959 242.873L323.039 242.713L312.739 226.543Z",
    fill: "#68707E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.61 226.621L312.48 226.701L322.89 243.031L322.96 242.871L312.61 226.621Z",
    fill: "#666F7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.482 226.703L312.352 226.783L322.812 243.193L322.892 243.033L312.482 226.703Z",
    fill: "#656E7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.35 226.781L312.23 226.871L322.73 243.341L322.81 243.191L312.35 226.781Z",
    fill: "#646D7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.232 226.871L312.102 226.951L322.652 243.501L322.732 243.341L312.232 226.871Z",
    fill: "#636C79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.103 226.953L311.973 227.033L322.583 243.663L322.653 243.503L312.103 226.953Z",
    fill: "#626B78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.972 227.031L311.852 227.111L322.502 243.821L322.582 243.661L311.972 227.031Z",
    fill: "#616A76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.853 227.113L311.723 227.193L322.423 243.983L322.503 243.823L311.853 227.113Z",
    fill: "#606875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.72 227.191L311.59 227.271L322.34 244.141L322.42 243.981L311.72 227.191Z",
    fill: "#5F6774"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.593 227.273L311.473 227.353L322.273 244.293L322.343 244.143L311.593 227.273Z",
    fill: "#5E6673"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.47 227.352L311.34 227.432L322.19 244.452L322.27 244.292L311.47 227.352Z",
    fill: "#5D6572"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.341 227.434L311.211 227.514L322.111 244.614L322.191 244.454L311.341 227.434Z",
    fill: "#5C6471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.21 227.512L311.09 227.592L322.03 244.772L322.11 244.612L311.21 227.512Z",
    fill: "#5B636F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.091 227.594L310.961 227.674L321.961 244.934L322.031 244.774L311.091 227.594Z",
    fill: "#59626E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.962 227.672L310.832 227.762L321.882 245.092L321.962 244.932L310.962 227.672Z",
    fill: "#58616D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.829 227.762L310.699 227.842L321.799 245.242L321.879 245.092L310.829 227.762Z",
    fill: "#575F6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.702 227.844L310.582 227.924L321.722 245.404L321.802 245.244L310.702 227.844Z",
    fill: "#565E6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.579 227.922L310.449 228.002L321.649 245.562L321.719 245.402L310.579 227.922Z",
    fill: "#555D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.45 228.004L310.32 228.084L321.57 245.724L321.65 245.564L310.45 228.004Z",
    fill: "#545C68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.322 228.082L310.312 228.092L310.242 228.232L321.492 245.882L321.572 245.722L310.322 228.082Z",
    fill: "#535B67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.16 228.39L321.41 246.04L321.49 245.88L310.24 228.23L310.16 228.39Z",
    fill: "#525A66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.09 228.551L321.33 246.191L321.41 246.041L310.16 228.391L310.09 228.551Z",
    fill: "#515965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.012 228.701L321.262 246.351L321.332 246.191L310.092 228.551L310.012 228.701Z",
    fill: "#505864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.93 228.863L321.18 246.513L321.26 246.353L310.01 228.703L309.93 228.863Z",
    fill: "#4F5763"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.852 229.023L321.102 246.673L321.182 246.513L309.932 228.863L309.852 229.023Z",
    fill: "#4E5662"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.77 229.183L321.02 246.833L321.1 246.673L309.85 229.023L309.77 229.183Z",
    fill: "#4D5560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.699 229.344L320.949 246.994L321.019 246.834L309.769 229.184L309.699 229.344Z",
    fill: "#4C545F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.621 229.504L320.871 247.144L320.951 246.994L309.701 229.344L309.621 229.504Z",
    fill: "#4B535E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.539 229.654L320.789 247.304L320.869 247.144L309.619 229.504L309.539 229.654Z",
    fill: "#4A515D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.461 229.812L320.621 247.312L320.761 247.372L320.791 247.302L309.541 229.652L309.461 229.812Z",
    fill: "#49505C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.391 229.973L320.361 247.182L320.621 247.312L309.461 229.812L309.391 229.973Z",
    fill: "#484F5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.312 230.133L320.103 247.053L320.362 247.183L309.393 229.973L309.312 230.133Z",
    fill: "#474E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.23 230.293L319.84 246.923L320.1 247.053L309.31 230.133L309.23 230.293Z",
    fill: "#464D59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.152 230.453L319.582 246.803L319.842 246.923L309.232 230.293L309.152 230.453Z",
    fill: "#454C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.082 230.603L319.322 246.673L319.582 246.803L309.152 230.453L309.082 230.603Z",
    fill: "#444B57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309 230.762L319.06 246.542L319.32 246.672L309.08 230.602L309 230.762Z",
    fill: "#434A55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.922 230.922L318.802 246.422L319.062 246.542L309.002 230.762L308.922 230.922Z",
    fill: "#424954"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.84 231.082L318.54 246.292L318.8 246.422L308.92 230.922L308.84 231.082Z",
    fill: "#414853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.77 231.242L318.28 246.162L318.54 246.292L308.84 231.082L308.77 231.242Z",
    fill: "#404752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.691 231.402L318.021 246.032L318.281 246.162L308.771 231.242L308.691 231.402Z",
    fill: "#3F4651"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.609 231.552L317.759 245.912L318.019 246.032L308.689 231.402L308.609 231.552Z",
    fill: "#3E4550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.531 231.711L317.501 245.781L317.761 245.911L308.611 231.551L308.531 231.711Z",
    fill: "#3D444F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.461 231.871L317.241 245.651L317.501 245.781L308.531 231.711L308.461 231.871Z",
    fill: "#3C434E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.383 232.031L316.983 245.521L317.243 245.651L308.463 231.871L308.383 232.031Z",
    fill: "#3B424D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.301 232.191L316.721 245.401L316.981 245.521L308.381 232.031L308.301 232.191Z",
    fill: "#3A414C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.223 232.351L316.463 245.271L316.723 245.401L308.303 232.191L308.223 232.351Z",
    fill: "#39404B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.152 232.502L316.202 245.142L316.462 245.272L308.222 232.352L308.152 232.502Z",
    fill: "#383F4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.07 232.664L315.94 245.024L316.2 245.144L308.15 232.504L308.07 232.664Z",
    fill: "#373E49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.992 232.824L315.682 244.894L315.942 245.024L308.072 232.664L307.992 232.824Z",
    fill: "#363D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.91 232.98L315.42 244.76L315.68 244.89L307.99 232.82L307.91 232.98Z",
    fill: "#353C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.84 233.14L315.16 244.63L315.42 244.76L307.91 232.98L307.84 233.14Z",
    fill: "#343B46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.762 233.301L314.902 244.511L315.162 244.631L307.842 233.141L307.762 233.301Z",
    fill: "#333A45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.68 233.451L314.64 244.381L314.9 244.511L307.76 233.301L307.68 233.451Z",
    fill: "#333944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.602 233.613L314.382 244.253L314.642 244.383L307.682 233.453L307.602 233.613Z",
    fill: "#323843"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.52 233.773L314.12 244.133L314.38 244.253L307.6 233.613L307.52 233.773Z",
    fill: "#313742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.449 233.933L313.869 244.003L314.119 244.133L307.519 233.773L307.449 233.933Z",
    fill: "#303641"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.371 234.094L313.611 243.874L313.871 244.004L307.451 233.934L307.371 234.094Z",
    fill: "#2F3540"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.289 234.254L313.349 243.744L313.609 243.874L307.369 234.094L307.289 234.254Z",
    fill: "#2E343F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.211 234.404L313.091 243.624L313.351 243.744L307.291 234.254L307.211 234.404Z",
    fill: "#2D343E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.141 234.562L312.831 243.492L313.091 243.622L307.211 234.402L307.141 234.562Z",
    fill: "#2C333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.062 234.723L312.573 243.363L312.832 243.493L307.143 234.562L307.062 234.723Z",
    fill: "#2B323C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.98 234.883L312.31 243.233L312.57 243.363L307.06 234.723L306.98 234.883Z",
    fill: "#2A313B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.902 235.043L312.052 243.113L312.312 243.233L306.982 234.883L306.902 235.043Z",
    fill: "#2A303A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.832 235.203L311.792 242.983L312.052 243.113L306.902 235.043L306.832 235.203Z",
    fill: "#292F39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.75 235.353L311.53 242.853L311.79 242.983L306.83 235.203L306.75 235.353Z",
    fill: "#282E38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.672 235.512L311.272 242.732L311.532 242.852L306.752 235.352L306.672 235.512Z",
    fill: "#272D37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.59 235.672L311.01 242.602L311.27 242.732L306.67 235.512L306.59 235.672Z",
    fill: "#262C36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.52 235.832L310.75 242.472L311.01 242.602L306.59 235.672L306.52 235.832Z",
    fill: "#252B35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.441 235.992L310.491 242.342L310.751 242.472L306.521 235.832L306.441 235.992Z",
    fill: "#242A34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.359 236.152L310.229 242.222L310.489 242.342L306.439 235.992L306.359 236.152Z",
    fill: "#232A33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.281 236.302L309.971 242.092L310.231 242.222L306.361 236.152L306.281 236.302Z",
    fill: "#232932"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.211 236.461L309.711 241.961L309.971 242.091L306.281 236.301L306.211 236.461Z",
    fill: "#222831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.133 236.621L309.453 241.831L309.713 241.961L306.213 236.461L306.133 236.621Z",
    fill: "#212730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.051 236.781L309.191 241.711L309.451 241.831L306.131 236.621L306.051 236.781Z",
    fill: "#20262F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.973 236.941L308.933 241.581L309.193 241.711L306.053 236.781L305.973 236.941Z",
    fill: "#1F252F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.902 237.101L308.672 241.451L308.932 241.581L305.972 236.941L305.902 237.101Z",
    fill: "#1F242E"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.24
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M333.652 205.51C333.342 206.6 333.322 207.94 333.772 209.03C334.452 210.68 335.772 210.68 336.812 212.02C339.652 215.69 335.252 222.85 335.832 223.47C339.402 215.26 339.532 207.56 335.962 205.81C335.272 205.47 334.492 205.38 333.662 205.5L333.652 205.51Z",
    fill: "#090E16"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.812 213.67C329.115 213.67 329.362 213.424 329.362 213.12C329.362 212.817 329.115 212.57 328.812 212.57C328.508 212.57 328.262 212.817 328.262 213.12C328.262 213.424 328.508 213.67 328.812 213.67Z",
    fill: "#090E16"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.291 218.148C330.976 218.148 331.531 217.593 331.531 216.908C331.531 216.223 330.976 215.668 330.291 215.668C329.606 215.668 329.051 216.223 329.051 216.908C329.051 217.593 329.606 218.148 330.291 218.148Z",
    fill: "#090E16"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.279 218.418C326.511 218.418 326.699 218.23 326.699 217.998C326.699 217.766 326.511 217.578 326.279 217.578C326.047 217.578 325.859 217.766 325.859 217.998C325.859 218.23 326.047 218.418 326.279 218.418Z",
    fill: "#090E16"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.83 222.289C326.924 222.289 327 222.213 327 222.119C327 222.025 326.924 221.949 326.83 221.949C326.736 221.949 326.66 222.025 326.66 222.119C326.66 222.213 326.736 222.289 326.83 222.289Z",
    fill: "#090E16"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.041 228.11C329.235 228.11 329.391 227.953 329.391 227.76C329.391 227.567 329.235 227.41 329.041 227.41C328.848 227.41 328.691 227.567 328.691 227.76C328.691 227.953 328.848 228.11 329.041 228.11Z",
    fill: "#090E16"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.061 230.829C323.856 230.829 324.501 230.185 324.501 229.389C324.501 228.594 323.856 227.949 323.061 227.949C322.266 227.949 321.621 228.594 321.621 229.389C321.621 230.185 322.266 230.829 323.061 230.829Z",
    fill: "#090E16"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_90771_36502",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 308,
    y: 205,
    width: 30,
    height: 30
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M308.72 231.281C308.98 230.771 310.98 231.501 313.29 231.961C314.84 232.271 316.32 232.431 317.71 232.491C317.55 229.911 318.07 226.651 319.25 223.161C319.78 221.611 320.43 220.011 321.22 218.411C324.77 211.171 329.85 206.081 333.66 205.511C334.5 205.391 335.28 205.481 335.96 205.821C336.7 206.181 337.28 206.801 337.7 207.631C327.57 212.251 322.38 224.111 320.67 234.571C317.2 233.051 313.78 232.901 310.89 234.001C309.49 232.831 308.51 231.701 308.72 231.291V231.281Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_90771_36502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.922 206.799L321.934 239.422L322.086 239.497L338.075 206.874L337.922 206.799Z",
    fill: "#858F9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.813 206.737L321.824 239.359L321.932 239.412L337.921 206.79L337.813 206.737Z",
    fill: "#858F9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.707 206.694L321.719 239.316L321.827 239.369L337.815 206.747L337.707 206.694Z",
    fill: "#87909F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.61 206.631L321.621 239.254L321.729 239.307L337.718 206.684L337.61 206.631Z",
    fill: "#8892A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.485 206.577L321.496 239.199L321.604 239.252L337.593 206.629L337.485 206.577Z",
    fill: "#8A93A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.383 206.534L321.395 239.156L321.502 239.209L337.491 206.586L337.383 206.534Z",
    fill: "#8B95A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.282 206.479L321.293 239.102L321.401 239.154L337.389 206.532L337.282 206.479Z",
    fill: "#8D96A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.176 206.436L321.188 239.059L321.295 239.111L337.284 206.489L337.176 206.436Z",
    fill: "#8E97A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.059 206.37L321.07 238.992L321.178 239.045L337.167 206.422L337.059 206.37Z",
    fill: "#9099A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.954 206.315L320.965 238.938L321.073 238.99L337.061 206.368L336.954 206.315Z",
    fill: "#919AA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.852 206.272L320.863 238.895L320.971 238.947L336.96 206.325L336.852 206.272Z",
    fill: "#939BA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.731 206.213L320.742 238.836L320.85 238.889L336.839 206.266L336.731 206.213Z",
    fill: "#949DAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.629 206.151L320.641 238.773L320.748 238.826L336.737 206.204L336.629 206.151Z",
    fill: "#969EAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.528 206.108L320.539 238.73L320.647 238.783L336.636 206.161L336.528 206.108Z",
    fill: "#97A0AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.426 206.057L320.438 238.68L320.545 238.732L336.534 206.11L336.426 206.057Z",
    fill: "#98A1AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.301 205.999L320.312 238.621L320.42 238.674L336.409 206.051L336.301 205.999Z",
    fill: "#9AA2AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.2 205.956L320.211 238.578L320.319 238.631L336.307 206.008L336.2 205.956Z",
    fill: "#9BA4B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.098 205.893L320.109 238.516L320.217 238.568L336.206 205.946L336.098 205.893Z",
    fill: "#9DA5B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.977 205.834L319.988 238.457L320.096 238.51L336.085 205.887L335.977 205.834Z",
    fill: "#9EA6B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.875 205.792L319.887 238.414L319.994 238.467L335.983 205.844L335.875 205.792Z",
    fill: "#A0A7B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.77 205.741L319.781 238.363L319.889 238.416L335.878 205.794L335.77 205.741Z",
    fill: "#A1A9B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.672 205.686L319.684 238.309L319.791 238.361L335.78 205.739L335.672 205.686Z",
    fill: "#A2AAB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.551 205.627L319.562 238.25L319.67 238.303L335.659 205.68L335.551 205.627Z",
    fill: "#A4ABB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.446 205.577L319.457 238.199L319.565 238.252L335.553 205.629L335.446 205.577Z",
    fill: "#A5ADB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.344 205.534L319.355 238.156L319.463 238.209L335.452 205.587L335.344 205.534Z",
    fill: "#A7AEB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.219 205.475L319.23 238.098L319.338 238.15L335.327 205.528L335.219 205.475Z",
    fill: "#A8AFBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.121 205.413L319.133 238.035L319.241 238.088L335.229 205.465L335.121 205.413Z",
    fill: "#A9B0BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.02 205.37L319.031 237.992L319.139 238.045L335.128 205.422L335.02 205.37Z",
    fill: "#ABB2BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.907 205.315L318.918 237.938L319.026 237.99L335.014 205.368L334.907 205.315Z",
    fill: "#ACB3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.793 205.26L318.805 237.883L318.912 237.936L334.901 205.313L334.793 205.26Z",
    fill: "#ADB4BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.696 205.206L318.707 237.828L318.815 237.881L334.803 205.258L334.696 205.206Z",
    fill: "#AFB5BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.59 205.155L318.602 237.777L318.709 237.83L334.698 205.208L334.59 205.155Z",
    fill: "#B0B7C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.469 205.104L318.48 237.727L318.588 237.779L334.577 205.157L334.469 205.104Z",
    fill: "#B1B8C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.364 205.053L318.375 237.676L318.483 237.729L334.471 205.106L334.364 205.053Z",
    fill: "#B3B9C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.262 204.999L318.273 237.621L318.381 237.674L334.37 205.051L334.262 204.999Z",
    fill: "#B4BAC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.153 204.948L318.164 237.57L318.272 237.623L334.26 205.001L334.153 204.948Z",
    fill: "#B5BBC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.039 204.889L318.051 237.512L318.159 237.565L334.147 204.942L334.039 204.889Z",
    fill: "#B7BDC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.938 204.834L317.949 237.457L318.057 237.51L334.046 204.887L333.938 204.834Z",
    fill: "#B8BEC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.832 204.791L317.844 237.414L317.951 237.467L333.94 204.844L333.832 204.791Z",
    fill: "#B9BFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.711 204.737L317.723 237.359L317.83 237.412L333.819 204.79L333.711 204.737Z",
    fill: "#BAC0C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.614 204.674L317.625 237.297L317.733 237.35L333.721 204.727L333.614 204.674Z",
    fill: "#BCC1C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.508 204.631L317.52 237.254L317.627 237.307L333.616 204.684L333.508 204.631Z",
    fill: "#BDC2CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.395 204.577L317.406 237.199L317.514 237.252L333.503 204.629L333.395 204.577Z",
    fill: "#BEC3CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.286 204.53L317.297 237.152L317.405 237.205L333.393 204.583L333.286 204.53Z",
    fill: "#BFC5CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.184 204.467L317.195 237.09L317.303 237.143L333.292 204.52L333.184 204.467Z",
    fill: "#C1C6CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.071 204.413L317.082 237.035L317.19 237.088L333.178 204.465L333.071 204.413Z",
    fill: "#C2C7CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.969 204.37L316.98 236.992L317.088 237.045L333.077 204.422L332.969 204.37Z",
    fill: "#C3C8CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.856 204.311L316.867 236.934L316.975 236.986L332.964 204.364L332.856 204.311Z",
    fill: "#C4C9D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.754 204.26L316.766 236.883L316.873 236.936L332.862 204.313L332.754 204.26Z",
    fill: "#C5CAD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.645 204.206L316.656 236.828L316.764 236.881L332.753 204.258L332.645 204.206Z",
    fill: "#C7CBD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.532 204.151L316.543 236.773L316.651 236.826L332.639 204.204L332.532 204.151Z",
    fill: "#C8CCD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.43 204.096L316.441 236.719L316.549 236.772L332.538 204.149L332.43 204.096Z",
    fill: "#C9CDD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.317 204.053L316.328 236.676L316.436 236.729L332.425 204.106L332.317 204.053Z",
    fill: "#CACED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.215 203.991L316.227 236.613L316.334 236.666L332.323 204.044L332.215 203.991Z",
    fill: "#CBD0D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.102 203.932L316.113 236.555L316.221 236.608L332.21 203.985L332.102 203.932Z",
    fill: "#CCD1D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332 203.889L316.012 236.512L316.119 236.565L332.108 203.942L332 203.889Z",
    fill: "#CED2D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.887 203.838L315.898 236.461L316.006 236.514L331.995 203.891L331.887 203.838Z",
    fill: "#CFD3D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.774 203.788L315.785 236.41L315.893 236.463L331.882 203.84L331.774 203.788Z",
    fill: "#D0D4D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.676 203.729L315.688 236.352L315.795 236.404L331.784 203.782L331.676 203.729Z",
    fill: "#D1D5DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.563 203.674L315.574 236.297L315.682 236.35L331.671 203.727L331.563 203.674Z",
    fill: "#D2D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.461 203.631L315.473 236.254L315.58 236.307L331.569 203.684L331.461 203.631Z",
    fill: "#D3D7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.348 203.573L315.359 236.195L315.467 236.248L331.456 203.626L331.348 203.573Z",
    fill: "#D4D8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.246 203.51L315.258 236.133L315.366 236.186L331.354 203.563L331.246 203.51Z",
    fill: "#D5D9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.133 203.467L315.145 236.09L315.252 236.143L331.241 203.52L331.133 203.467Z",
    fill: "#D6DADF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.024 203.409L315.035 236.031L315.143 236.084L331.132 203.462L331.024 203.409Z",
    fill: "#D7DBDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.918 203.358L314.93 235.98L315.037 236.033L331.026 203.411L330.918 203.358Z",
    fill: "#D8DCE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.805 203.315L314.816 235.938L314.924 235.99L330.913 203.368L330.805 203.315Z",
    fill: "#D9DCE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.707 203.252L314.719 235.875L314.826 235.928L330.815 203.305L330.707 203.252Z",
    fill: "#DADDE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.594 203.206L314.605 235.828L314.713 235.881L330.702 203.258L330.594 203.206Z",
    fill: "#DBDEE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.481 203.151L314.492 235.773L314.6 235.826L330.589 203.204L330.481 203.151Z",
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.379 203.096L314.391 235.719L314.498 235.772L330.487 203.149L330.379 203.096Z",
    fill: "#DDE0E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.27 203.042L314.281 235.664L314.389 235.717L330.378 203.094L330.27 203.042Z",
    fill: "#DEE1E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.168 202.987L314.18 235.609L314.287 235.662L330.276 203.04L330.168 202.987Z",
    fill: "#DFE2E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.055 202.936L314.066 235.559L314.174 235.611L330.163 202.989L330.055 202.936Z",
    fill: "#E0E3E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.95 202.889L313.961 235.512L314.069 235.565L330.057 202.942L329.95 202.889Z",
    fill: "#E1E4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.836 202.834L313.848 235.457L313.955 235.51L329.944 202.887L329.836 202.834Z",
    fill: "#E2E5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.731 202.772L313.742 235.395L313.85 235.447L329.839 202.825L329.731 202.772Z",
    fill: "#E3E5E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.625 202.729L313.637 235.352L313.744 235.404L329.733 202.782L329.625 202.729Z",
    fill: "#E4E6EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.512 202.67L313.523 235.293L313.631 235.346L329.62 202.723L329.512 202.67Z",
    fill: "#E5E7EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.411 202.627L313.422 235.25L313.53 235.303L329.518 202.68L329.411 202.627Z",
    fill: "#E6E8EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.297 202.573L313.309 235.195L313.416 235.248L329.405 202.626L329.297 202.573Z",
    fill: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.2 202.51L313.211 235.133L313.319 235.186L329.307 202.563L329.2 202.51Z",
    fill: "#E8EAEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.086 202.463L313.098 235.086L313.205 235.139L329.194 202.516L329.086 202.463Z",
    fill: "#E9EAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.973 202.413L312.984 235.035L313.092 235.088L329.081 202.465L328.973 202.413Z",
    fill: "#E9EBEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.868 202.358L312.879 234.98L312.987 235.033L328.975 202.411L328.868 202.358Z",
    fill: "#EAECEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.762 202.299L312.773 234.922L312.881 234.975L328.87 202.352L328.762 202.299Z",
    fill: "#EBEDEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.657 202.249L312.668 234.871L312.776 234.924L328.764 202.301L328.657 202.249Z",
    fill: "#ECEDF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.543 202.194L312.555 234.816L312.662 234.869L328.651 202.247L328.543 202.194Z",
    fill: "#EDEEF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.442 202.151L312.453 234.773L312.561 234.826L328.55 202.204L328.442 202.151Z",
    fill: "#EDEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.329 202.092L312.34 234.715L312.448 234.768L328.436 202.145L328.329 202.092Z",
    fill: "#EEF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.219 202.03L312.23 234.652L312.338 234.705L328.327 202.083L328.219 202.03Z",
    fill: "#EFF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.118 201.987L312.129 234.609L312.237 234.662L328.225 202.04L328.118 201.987Z",
    fill: "#F0F1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.004 201.932L312.016 234.555L312.123 234.607L328.112 201.985L328.004 201.932Z",
    fill: "#F1F2F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.891 201.889L311.902 234.512L312.01 234.565L327.999 201.942L327.891 201.889Z",
    fill: "#F1F2F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.793 201.827L311.805 234.449L311.912 234.502L327.901 201.879L327.793 201.827Z",
    fill: "#F2F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.688 201.772L311.699 234.395L311.807 234.447L327.796 201.825L327.688 201.772Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.579 201.725L311.59 234.348L311.698 234.4L327.686 201.778L327.579 201.725Z",
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.465 201.67L311.477 234.293L311.584 234.346L327.573 201.723L327.465 201.67Z",
    fill: "#F4F5F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.36 201.62L311.371 234.242L311.479 234.295L327.468 201.672L327.36 201.62Z",
    fill: "#F5F6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.262 201.565L311.273 234.188L311.381 234.24L327.37 201.618L327.262 201.565Z",
    fill: "#F5F6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.137 201.506L311.148 234.129L311.256 234.182L327.245 201.559L327.137 201.506Z",
    fill: "#F6F7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.036 201.456L311.047 234.078L311.155 234.131L327.143 201.508L327.036 201.456Z",
    fill: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.934 201.413L310.945 234.035L311.053 234.088L327.042 201.465L326.934 201.413Z",
    fill: "#F7F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.825 201.346L310.836 233.969L310.944 234.022L326.932 201.399L326.825 201.346Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.711 201.303L310.723 233.926L310.83 233.979L326.819 201.356L326.711 201.303Z",
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.606 201.249L310.617 233.871L310.725 233.924L326.714 201.301L326.606 201.249Z",
    fill: "#F9F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.504 201.194L310.516 233.816L310.623 233.869L326.612 201.247L326.504 201.194Z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.383 201.147L310.395 233.77L310.502 233.822L326.491 201.2L326.383 201.147Z",
    fill: "#FAFAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.282 201.084L310.293 233.707L310.401 233.76L326.389 201.137L326.282 201.084Z",
    fill: "#FAFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.18 201.034L310.191 233.656L310.299 233.709L326.288 201.086L326.18 201.034Z",
    fill: "#FBFBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.059 200.983L310.07 233.605L310.178 233.658L326.167 201.036L326.059 200.983Z",
    fill: "#FBFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.954 200.932L309.965 233.555L310.073 233.607L326.061 200.985L325.954 200.932Z",
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.856 200.87L309.867 233.492L309.975 233.545L325.964 200.922L325.856 200.87Z",
    fill: "#FCFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.75 200.827L309.762 233.449L309.869 233.502L325.858 200.879L325.75 200.827Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.629 200.768L309.641 233.391L309.748 233.443L325.737 200.821L325.629 200.768Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.528 200.725L309.539 233.348L309.647 233.4L325.636 200.778L325.528 200.725Z",
    fill: "#FDFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.422 200.67L309.434 233.293L309.541 233.346L325.53 200.723L325.422 200.67Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.305 200.604L309.316 233.227L309.424 233.279L325.413 200.657L325.305 200.604Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.204 200.561L309.215 233.184L309.323 233.236L325.311 200.614L325.204 200.561Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.098 200.51L309.109 233.133L309.217 233.186L325.206 200.563L325.098 200.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.997 200.456L309.008 233.078L309.116 233.131L325.104 200.508L324.997 200.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.871 200.409L308.883 233.031L308.991 233.084L324.979 200.462L324.871 200.409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.774 200.346L308.785 232.969L308.893 233.022L324.882 200.399L324.774 200.346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.059 199.995L308.07 232.617L308.789 232.969L324.777 200.347L324.059 199.995Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.24
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M330.78 209.406L331.73 209.876L332.2 208.926C332.25 208.816 332.39 208.776 332.49 208.826C332.59 208.876 332.64 209.016 332.59 209.116L332.12 210.066L333.07 210.536C333.18 210.586 333.22 210.726 333.17 210.826C333.12 210.926 332.98 210.976 332.88 210.926L331.93 210.456L331.46 211.406C331.41 211.516 331.27 211.556 331.17 211.506C331.07 211.456 331.02 211.316 331.07 211.216L331.54 210.266L330.59 209.796C330.48 209.746 330.44 209.606 330.49 209.506C330.54 209.406 330.68 209.356 330.78 209.406Z",
    fill: "#090E16"
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M330.659 209.078L331.609 209.548L332.079 208.598C332.129 208.488 332.269 208.448 332.369 208.498C332.469 208.548 332.519 208.688 332.469 208.788L331.999 209.738L332.949 210.208C333.059 210.258 333.099 210.398 333.049 210.498C332.999 210.598 332.859 210.648 332.759 210.598L331.809 210.128L331.339 211.078C331.289 211.188 331.149 211.228 331.049 211.178C330.949 211.128 330.899 210.988 330.949 210.888L331.419 209.938L330.469 209.468C330.359 209.418 330.319 209.278 330.369 209.178C330.419 209.078 330.559 209.028 330.659 209.078Z",
    fill: "#090E16"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M348.781 241.172C342.961 238.222 334.271 232.822 327.061 223.342C317.271 210.482 315.371 196.892 312.971 179.842C311.481 169.262 311.371 160.802 311.371 143.872C311.371 130.822 311.901 118.562 312.971 107.102C314.301 95.3816 316.431 85.1216 319.361 76.3316C322.561 67.5416 327.221 60.6116 333.351 55.5516C338.181 51.5616 344.181 49.1516 351.331 48.3016C346.791 32.5116 340.441 17.2116 331.801 2.60156C325.021 4.13156 318.871 6.32156 313.371 9.19156C301.911 15.3216 292.591 23.4416 285.391 33.5716C278.201 43.6916 272.741 55.0216 269.001 67.5416C265.541 80.0616 263.141 92.8516 261.811 105.902C260.741 118.692 260.211 130.812 260.211 142.272C260.211 153.732 260.881 166.512 262.211 179.842C263.541 193.162 265.941 206.082 269.401 218.602C273.131 231.122 278.591 242.582 285.791 252.972C292.981 263.092 302.441 271.222 314.161 277.352C316.861 278.762 319.711 280.012 322.711 281.092C324.801 280.652 337.521 277.772 344.881 265.332C351.311 254.472 349.301 243.672 348.771 241.162L348.781 241.172Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M343.98 222.532C342.28 221.032 340.18 220.112 337.82 220.162C336.95 219.322 335.94 218.622 334.83 218.172C333.62 215.402 331.26 213.252 327.86 213.162C323.7 213.062 318.58 216.322 318.8 221.062C319.03 225.812 319.5 231.372 323.82 234.312C324.9 235.052 326.1 235.542 327.35 235.792C328.69 237.462 330.38 238.772 332.52 239.352C335.11 240.062 337.75 239.852 340.11 238.572C340.42 238.402 340.71 238.212 341 238.012C341.06 238.012 341.12 238.012 341.18 238.002C345.62 237.622 348.9 232.162 347.9 228.032C347.28 225.462 345.86 223.622 343.96 222.522L343.98 222.532Z",
    fill: "url(#paint2_radial_90771_36502)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M381.668 244.439C381.118 244.399 378.378 244.129 374.708 244.589C370.718 245.089 367.908 246.179 367.378 246.369C363.868 247.589 355.418 245.469 333.898 231.109C335.138 234.609 339.588 245.819 351.458 252.809C353.748 254.159 371.328 264.109 388.568 254.369C399.858 247.989 406.698 235.589 406.498 222.219C392.388 240.539 385.418 244.689 381.688 244.439H381.668Z",
    fill: "url(#paint3_radial_90771_36502)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M408.921 239.628C406.581 243.028 402.981 243.968 398.751 245.078C393.221 246.538 383.821 249.008 378.401 243.538C372.891 237.988 373.971 226.768 377.171 225.188C377.741 224.908 378.691 224.778 379.581 224.958C382.191 225.498 383.051 228.488 384.031 228.218C385.061 227.928 384.111 224.658 386.061 223.148C386.881 222.508 387.941 222.418 388.981 222.318C389.391 222.278 390.881 222.128 392.211 222.638C395.271 223.788 395.551 227.568 396.541 227.408C397.261 227.288 396.811 225.368 398.431 223.508C398.561 223.358 400.461 221.238 403.081 221.188C405.211 221.148 406.651 222.478 407.321 223.098C411.121 226.608 412.451 234.488 408.911 239.618L408.921 239.628Z",
    fill: "#EDBF1C"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.669 240.667C385.869 242.507 379.389 241.257 376.199 240.417C376.769 241.567 377.489 242.637 378.399 243.547C383.829 249.017 393.219 246.537 398.749 245.087C402.969 243.977 406.579 243.027 408.919 239.637C410.629 237.147 411.199 234.017 410.909 231.047C408.559 233.387 402.779 238.517 393.669 240.667Z",
    fill: "white"
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M384.281 229.669C384.401 229.249 385.261 226.429 388.001 225.339C389.541 224.719 390.911 224.959 391.441 225.059C394.671 225.669 396.321 228.499 396.611 228.999C396.911 227.989 397.621 226.179 399.281 224.609C399.731 224.179 400.581 223.379 401.671 222.999C405.211 221.769 409.171 225.769 409.341 225.939C409.051 225.259 408.471 224.129 407.341 223.109C406.711 222.539 405.231 221.209 403.101 221.199C400.701 221.189 399.081 222.859 398.451 223.519C397.001 225.029 396.511 226.719 396.341 227.509C396.201 227.029 395.151 223.699 392.221 222.649C390.861 222.159 389.441 222.289 388.991 222.329C388.201 222.399 387.041 222.509 386.071 223.159C383.901 224.609 384.021 227.869 384.041 228.229C383.621 227.509 382.561 225.959 380.611 225.219C380.021 224.999 379.171 224.679 378.111 224.889C376.311 225.239 375.381 226.799 375.171 227.169C374.131 228.929 374.511 230.739 374.611 231.169C374.611 230.609 374.701 229.449 375.501 228.499C377.231 226.459 380.601 227.389 381.001 227.499C382.671 227.979 383.741 229.029 384.281 229.669Z",
    fill: "#E9AB21"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M344.269 245.47C344.269 245.47 345.359 250.5 351.659 253.42C352.679 253.89 353.409 253.96 354.039 253.79C355.249 253.47 355.959 252.37 356.129 252.1C356.709 251.15 356.449 250.69 356.979 249.85C357.589 248.88 358.569 248.51 359.069 248.31C363.719 246.41 371.639 243.18 372.019 240.19C372.369 237.4 366.209 234.16 362.639 233.01C360.479 232.32 358.689 232.2 357.899 232.18C354.669 232.08 352.299 232.93 351.759 233.13C350.309 233.67 348.249 234.44 346.559 236.39C344.569 238.69 343.549 242.1 344.279 245.47H344.269Z",
    fill: "#E9AB21"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M348.427 236.578C351.157 231.678 356.317 232.058 361.527 232.438C366.227 232.778 370.717 233.108 373.027 237.508C376.277 243.688 372.777 253.398 370.377 254.298C369.947 254.458 369.187 254.478 368.587 254.128C367.337 253.398 367.647 251.458 366.927 251.368C366.097 251.278 365.697 253.828 363.777 254.618C362.947 254.958 362.087 254.878 361.717 254.838C361.447 254.808 360.447 254.718 359.607 254.158C357.677 252.858 357.717 249.778 357.037 249.788C356.547 249.788 356.747 251.418 355.607 252.648C355.517 252.748 354.257 254.078 352.627 253.768C351.327 253.518 350.427 252.358 349.997 251.798C347.677 248.778 345.517 241.728 348.397 236.568L348.427 236.578Z",
    fill: "#EDBF1C"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.359 245.401C347.909 248.691 349.219 250.751 350.029 251.811C350.409 252.311 351.089 253.261 352.279 253.691C352.889 253.911 353.329 253.891 353.419 253.891C354.669 253.841 355.519 252.901 355.689 252.711C356.879 251.401 356.639 249.841 357.049 249.801C357.629 249.741 357.599 252.811 359.619 254.171C360.449 254.731 361.449 254.831 361.729 254.851C362.089 254.891 362.949 254.971 363.789 254.631C365.709 253.841 366.109 251.291 366.939 251.381C367.659 251.461 367.349 253.411 368.599 254.141C369.299 254.541 370.079 254.391 370.329 254.321C370.329 254.321 370.359 254.321 370.389 254.311C371.379 254.031 372.189 252.431 372.369 252.061C372.769 251.261 373.269 250.081 373.659 248.541C373.449 249.201 373.009 250.331 372.049 251.381C371.499 251.991 370.909 252.631 370.139 252.731C368.919 252.901 367.569 251.691 366.789 249.761C366.679 249.891 364.669 252.251 361.629 251.801C358.539 251.351 357.349 248.461 357.289 248.301C357.079 248.551 355.309 250.641 352.669 250.521C350.139 250.411 347.879 248.321 347.359 245.391V245.401Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("path", {
    d: "M442.09 167.172C442.43 167.862 439.66 170.362 436.87 171.972C435.17 172.952 434.24 173.162 433.5 174.342C432.72 175.592 433.11 176.402 432.7 178.192C432.06 181.002 430.05 183.662 429.14 183.422C428.25 183.192 428.8 180.332 428.12 176.212C428.01 175.582 427.89 174.962 427.75 174.372C427.75 174.342 427.73 174.312 427.73 174.282C427.67 174.282 427.62 174.282 427.56 174.282C427.17 174.262 426.76 174.192 426.35 174.082C425.64 173.882 424.89 173.552 424.13 173.092C420.59 170.972 416.67 166.182 413.8 159.982C413.51 159.362 413.24 158.742 412.99 158.122C409.32 149.162 409.36 140.842 413.26 139.032C414.01 138.682 414.85 138.602 415.76 138.752C419.87 139.452 425.25 145.082 428.91 152.982C429.72 154.732 430.39 156.472 430.93 158.162C432.12 161.962 432.61 165.492 432.37 168.282C433.87 168.252 435.47 168.112 437.16 167.812C439.66 167.372 441.85 166.632 442.11 167.182L442.09 167.172Z",
    fill: "#090E16"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M442.75 166.863C443.09 167.553 440.32 170.053 437.53 171.663C435.83 172.643 434.9 172.853 434.16 174.033C433.38 175.283 433.77 176.093 433.36 177.883C432.72 180.693 430.71 183.353 429.8 183.113C428.91 182.883 429.46 180.023 428.78 175.903C428.67 175.273 428.55 174.653 428.41 174.063C428.41 174.033 428.39 174.003 428.39 173.973C428.33 173.973 428.28 173.973 428.22 173.973C427.83 173.953 427.42 173.883 427.01 173.773C426.3 173.573 425.55 173.243 424.79 172.783C421.25 170.663 417.33 165.873 414.46 159.673C414.17 159.053 413.9 158.433 413.65 157.813C409.98 148.853 410.02 140.533 413.92 138.723C414.67 138.373 415.51 138.293 416.42 138.443C420.53 139.143 425.91 144.773 429.57 152.673C430.38 154.423 431.05 156.163 431.59 157.853C432.78 161.653 433.27 165.183 433.03 167.973C434.53 167.943 436.13 167.803 437.82 167.503C440.32 167.063 442.51 166.323 442.77 166.873L442.75 166.863Z",
    fill: "#858F9E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_90771_36502",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 424,
    y: 157,
    width: 19,
    height: 27
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M442.708 166.883C443.048 167.573 440.278 170.073 437.488 171.683C435.788 172.663 434.858 172.873 434.118 174.053C433.338 175.303 433.728 176.113 433.318 177.903C432.678 180.713 430.668 183.373 429.758 183.133C428.868 182.903 429.418 180.043 428.738 175.923C428.628 175.293 428.508 174.673 428.368 174.083C428.298 174.043 428.238 174.013 428.178 173.983C427.788 173.963 427.378 173.893 426.968 173.783C426.258 173.583 425.508 173.253 424.748 172.793C424.408 169.613 424.778 166.603 425.768 164.083C425.808 163.973 425.848 163.863 425.898 163.763C427.058 160.993 428.988 158.873 431.538 157.863C432.728 161.663 433.218 165.193 432.978 167.983C434.478 167.953 436.078 167.813 437.768 167.513C440.268 167.073 442.458 166.333 442.718 166.883H442.708Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_90771_36502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432.149 157.402L434.999 159.302L424.919 174.392L419.719 163.162L432.149 157.402Z",
    fill: "#858F9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.998 159.301L435.138 159.391L424.998 174.561L424.918 174.391L434.998 159.301Z",
    fill: "#858F9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.14 159.391L435.27 159.481L425.08 174.731L425 174.561L435.14 159.391Z",
    fill: "#848E9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.268 159.48L435.408 159.57L425.158 174.91L425.078 174.73L435.268 159.48Z",
    fill: "#838D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.41 159.574L435.54 159.664L425.24 175.084L425.16 174.914L435.41 159.574Z",
    fill: "#828B9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.538 159.664L435.678 159.754L425.318 175.254L425.238 175.084L435.538 159.664Z",
    fill: "#808A99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.68 159.754L435.81 159.844L425.4 175.424L425.32 175.254L435.68 159.754Z",
    fill: "#7F8998"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.808 159.844L435.948 159.934L425.478 175.604L425.398 175.424L435.808 159.844Z",
    fill: "#7E8896"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.95 159.934L436.08 160.024L425.56 175.774L425.48 175.604L435.95 159.934Z",
    fill: "#7D8795"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.079 160.023L436.219 160.113L425.639 175.943L425.559 175.773L436.079 160.023Z",
    fill: "#7C8594"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.221 160.113L436.351 160.203L425.721 176.123L425.641 175.943L436.221 160.113Z",
    fill: "#7B8493"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.349 160.203L436.489 160.293L425.799 176.293L425.719 176.123L436.349 160.203Z",
    fill: "#798391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.487 160.293L436.617 160.383L425.877 176.463L425.797 176.293L436.487 160.293Z",
    fill: "#788290"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.619 160.383L436.759 160.473L425.959 176.633L425.879 176.463L436.619 160.383Z",
    fill: "#77818F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.757 160.473L436.897 160.563L426.037 176.813L425.957 176.633L436.757 160.473Z",
    fill: "#767F8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.899 160.562L437.029 160.652L426.119 176.982L426.039 176.812L436.899 160.562Z",
    fill: "#757E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.027 160.652L437.167 160.742L426.197 177.152L426.117 176.982L437.027 160.652Z",
    fill: "#747D8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.169 160.742L437.299 160.832L426.279 177.332L426.199 177.152L437.169 160.742Z",
    fill: "#737C8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.297 160.832L437.437 160.922L426.367 177.502L426.277 177.332L437.297 160.832Z",
    fill: "#727B89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.437 160.922L437.567 161.012L426.447 177.672L426.367 177.502L437.437 160.922Z",
    fill: "#707A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.569 161.012L437.709 161.102L426.529 177.842L426.449 177.672L437.569 161.012Z",
    fill: "#6F7886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.707 161.102L437.837 161.202L426.607 178.022L426.527 177.842L437.707 161.102Z",
    fill: "#6E7785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.839 161.203L437.979 161.293L426.689 178.193L426.609 178.023L437.839 161.203Z",
    fill: "#6D7684"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.978 161.293L438.107 161.383L426.767 178.363L426.688 178.193L437.978 161.293Z",
    fill: "#6C7583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.11 161.383L438.25 161.473L426.85 178.543L426.77 178.363L438.11 161.383Z",
    fill: "#6B7481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.248 161.473L438.378 161.563L426.928 178.713L426.848 178.543L438.248 161.473Z",
    fill: "#6A7380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.38 161.562L438.52 161.652L427.01 178.883L426.93 178.713L438.38 161.562Z",
    fill: "#69717F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.518 161.652L438.648 161.742L427.088 179.062L427.008 178.882L438.518 161.652Z",
    fill: "#68707E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.65 161.742L438.79 161.832L427.17 179.232L427.09 179.062L438.65 161.742Z",
    fill: "#666F7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.788 161.832L438.928 161.922L427.248 179.402L427.168 179.232L438.788 161.832Z",
    fill: "#656E7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.93 161.922L439.06 162.012L427.33 179.572L427.25 179.402L438.93 161.922Z",
    fill: "#646D7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.058 162.012L439.198 162.102L427.408 179.752L427.328 179.572L439.058 162.012Z",
    fill: "#636C79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.2 162.102L439.33 162.192L427.49 179.922L427.41 179.752L439.2 162.102Z",
    fill: "#626B78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.328 162.191L439.468 162.281L427.568 180.091L427.488 179.921L439.328 162.191Z",
    fill: "#616A76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.47 162.281L439.6 162.371L427.65 180.271L427.57 180.091L439.47 162.281Z",
    fill: "#606875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.598 162.371L439.738 162.461L427.728 180.441L427.648 180.271L439.598 162.371Z",
    fill: "#5F6774"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.74 162.461L439.87 162.551L427.81 180.611L427.73 180.441L439.74 162.461Z",
    fill: "#5E6673"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.869 162.551L440.009 162.641L427.889 180.781L427.809 180.611L439.869 162.551Z",
    fill: "#5D6572"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.011 162.641L440.141 162.731L427.971 180.961L427.891 180.781L440.011 162.641Z",
    fill: "#5C6471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.139 162.73L440.279 162.82L428.049 181.13L427.969 180.96L440.139 162.73Z",
    fill: "#5B636F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.277 162.824L440.407 162.914L428.127 181.304L428.047 181.134L440.277 162.824Z",
    fill: "#59626E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.409 162.914L440.549 163.004L428.209 181.484L428.129 181.304L440.409 162.914Z",
    fill: "#58616D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.547 163.004L440.677 163.094L428.287 181.654L428.207 181.484L440.547 163.004Z",
    fill: "#575F6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.679 163.094L440.819 163.184L428.369 181.824L428.289 181.654L440.679 163.094Z",
    fill: "#565E6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.817 163.184L440.947 163.274L428.447 181.994L428.367 181.824L440.817 163.184Z",
    fill: "#555D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.949 163.273L441.089 163.363L428.529 182.173L428.449 181.993L440.949 163.273Z",
    fill: "#545C68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.087 163.363L441.097 163.373L441.177 163.533L428.607 182.343L428.527 182.173L441.087 163.363Z",
    fill: "#535B67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.259 163.701L428.689 182.511L428.609 182.341L441.179 163.531L441.259 163.701Z",
    fill: "#525A66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.337 163.873L428.767 182.693L428.688 182.513L441.258 163.703L441.337 163.873Z",
    fill: "#515965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.42 164.051L428.85 182.861L428.77 182.691L441.34 163.871L441.42 164.051Z",
    fill: "#505864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.498 164.221L428.928 183.031L428.848 182.861L441.418 164.051L441.498 164.221Z",
    fill: "#4F5763"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.58 164.393L429.01 183.213L428.93 183.033L441.5 164.223L441.58 164.393Z",
    fill: "#4E5662"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.658 164.571L429.088 183.381L429.008 183.211L441.578 164.391L441.658 164.571Z",
    fill: "#4D5560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.74 164.744L429.17 183.554L429.09 183.384L441.66 164.574L441.74 164.744Z",
    fill: "#4C545F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.818 164.912L429.248 183.722L429.168 183.552L441.738 164.742L441.818 164.912Z",
    fill: "#4B535E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.9 165.084L429.33 183.904L429.25 183.724L441.82 164.914L441.9 165.084Z",
    fill: "#4A515D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.978 165.262L429.518 183.912L429.368 183.982L429.328 183.902L441.898 165.082L441.978 165.262Z",
    fill: "#49505C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.06 165.432L429.81 183.772L429.52 183.912L441.98 165.262L442.06 165.432Z",
    fill: "#484F5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.139 165.604L430.089 183.644L429.809 183.774L442.059 165.434L442.139 165.604Z",
    fill: "#474E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.22 165.782L430.37 183.512L430.09 183.642L442.14 165.602L442.22 165.782Z",
    fill: "#464D59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.297 165.951L430.657 183.381L430.367 183.511L442.217 165.781L442.297 165.951Z",
    fill: "#454C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.38 166.123L430.94 183.253L430.66 183.383L442.3 165.953L442.38 166.123Z",
    fill: "#444B57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.457 166.301L431.217 183.121L430.938 183.251L442.378 166.121L442.457 166.301Z",
    fill: "#434A55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.539 166.471L431.509 182.981L431.219 183.121L442.459 166.301L442.539 166.471Z",
    fill: "#424954"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.618 166.643L431.788 182.853L431.508 182.983L442.538 166.473L442.618 166.643Z",
    fill: "#414853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.699 166.811L432.069 182.721L431.789 182.851L442.619 166.641L442.699 166.811Z",
    fill: "#404752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.78 166.993L432.36 182.592L432.07 182.723L442.7 166.812L442.78 166.993Z",
    fill: "#3F4651"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.859 167.162L432.639 182.462L432.359 182.592L442.779 166.992L442.859 167.162Z",
    fill: "#3E4550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.941 167.334L432.921 182.334L432.641 182.464L442.861 167.164L442.941 167.334Z",
    fill: "#3D444F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.018 167.512L433.208 182.202L432.918 182.332L442.938 167.332L443.018 167.512Z",
    fill: "#3C434E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.097 167.682L433.487 182.062L433.207 182.202L443.017 167.512L443.097 167.682Z",
    fill: "#3B424D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.178 167.854L433.778 181.934L433.488 182.064L443.098 167.684L443.178 167.854Z",
    fill: "#3A414C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.257 168.022L434.057 181.802L433.777 181.932L443.177 167.852L443.257 168.022Z",
    fill: "#39404B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.339 168.203L434.339 181.673L434.059 181.803L443.259 168.023L443.339 168.203Z",
    fill: "#383F4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.42 168.373L434.63 181.543L434.34 181.673L443.34 168.203L443.42 168.373Z",
    fill: "#373E49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.499 168.541L434.909 181.411L434.629 181.541L443.419 168.371L443.499 168.541Z",
    fill: "#363D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.58 168.723L435.19 181.283L434.91 181.413L443.5 168.543L443.58 168.723Z",
    fill: "#353C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.658 168.893L435.478 181.143L435.188 181.283L443.577 168.723L443.658 168.893Z",
    fill: "#343B46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.74 169.061L435.76 181.011L435.48 181.141L443.66 168.891L443.74 169.061Z",
    fill: "#333A45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.818 169.232L436.038 180.883L435.758 181.012L443.738 169.062L443.818 169.232Z",
    fill: "#333944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.899 169.41L436.329 180.75L436.039 180.88L443.819 169.23L443.899 169.41Z",
    fill: "#323843"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.978 169.584L436.608 180.624L436.328 180.754L443.898 169.414L443.978 169.584Z",
    fill: "#313742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.059 169.752L436.889 180.492L436.609 180.622L443.979 169.582L444.059 169.752Z",
    fill: "#303641"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.141 169.934L437.181 180.354L436.891 180.494L444.061 169.754L444.141 169.934Z",
    fill: "#2F3540"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.22 170.104L437.46 180.224L437.18 180.354L444.14 169.934L444.22 170.104Z",
    fill: "#2E343F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.297 170.272L437.737 180.092L437.457 180.222L444.217 170.102L444.297 170.272Z",
    fill: "#2D343E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.378 170.453L438.028 179.963L437.738 180.093L444.298 170.273L444.378 170.453Z",
    fill: "#2C333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.457 170.623L438.307 179.833L438.027 179.963L444.377 170.453L444.457 170.623Z",
    fill: "#2B323C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.539 170.791L438.599 179.701L438.309 179.831L444.459 170.621L444.539 170.791Z",
    fill: "#2A313B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.618 170.963L438.878 179.573L438.598 179.703L444.538 170.793L444.618 170.963Z",
    fill: "#2A303A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.699 171.141L439.159 179.431L438.879 179.571L444.619 170.961L444.699 171.141Z",
    fill: "#292F39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.79 171.311L439.45 179.301L439.16 179.431L444.7 171.141L444.79 171.311Z",
    fill: "#282E38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.869 171.482L439.729 179.173L439.449 179.303L444.789 171.312L444.869 171.482Z",
    fill: "#272D37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.95 171.66L440.01 179.04L439.73 179.17L444.87 171.48L444.95 171.66Z",
    fill: "#262C36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.028 171.834L440.298 178.914L440.008 179.044L444.948 171.664L445.028 171.834Z",
    fill: "#252B35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.107 172.002L440.577 178.782L440.297 178.912L445.027 171.832L445.107 172.002Z",
    fill: "#242A34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.188 172.174L440.858 178.654L440.578 178.784L445.108 172.004L445.188 172.174Z",
    fill: "#232A33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.269 172.352L441.149 178.512L440.859 178.652L445.189 172.172L445.269 172.352Z",
    fill: "#232932"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.348 172.522L441.428 178.382L441.148 178.512L445.268 172.352L445.348 172.522Z",
    fill: "#222831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.43 172.693L441.71 178.253L441.43 178.383L445.35 172.523L445.43 172.693Z",
    fill: "#212730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.507 172.871L441.997 178.121L441.707 178.251L445.427 172.691L445.507 172.871Z",
    fill: "#20262F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.59 173.041L442.28 177.991L442 178.121L445.51 172.871L445.59 173.041Z",
    fill: "#1F252F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.667 173.213L442.557 177.863L442.277 177.993L445.587 173.043L445.667 173.213Z",
    fill: "#1F242E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.749 173.381L442.849 177.721L442.559 177.861L445.669 173.211L445.749 173.381Z",
    fill: "#1E242D"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.24
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M416.401 138.431C416.711 139.621 416.701 141.071 416.191 142.231C415.421 144.001 413.991 143.971 412.831 145.401C409.671 149.301 414.271 157.141 413.631 157.801C409.961 148.851 410.001 140.521 413.901 138.711C414.651 138.361 415.491 138.281 416.401 138.431Z",
    fill: "#090E16"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.461 147.36C421.787 147.36 422.051 147.096 422.051 146.77C422.051 146.444 421.787 146.18 421.461 146.18C421.135 146.18 420.871 146.444 420.871 146.77C420.871 147.096 421.135 147.36 421.461 147.36Z",
    fill: "#090E16"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419.77 152.172C420.51 152.172 421.11 151.572 421.11 150.832C421.11 150.092 420.51 149.492 419.77 149.492C419.03 149.492 418.43 150.092 418.43 150.832C418.43 151.572 419.03 152.172 419.77 152.172Z",
    fill: "#090E16"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.079 152.552C424.327 152.552 424.529 152.351 424.529 152.102C424.529 151.854 424.327 151.652 424.079 151.652C423.83 151.652 423.629 151.854 423.629 152.102C423.629 152.351 423.83 152.552 424.079 152.552Z",
    fill: "#090E16"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.391 156.723C423.49 156.723 423.571 156.643 423.571 156.543C423.571 156.444 423.49 156.363 423.391 156.363C423.292 156.363 423.211 156.444 423.211 156.543C423.211 156.643 423.292 156.723 423.391 156.723Z",
    fill: "#090E16"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.868 162.971C421.078 162.971 421.248 162.801 421.248 162.591C421.248 162.381 421.078 162.211 420.868 162.211C420.658 162.211 420.488 162.381 420.488 162.591C420.488 162.801 420.658 162.971 420.868 162.971Z",
    fill: "#090E16"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.3 166.03C428.156 166.03 428.85 165.336 428.85 164.48C428.85 163.624 428.156 162.93 427.3 162.93C426.444 162.93 425.75 163.624 425.75 164.48C425.75 165.336 426.444 166.03 427.3 166.03Z",
    fill: "#090E16"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask15_90771_36502",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 411,
    y: 138,
    width: 32,
    height: 33
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M442.75 166.861C442.49 166.311 440.3 167.041 437.8 167.491C436.12 167.791 434.52 167.931 433.01 167.961C433.25 165.171 432.76 161.641 431.57 157.841C431.04 156.151 430.37 154.411 429.55 152.661C425.88 144.761 420.51 139.131 416.4 138.431C415.5 138.281 414.65 138.361 413.9 138.711C413.09 139.081 412.45 139.741 411.98 140.621C422.82 145.851 428.16 158.781 429.76 170.131C433.55 168.571 437.25 168.491 440.34 169.741C441.88 168.511 442.96 167.311 442.74 166.861H442.75Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_90771_36502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.774 139.713L411.602 139.793L428.123 175.418L428.296 175.338L411.774 139.713Z",
    fill: "#858F9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.884 139.664L411.766 139.719L428.287 175.344L428.405 175.289L411.884 139.664Z",
    fill: "#858F9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.001 139.605L411.883 139.66L428.404 175.286L428.522 175.231L412.001 139.605Z",
    fill: "#87909F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.118 139.559L412 139.613L428.522 175.239L428.64 175.184L412.118 139.559Z",
    fill: "#8892A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.235 139.5L412.117 139.555L428.639 175.18L428.757 175.125L412.235 139.5Z",
    fill: "#8A93A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.352 139.445L412.234 139.5L428.756 175.125L428.874 175.071L412.352 139.445Z",
    fill: "#8B95A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.477 139.391L412.359 139.445L428.881 175.071L428.999 175.016L412.477 139.391Z",
    fill: "#8D96A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.594 139.336L412.477 139.391L428.998 175.016L429.116 174.961L412.594 139.336Z",
    fill: "#8E97A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.708 139.285L412.59 139.34L429.111 174.965L429.229 174.911L412.708 139.285Z",
    fill: "#9099A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.825 139.227L412.707 139.281L429.229 174.907L429.347 174.852L412.825 139.227Z",
    fill: "#919AA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.938 139.172L412.82 139.227L429.342 174.852L429.46 174.797L412.938 139.172Z",
    fill: "#939BA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.067 139.117L412.949 139.172L429.471 174.797L429.589 174.743L413.067 139.117Z",
    fill: "#949DAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.173 139.066L413.055 139.121L429.576 174.746L429.694 174.692L413.173 139.066Z",
    fill: "#969EAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.302 139.012L413.184 139.066L429.705 174.692L429.823 174.637L413.302 139.012Z",
    fill: "#97A0AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.415 138.945L413.297 139L429.819 174.625L429.936 174.571L413.415 138.945Z",
    fill: "#98A1AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.532 138.898L413.414 138.953L429.936 174.579L430.054 174.524L413.532 138.898Z",
    fill: "#9AA2AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.653 138.836L413.535 138.891L430.057 174.516L430.175 174.461L413.653 138.836Z",
    fill: "#9BA4B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.762 138.793L413.645 138.848L430.166 174.473L430.284 174.418L413.762 138.793Z",
    fill: "#9DA5B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.891 138.738L413.773 138.793L430.295 174.418L430.413 174.364L413.891 138.738Z",
    fill: "#9EA6B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.005 138.684L413.887 138.738L430.408 174.364L430.526 174.309L414.005 138.684Z",
    fill: "#A0A7B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.122 138.625L414.004 138.68L430.526 174.305L430.643 174.25L414.122 138.625Z",
    fill: "#A1A9B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.239 138.574L414.121 138.629L430.643 174.254L430.761 174.2L414.239 138.574Z",
    fill: "#A2AAB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.356 138.52L414.238 138.574L430.76 174.2L430.878 174.145L414.356 138.52Z",
    fill: "#A4ABB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.47 138.453L414.352 138.508L430.873 174.133L430.991 174.079L414.47 138.453Z",
    fill: "#A5ADB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.598 138.41L414.48 138.465L431.002 174.09L431.12 174.036L414.598 138.41Z",
    fill: "#A7AEB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.7 138.348L414.582 138.402L431.104 174.028L431.222 173.973L414.7 138.348Z",
    fill: "#A8AFBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.829 138.301L414.711 138.355L431.233 173.981L431.351 173.926L414.829 138.301Z",
    fill: "#A9B0BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.942 138.238L414.824 138.293L431.346 173.918L431.464 173.864L414.942 138.238Z",
    fill: "#ABB2BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.059 138.191L414.941 138.246L431.463 173.871L431.581 173.817L415.059 138.191Z",
    fill: "#ACB3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.184 138.125L415.066 138.18L431.588 173.805L431.706 173.75L415.184 138.125Z",
    fill: "#ADB4BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.294 138.086L415.176 138.141L431.697 173.766L431.815 173.711L415.294 138.086Z",
    fill: "#AFB5BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.423 138.031L415.305 138.086L431.826 173.711L431.944 173.657L415.423 138.031Z",
    fill: "#B0B7C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.536 137.973L415.418 138.027L431.94 173.653L432.058 173.598L415.536 137.973Z",
    fill: "#B1B8C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.653 137.918L415.535 137.973L432.057 173.598L432.175 173.543L415.653 137.918Z",
    fill: "#B3B9C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.766 137.859L415.648 137.914L432.17 173.539L432.288 173.485L415.766 137.859Z",
    fill: "#B4BAC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.884 137.812L415.766 137.867L432.287 173.493L432.405 173.438L415.884 137.812Z",
    fill: "#B5BBC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.009 137.746L415.891 137.801L432.412 173.426L432.53 173.371L416.009 137.746Z",
    fill: "#B7BDC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.126 137.703L416.008 137.758L432.529 173.383L432.647 173.329L416.126 137.703Z",
    fill: "#B8BEC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.239 137.637L416.121 137.691L432.643 173.317L432.761 173.262L416.239 137.637Z",
    fill: "#B9BFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.36 137.594L416.242 137.648L432.764 173.274L432.882 173.219L416.36 137.594Z",
    fill: "#BAC0C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.473 137.531L416.355 137.586L432.877 173.211L432.995 173.157L416.473 137.531Z",
    fill: "#BCC1C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.598 137.484L416.48 137.539L433.002 173.164L433.12 173.11L416.598 137.484Z",
    fill: "#BDC2CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.72 137.43L416.602 137.484L433.123 173.11L433.241 173.055L416.72 137.43Z",
    fill: "#BEC3CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.821 137.367L416.703 137.422L433.225 173.047L433.343 172.993L416.821 137.367Z",
    fill: "#BFC5CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.95 137.32L416.832 137.375L433.354 173L433.472 172.946L416.95 137.32Z",
    fill: "#C1C6CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.063 137.258L416.945 137.312L433.467 172.938L433.585 172.883L417.063 137.258Z",
    fill: "#C2C7CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.18 137.211L417.062 137.266L433.584 172.891L433.702 172.836L417.18 137.211Z",
    fill: "#C3C8CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.298 137.148L417.18 137.203L433.701 172.829L433.819 172.774L417.298 137.148Z",
    fill: "#C4C9D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.415 137.105L417.297 137.16L433.819 172.786L433.936 172.731L417.415 137.105Z",
    fill: "#C5CAD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.536 137.039L417.418 137.094L433.94 172.719L434.058 172.664L417.536 137.039Z",
    fill: "#C7CBD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.657 136.992L417.539 137.047L434.061 172.672L434.179 172.618L417.657 136.992Z",
    fill: "#C8CCD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.77 136.93L417.652 136.984L434.174 172.61L434.292 172.555L417.77 136.93Z",
    fill: "#C9CDD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.887 136.875L417.77 136.93L434.291 172.555L434.409 172.5L417.887 136.875Z",
    fill: "#CACED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.001 136.82L417.883 136.875L434.404 172.5L434.522 172.446L418.001 136.82Z",
    fill: "#CBD0D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.13 136.766L418.012 136.82L434.533 172.446L434.651 172.391L418.13 136.766Z",
    fill: "#CCD1D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.247 136.719L418.129 136.773L434.651 172.399L434.768 172.344L418.247 136.719Z",
    fill: "#CED2D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.352 136.66L418.234 136.715L434.756 172.34L434.874 172.286L418.352 136.66Z",
    fill: "#CFD3D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.481 136.613L418.363 136.668L434.885 172.293L435.003 172.239L418.481 136.613Z",
    fill: "#D0D4D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.594 136.551L418.477 136.605L434.998 172.231L435.116 172.176L418.594 136.551Z",
    fill: "#D1D5DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.72 136.504L418.602 136.559L435.123 172.184L435.241 172.129L418.72 136.504Z",
    fill: "#D2D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.833 136.437L418.715 136.492L435.236 172.118L435.354 172.063L418.833 136.437Z",
    fill: "#D3D7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.942 136.387L418.824 136.441L435.346 172.067L435.464 172.012L418.942 136.387Z",
    fill: "#D4D8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.067 136.332L418.949 136.387L435.471 172.012L435.589 171.957L419.067 136.332Z",
    fill: "#D5D9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.184 136.277L419.066 136.332L435.588 171.957L435.706 171.903L419.184 136.277Z",
    fill: "#D6DADF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.298 136.223L419.18 136.277L435.701 171.903L435.819 171.848L419.298 136.223Z",
    fill: "#D7DBDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.419 136.168L419.301 136.223L435.822 171.848L435.94 171.793L419.419 136.168Z",
    fill: "#D8DCE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.532 136.113L419.414 136.168L435.936 171.793L436.054 171.739L419.532 136.113Z",
    fill: "#D9DCE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.657 136.059L419.539 136.113L436.061 171.739L436.179 171.684L419.657 136.059Z",
    fill: "#DADDE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.778 136.012L419.66 136.066L436.182 171.692L436.3 171.637L419.778 136.012Z",
    fill: "#DBDEE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.88 135.953L419.762 136.008L436.283 171.633L436.401 171.579L419.88 135.953Z",
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.009 135.895L419.891 135.949L436.412 171.575L436.53 171.52L420.009 135.895Z",
    fill: "#DDE0E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.122 135.84L420.004 135.895L436.526 171.52L436.643 171.465L420.122 135.84Z",
    fill: "#DEE1E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.251 135.785L420.133 135.84L436.654 171.465L436.772 171.411L420.251 135.785Z",
    fill: "#DFE2E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.364 135.73L420.246 135.785L436.768 171.411L436.886 171.356L420.364 135.73Z",
    fill: "#E0E3E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.473 135.68L420.355 135.734L436.877 171.36L436.995 171.305L420.473 135.68Z",
    fill: "#E1E4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.594 135.625L420.477 135.68L436.998 171.305L437.116 171.25L420.594 135.625Z",
    fill: "#E2E5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.716 135.566L420.598 135.621L437.119 171.246L437.237 171.192L420.716 135.566Z",
    fill: "#E3E5E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.837 135.512L420.719 135.566L437.24 171.192L437.358 171.137L420.837 135.512Z",
    fill: "#E4E6EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.946 135.461L420.828 135.516L437.35 171.141L437.468 171.086L420.946 135.461Z",
    fill: "#E5E7EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.059 135.395L420.941 135.449L437.463 171.075L437.581 171.02L421.059 135.395Z",
    fill: "#E6E8EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.188 135.352L421.07 135.406L437.592 171.032L437.71 170.977L421.188 135.352Z",
    fill: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.305 135.293L421.188 135.348L437.709 170.973L437.827 170.918L421.305 135.293Z",
    fill: "#E8EAEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.43 135.238L421.312 135.293L437.834 170.918L437.952 170.864L421.43 135.238Z",
    fill: "#E9EAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.54 135.188L421.422 135.242L437.944 170.868L438.061 170.813L421.54 135.188Z",
    fill: "#E9EBEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.653 135.133L421.535 135.188L438.057 170.813L438.175 170.758L421.653 135.133Z",
    fill: "#EAECEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.778 135.078L421.66 135.133L438.182 170.758L438.3 170.703L421.778 135.078Z",
    fill: "#EBEDEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.891 135.023L421.773 135.078L438.295 170.704L438.413 170.649L421.891 135.023Z",
    fill: "#ECEDF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.001 134.973L421.883 135.027L438.404 170.653L438.522 170.598L422.001 134.973Z",
    fill: "#EDEEF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.126 134.914L422.008 134.969L438.529 170.594L438.647 170.539L422.126 134.914Z",
    fill: "#EDEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.243 134.859L422.125 134.914L438.647 170.539L438.765 170.485L422.243 134.859Z",
    fill: "#EEF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.368 134.797L422.25 134.852L438.772 170.477L438.89 170.422L422.368 134.797Z",
    fill: "#EFF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.477 134.754L422.359 134.809L438.881 170.434L438.999 170.379L422.477 134.754Z",
    fill: "#F0F1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.591 134.688L422.473 134.742L438.994 170.368L439.112 170.313L422.591 134.688Z",
    fill: "#F1F2F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.716 134.645L422.598 134.699L439.119 170.325L439.237 170.27L422.716 134.645Z",
    fill: "#F1F2F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.837 134.586L422.719 134.641L439.24 170.266L439.358 170.211L422.837 134.586Z",
    fill: "#F2F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.958 134.531L422.84 134.586L439.361 170.211L439.479 170.157L422.958 134.531Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.067 134.48L422.949 134.535L439.471 170.161L439.589 170.106L423.067 134.48Z",
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.18 134.426L423.062 134.48L439.584 170.106L439.702 170.051L423.18 134.426Z",
    fill: "#F4F5F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.309 134.371L423.191 134.426L439.713 170.051L439.831 169.996L423.309 134.371Z",
    fill: "#F5F6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.423 134.305L423.305 134.359L439.826 169.985L439.944 169.93L423.423 134.305Z",
    fill: "#F5F6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.54 134.262L423.422 134.316L439.944 169.942L440.061 169.887L423.54 134.262Z",
    fill: "#F6F7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.653 134.199L423.535 134.254L440.057 169.879L440.175 169.825L423.653 134.199Z",
    fill: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.774 134.152L423.656 134.207L440.178 169.832L440.296 169.778L423.774 134.152Z",
    fill: "#F7F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.895 134.086L423.777 134.141L440.299 169.766L440.417 169.711L423.895 134.086Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.012 134.043L423.895 134.098L440.416 169.723L440.534 169.668L424.012 134.043Z",
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.122 133.988L424.004 134.043L440.526 169.668L440.643 169.614L424.122 133.988Z",
    fill: "#F9F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.247 133.934L424.129 133.988L440.651 169.614L440.768 169.559L424.247 133.934Z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.364 133.879L424.246 133.934L440.768 169.559L440.886 169.504L424.364 133.879Z",
    fill: "#FAFAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.489 133.812L424.371 133.867L440.893 169.493L441.011 169.438L424.489 133.812Z",
    fill: "#FAFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.598 133.773L424.48 133.828L441.002 169.454L441.12 169.399L424.598 133.773Z",
    fill: "#FBFBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.712 133.707L424.594 133.762L441.115 169.387L441.233 169.332L424.712 133.707Z",
    fill: "#FBFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.837 133.66L424.719 133.715L441.24 169.34L441.358 169.286L424.837 133.66Z",
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.95 133.598L424.832 133.652L441.354 169.278L441.472 169.223L424.95 133.598Z",
    fill: "#FCFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.071 133.555L424.953 133.609L441.475 169.235L441.593 169.18L425.071 133.555Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.184 133.492L425.066 133.547L441.588 169.172L441.706 169.118L425.184 133.492Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.302 133.445L425.184 133.5L441.705 169.125L441.823 169.071L425.302 133.445Z",
    fill: "#FDFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.427 133.379L425.309 133.434L441.83 169.059L441.948 169.004L425.427 133.379Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.544 133.324L425.426 133.379L441.947 169.004L442.065 168.95L425.544 133.324Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.661 133.281L425.543 133.336L442.065 168.961L442.183 168.907L425.661 133.281Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.774 133.219L425.656 133.273L442.178 168.899L442.296 168.844L425.774 133.219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.895 133.172L425.777 133.227L442.299 168.852L442.417 168.797L425.895 133.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.016 133.105L425.898 133.16L442.42 168.786L442.538 168.731L426.016 133.105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.126 133.066L426.008 133.121L442.529 168.746L442.647 168.692L426.126 133.066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.913 132.701L426.133 133.062L442.654 168.688L443.435 168.326L426.913 132.701Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.24
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M419.409 142.715L418.369 143.195L417.889 142.155C417.829 142.035 417.689 141.985 417.569 142.035C417.449 142.085 417.399 142.235 417.449 142.355L417.929 143.395L416.889 143.875C416.769 143.935 416.719 144.075 416.769 144.195C416.819 144.315 416.969 144.365 417.089 144.315L418.129 143.835L418.609 144.875C418.669 144.995 418.809 145.045 418.929 144.995C419.049 144.945 419.099 144.795 419.049 144.675L418.569 143.635L419.609 143.155C419.729 143.095 419.779 142.955 419.729 142.835C419.679 142.715 419.529 142.665 419.409 142.715Z",
    fill: "#090E16"
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M419.55 142.363L418.51 142.843L418.03 141.803C417.97 141.683 417.83 141.633 417.71 141.683C417.59 141.733 417.54 141.883 417.59 142.003L418.07 143.043L417.03 143.523C416.91 143.583 416.86 143.723 416.91 143.843C416.96 143.963 417.11 144.013 417.23 143.963L418.27 143.483L418.75 144.523C418.81 144.643 418.95 144.693 419.07 144.643C419.19 144.593 419.24 144.443 419.19 144.323L418.71 143.283L419.75 142.803C419.87 142.743 419.92 142.603 419.87 142.483C419.82 142.363 419.67 142.313 419.55 142.363Z",
    fill: "#090E16"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_90771_36502",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(404.781 184.35) rotate(-90) scale(29.71 29.71)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#707274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#737577",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#AFB0B1",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#DADBDB",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F5F5F5",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_90771_36502",
    x1: 373.783,
    y1: 252.138,
    x2: 374.173,
    y2: 183.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19124C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#807C9C",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#DCDBE3",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_90771_36502",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(332.829 226.073) rotate(120.97) scale(10.89 32.67)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#707274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_90771_36502",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(370.188 240.409) scale(24.74 24.74)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#707274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#737577",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#AFB0B1",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#DADBDB",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F5F5F5",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_90771_36502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 689.66,
    height: 286.54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenguinErrorDark);
export default __webpack_public_path__ + "static/media/PenguinErrorDark.e2064943cf506c2fcd771a561306af6e.svg";
export { ForwardRef as ReactComponent };